'use strict';

var economy = angular.module('gymsystem.economy', []);

economy.directive('showLegalEntity', ['$rootScope', 'server', function($rootScope, server) {
    return {
        restrict: 'E',
        scope: {
            noLeftPadding: '@',
            noTitle: '@'
        },
        template: `
            <div ng-if="haveFetchedLegalEntities"
                 ng-style="{
                     'padding-top': noTitle !== undefined ? '0' : '20px',
                     'padding-bottom': noTitle !== undefined ? '0' : '20px',
                     'padding-left': noLeftPadding !== undefined ? '0' : '8px',
                     'line-height': noTitle !== undefined ? '34px' : 'inherit'
                 }">
                <span ng-if="noTitle === undefined"><b>{{'Legal entity' | translate}}</b>&nbsp;&nbsp;&nbsp;</span>
                {{getLegalEntityName()}}, {{getLegalEntityOrganizationNumber() | formatter:'personalCodeNumber'}}
            </div>
        `,
        link: function(scope) {
            scope.legalEntities = [];

            scope.getLegalEntityName = () =>
                scope.legalEntities.find(e => e.id == $rootScope.selectedSite.legal_entity_id)?.name;

            scope.getLegalEntityOrganizationNumber = () =>
                scope.legalEntities.find(e => e.id == $rootScope.selectedSite.legal_entity_id)?.registration_number;

            server.get('/api/legal_entity/get/all').then(legalEntities => {
                scope.legalEntities = legalEntities;
                scope.haveFetchedLegalEntities = true;
            });
        }
    };
}]);

economy.controller('EconomyTabsetController', ['$scope', function($scope) {
    $scope.tab = {};
    $scope.setTab = function(tab) {
        $scope.tab = {};
        $scope.tab[tab] = true;
    };
}]);

economy.controller('EconomyCtrl', ['$rootScope', '$scope', '$filter', '$modal', '$location', 'paymentMethods', 'confirm', 'server', 'formatter', 'util', 'cashiers', 'pubsub', '$injector', function($rootScope, $scope, $filter, $modal, $location, paymentMethods, confirm, server, formatter, util, cashiers, pubsub, $injector) {
    $scope.bundleTogether = function(payments, useBundleId) {
        var bundles = {};
        var taken = {};
        var uniq = 0;

        let transactionByBundle = {};  // Get transaction by bundle
        for (let p of payments) {
            if (p.transactions?.length) {
                for (let t of p.transactions) {
                    if (t.claim) continue;
                    transactionByBundle[p.invoice_bundle_id] = t.id;
                    if (t.bundle_id) transactionByBundle[t.bundle_id] = t.id;
                }
            }
        };

        const getEntityId = payment => $rootScope.sites.find(x => x.id == payment.site_id)?.legal_entity_id;

        function push(k, payment) {
            if(taken[payment.id]) {return;}
            taken[payment.id] = true;

            // Append legal_entity_id to the key
            k += '_' + getEntityId(payment);

            if(!bundles[k]) {bundles[k]=[];}
            bundles[k].push(payment);
        }

        payments.forEach(function(p) {
            if (useBundleId) {
                if (p.invoice_id) {
                    push('i' + p.invoice_id, p);
                    return;
                }
                if (p.attempts?.length) {
                    for (let a of p.attempts) {
                        if(a.status === 'paid') {p.method = a.method;}

                        let transactionId = a.bundle_id && transactionByBundle[a.bundle_id];
                        if (transactionId) {
                            p.transactionId = transactionId;
                            push('t' + transactionId, p);
                            return;
                        };

                        if(a.status === 'failed' && (a.method === 'xcard' || a.method === 'adyen-card')) continue;
                        if(a.bundle_id) {
                            push('a' + a.bundle_id, p);
                        } else {
                            push('u' + (uniq++), p);
                        }
                        return;
                    }
                }
            }

            if(p.separate_invoice) {
                push('s' + p.id, p);
            } else if(p.method == 'invoice') {
                // payer_id x date x days for invoce
                push('i' + p.payer_id + '_' + p.date.yyyymmdd() + '_' + p.days, p);
            } else {
                // payer_id x date x method
                push('p' + p.payer_id + '_' + p.date.yyyymmdd() + '_' + p.method, p);
            }
        });

        function summ(i, p) {
            return i + Number(p.amount);
        }

        function sumd(i, p) {
            return i + Number(p.discount);
        }

        var result = [];
        for(var bundleId in bundles) {
            var bundle = bundles[bundleId];

            var payment = bundle[0];
            payment.parts = bundle;
            payment.totalamount = _.reduce(bundle, summ, 0);
            payment.totaldiscount = _.reduce(bundle, sumd, 0);
            payment.alreadyPaidAmount = $injector.get('payment').getAlreadyPaid(payment);
            payment.creditedAmount = $injector.get('payment').getCreditedAmount(payment);
            payment.remainingAmountToPay = payment.totalamount - payment.alreadyPaidAmount - payment.creditedAmount;

            result.push(payment);
        }
        return result;
    };

    $scope.getImage = function(p) {
        return $rootScope.smallMemberImage(p.payer);
    };

    $scope.getProductName = function(p) {
        if (p.parts.length == 1) {
            return p.name;
        } else {
            return p.parts.length +  ' ' + $filter('translate')('products');
        }
    };

    $scope.showPayments = function(payment, eventName) {
        $modal.open({
            templateUrl: 'views/paymentlist.html',
            controller: 'PaymentListModalCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                payments: function() {
                    return payment.parts;
                },
                eventName: function() {
                    return eventName;
                },
                invoice: function() {
                    return null;
                }
            }
        });
    };

    $scope.broadcastChangeEvent = function(eventName, payments) {
        $rootScope.$broadcast(eventName, function(payment) {
            var newPayment = payment && _.findWhere(payments, {id: payment.id});
            return newPayment ? newPayment.parts : [];
        });
    };

    $scope.getPaymentMethod = function(payment) {
        var methods = paymentMethods.getAll();
        return _.findWhere(methods, {id: payment.method});
    };

    $scope.getPaymentMethodName = function(payment) {
        var method = $scope.getPaymentMethod(payment);
        if (method) {
            return $filter('translate')(method.name);
        } else if (payment.method == 'multi') {
            return $filter('translate')('Multiple');
        }
    };

    $scope.paymentMarkAsPaid = function(payment, method) {
        var whenPaid = function(result) {
            if (result.success && $scope.onPaymentPaid) {
                $scope.onPaymentPaid(payment);
            }
        };

        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'MarkAsPaidCtrl',
            resolve: {
                options: function() {
                    return {
                        payment: payment,
                        whenPaid: whenPaid,
                        all: true,
                        method: method || payment.method
                    };
                }
            }
        });
    };

    $scope.markBundleAsFailed = function(payments) {
        confirm.show('Are you sure you want to mark the payment as failed?', {ladda: true}).then(function(resolve) {
            var ids = _.pluck(payments, 'id').join(',');
            server.post('/api/payment/markAsFailed', null, {payments: ids}, 'Payment was marked as failed', 'Failed to mark payment as failed').then(resolve);
        });
    };

    $scope.removeAll = function(payment) {
        confirm.show('Are you sure you want to remove the payment?', {ladda: true}).then(function(resolve) {
            var ids = _.pluck(payment.parts, 'id');
            server.post2('/api/payment/remove', {payments: ids }, null, '{0} was removed', 'Failed to remove {0}', 'Payment').then(resolve);
        });
    };

    $scope.getEconomyFilter = function() {
        let customer = $scope.getCustomer ? $scope.getCustomer() : $scope.customer;
        let legal_entity_id = customer ? null : $rootScope.selectedSite.legal_entity_id;
        return {
            customer,
            legal_entity_id
        };
    };

    $scope.countSuffix = function(payments) {
        var total = 0;
        angular.forEach(payments, function(payment) {
            total += payment.totalamount;
        });

        return $filter('translate')(payments.length == 1 ? 'payment' : 'payments') + ', ' + formatter.format('price', total);
    };

    $scope.getExcel = function(config) {

        config.control.exportTo('excel').then(function(blob) {
            util.download($filter('translate')(config.getTitle()) + '.xlsx', null, null, blob);
        });
    };

    function buildCheckoutSearchParams(payment) {
        var search = {};
        var customerId = payment.payer_id || payment.user_id;
        if (customerId) search.customer_id = customerId;
        if (payment.referenceNumber) {
            if (payment.invoice_id) search.invoice_id = payment.invoice_id;
            if (payment.invoiceNumber) search.invoice_number = payment.invoiceNumber;
            if (payment.remainingAmountToPay != null) search.invoice_amount = payment.remainingAmountToPay;
        } else {
            var ids = (payment.parts || []).map(function(p) { return p.id; }).filter(Boolean);
            if (ids.length) search.payment_ids = ids.join(',');
        }
        return search;
    }

    function navigateToCheckout(payment) {
        // Set the legacy in-memory transfer too so the legacy /checkout still
        // works for users who don't have the StaffNext flag on. The new
        // checkout reads $location query params instead, since iframe
        // localStorage is partitioned away from the parent.
        if (payment.referenceNumber) {
            cashiers.transferInvoice(payment);
        } else {
            cashiers.transferPayments(payment.parts);
        }
        $location.path('/checkout').search(buildCheckoutSearchParams(payment));
    }

    $scope.checkoutPayment = function(payment) {
        if ($rootScope.hasModule('MultipleLegalEntities')) {
            var siteId = payment.site_id || (payment.parts && payment.parts[0] && payment.parts[0].site_id);
            if (siteId) {
                var paymentSite = _.findWhere($rootScope.sites, {id: siteId});
                if (paymentSite && paymentSite.legal_entity_id !== $rootScope.selectedSite.legal_entity_id) {
                    var entityName = paymentSite.legal_entity ? paymentSite.legal_entity.name : paymentSite.name;
                    confirm.show(
                        $filter('translate')('PAYMENT_WRONG_ENTITY').format(entityName),
                        {yesButtonText: $filter('translate')('Yes, switch'), noButtonText: $filter('translate')('Stay')}
                    ).then(function() {
                        $rootScope.setSiteOnServer(paymentSite);
                        $rootScope.setSite(paymentSite.id);
                        navigateToCheckout(payment);
                    });
                    return;
                }
            }
        }
        navigateToCheckout(payment);
    };

    $scope.shouldUpdate = function(payments, event) {
        var action = event.action;
        for (var i=0; i < event.data.length; ++i) {
            var payment = event.data[i];
            var found = _.findWhere(payments, {id: payment.id});
            if (found) {
                return true;
            }
            var filter = $scope.getEconomyFilter();
            if (filter.customer) {
                if (payment.payer_id == filter.customer.id) {
                    return true;
                }
            } else {
                if (action == 'add' || action == 'change') {
                    return true;
                }
            }
        }

        return false;
    };

    $scope.sendMailing = function(config) {
        // Economy mailings go to the payer, who may be someone other than the user of the training card.
        // Unlike the user, the payer is not guaranteed to be loaded as a member, and NewMailingCtrl drops
        // the id of anyone it cannot look up, which fails the whole send.
        let payers = _.uniq(_.filter(config.control.getFilteredItems(), item => $rootScope.getMember(item.payer_id)), item => item.payer_id).map(item => ({id: item.payer_id}));
        pubsub.publish('newmailingdata', {
            isNewsOrAdvertising: false,
            sendOption: 'mail',
            receivers: payers,
            options: { 'callCloseOnSuccess': true, 'modalMode': false, noRedirect: true }
        });
        $modal.open({
            templateUrl: 'views/mailingnew.html',
            windowClass: 'huge-modal-window',
            controller: 'NewMailingCtrl'
        })
    };

    $scope.economyConfig = {
        unpaid: {},
        pending: {},
        sent: {},
        giftcard: {},
        debtcollection: {},
        history: {}
    };
    if ($scope.getEconomyConfig) {
        $scope.economyConfig = $scope.getEconomyConfig();
    }
}]);

economy.controller('MarkAsPaidCtrl', ['$rootScope', '$scope', '$controller', 'options', 'server', 'paymentMethods', 'formatter', 'confirm', 'util', function($rootScope, $scope, $controller, options, server, paymentMethods, formatter, confirm, util) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = 'Mark as paid';
    $scope.loadingStatus = {};

    var isBundle = ['sent', 'failed', 'credited'].includes(options.payment.status);
    var giftcard;
    var codeError;

    var whenPaid = function(result) {
        if (result.success) {
            $scope.$close();
        } else {
            $scope.loadingStatus.loading = false;
        }

        if (options.whenPaid) {
            options.whenPaid(result);
        }
    };

    const args = {legal_entity_id: $rootScope.selectedSite.legal_entity_id };
    server.get('/api/economy/accounting/next', args).then(function(result) {
        if (result.last) {
            $scope.lastAccountingDate = Date.newFull(result.last);
        }
    });

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        var payment = options.payment;
        var date = _.findWhere($scope.fields, {name: 'date'}).value.yyyymmdd();
        var method = _.findWhere($scope.fields, {name: 'method'}).value;
        var amountField = _.findWhere($scope.fields, {name: 'amount'});
        var amount = amountField && amountField.value;
        var amountValue = util.parseDecimal(amount);
        var code = _.findWhere($scope.fields, {name: 'code'}).value;
        var totalAmount = payment.totalamount;

        var doSubmit = function() {
            if (isBundle) {
                // Find the last bundle with an invoice
                var bundle_id;
                let attempts = payment.attempts.filter(a => a.status != 'credited');
                for (let a of attempts) {
                    if (!bundle_id || a.invoice_id) bundle_id = a.bundle_id;
                }
                server.post('/api/payment/markBundleAsPaid', null, {bundle: bundle_id, date: date, method: method.id, amount: amount, code: code}, 'Payment was marked as paid', 'Failed to mark payment as paid').then(whenPaid);
            } else {
                var ids;
                if (options.all) {
                    ids = _.pluck(payment.parts, 'id').join(',');
                } else {
                    ids = payment.id;
                }
                server.post('/api/payment/markAsPaid', null, {payments: ids, date: date, method: method.id, code: code}, 'Payment was marked as paid', 'Failed to mark payment as paid').then(whenPaid);
            }
        };

        var amountToBig = !isNaN(amountValue) && amountValue > totalAmount;
        var amountToBigWarning = function() {
            confirm.show('You have entered more than the required amount. Are you sure you want to continue?').then(function() {
                doSubmit();
            }).catch(function() {
                $scope.loadingStatus.loading = false;
            });
        };

        if ($scope.lastAccountingDate && $scope.lastAccountingDate >= Date.newFull(date) && !method.external) {
            confirm.show('MARKASPAID_ACCOUNTING_WARNING').then(function() {
                if (amountToBig) {
                    amountToBigWarning();
                } else {
                    doSubmit();
                }
            }).catch(function() {
                $scope.loadingStatus.loading = false;
            });
        } else if (amountToBig) {
            amountToBigWarning();
        } else {
            doSubmit();
        }
    };

    $scope.alertNotEnoughMoney = function() {
        if($scope.loadingStatus.loading) {return;}
        var method = _.findWhere($scope.fields, {name: 'method'}).value;
        if(!method || method.id != 'valuecard') {return;}
        var amount = util.parseDecimal(_.findWhere($scope.fields, {name: 'amount'}).value);
        if (isNaN(amount)) { return; }
        return Number(options.payment.payer.getValueCardAmountForSelectedLegalEntity()) < amount;
    };

    var isTooEarlyDate = function() {
        if (options.method == 'invoice') {
            var paymentDate = _.findWhere($scope.fields, {name: 'date'}).value;
            var sentDate = _.last(options.payment.attempts).created.clearTime();
            return paymentDate < sentDate;
        }
        return false;
    };

    var getMethodOptions = function() {
        var paymentMethodOptions = {markAsPaid: true};
        if ((options.method == 'invoice' || options.method == 'directdebit') && (options.payment.status == 'sent' || options.payment.status == 'failed')) {
            paymentMethodOptions.filter = function(m) { return !m.external; };
        } else {
            paymentMethodOptions.filter = function(m) { return m.id != 'customerloss'; };
        }
        return paymentMethodOptions;
    };

    var getMethod = function() {
        var method = _.findWhere($scope.fields, {name: 'method'}).value;
        return method && method.id;
    };

    var getAmount = function() {
        return util.parseDecimal(_.findWhere($scope.fields, {name: 'amount'}).value);
    };

    var giftCardOk = function() {
        if (getMethod() != 'giftcard') {
            return true;
        }

        var cardAmount = giftcard && giftcard.card ? util.parseDecimal(giftcard.card.amount) : NaN;
        var amount = getAmount();
        if (isNaN(cardAmount) || isNaN(amount)) {
            return false;
        }
        return !codeError && cardAmount >= amount;
    };

    $scope.canSubmit = function() {
        return !$scope.alertNotEnoughMoney() && !isTooEarlyDate() && giftCardOk();
    };

    var setCodeError = function(e) {
        codeError = e;
        _.findWhere($scope.fields, {name: 'codeError'}).hint = util.t(e);
    };

    var getGiftCard = function() {
        giftcard = null;
        codeError = null;
        var code = _.findWhere($scope.fields, {name: 'code'}).value;
        if (!code) {
            return;
        }
        var site = $rootScope.sites.find(x => x.id == options.payment.site_id);
        var legal_entity_id = site ? site.legal_entity_id : null;
        server.get('/api/public/giftcard/verify', {code: code, legal_entity_id: legal_entity_id}).then(function(response) {
            if (code == _.findWhere($scope.fields, {name: 'code'}).value) {
                if (response.found) {
                    giftcard = response;
                    if (response.expired) {
                        setCodeError('The gift card expired on {0} and is no longer valid.'.format(response.expired));
                    } else if (response.wrong_legal_entity) {
                        setCodeError('Gift card belongs to a different legal entity');
                    } else if (!util.parseDecimal(response.card.amount)) {
                        setCodeError('There is no money left on the gift card');
                    } else if (!response.paid) {
                        setCodeError('Gift card is not paid');
                    }
                } else {
                    setCodeError('Gift card could not be found');
                }
            }
        });
    };

    $scope.setInitialValues = function() {
        var methods = paymentMethods.getMarkAsPaid();
        var method = _.findWhere(methods, {id: options.method || 'unknown'}) || _.findWhere(methods, {id: 'unknown'});
        _.findWhere($scope.fields, {name: 'date'}).value = Date.today();
        _.findWhere($scope.fields, {name: 'method'}).value = method;
        var amount = options.remaining || (isBundle ? options.payment.remainingAmountToPay : options.payment.amount);
        _.findWhere($scope.fields, {name: 'amount'}).value = formatter.format('float', amount);
    };

    $scope.fields = [
        {name: 'date', title: 'Payment date', required: true, type: 'date', value: Date.today(), max: Date.today().yyyymmdd() },
        {hint: 'Payment date can\'t be earlier than invoice sent date', hintClass: 'alert-danger',  visible: isTooEarlyDate },
        {name: 'amount', title: 'Amount', required: true, type: isBundle ? 'price' : 'label', format: 'price', readonly: !isBundle },
        {name: 'method', title: 'Payment method', required: true, type: 'paymentmethod', value: options.method, options: getMethodOptions() },
        {name: 'code', title: 'Gift card code', required: true, type: 'text', visible: function() { return getMethod() == 'giftcard'; }, change: getGiftCard },
        {name: 'amount', title: 'Left on gift card after purchase', type: 'label', getValue: function() {
            if (!giftcard) { return null; }
            var cardAmount = util.parseDecimal(giftcard.card.amount);
            var amount = getAmount();
            if (isNaN(cardAmount) || isNaN(amount)) { return null; }
            return cardAmount - amount;
        }, visible: function() { return getMethod() == 'giftcard' && giftcard; }, format: 'price'},
        {name: 'codeError', hint: '', hintClass: 'alert-danger', visible: function() { return getMethod() == 'giftcard' && codeError; }},
        {hint: 'Not enough money on gift card', hintClass: 'alert-danger', visible: function() {
            if (!(getMethod() == 'giftcard' && giftcard)) { return false; }
            var cardAmount = util.parseDecimal(giftcard.card.amount);
            var amount = getAmount();
            if (isNaN(cardAmount) || isNaN(amount)) { return false; }
            return cardAmount < amount;
        }}
    ];

    $scope.setInitialValues();
}]);

economy.controller('EconomyDebtCollectionCtrl', ['$rootScope', '$scope', 'server', 'confirm', 'live', 'legalEntity', function($rootScope, $scope, server, confirm, live, legalEntity){
    var debtcollections = [];
    var eventName = 'DebtCollectionsChanged';
    $scope.loadingStatus = {};

    var getDebtCollections = function(silentLoading){
        var args = {};
        var filter = $scope.getEconomyFilter();
        if (filter.customer) {
            args.payer = filter.customer.id;
        }
        if (filter.legal_entity_id) {
            args.legal_entity_id = filter.legal_entity_id;
        }

        $scope.loadingStatus.loading = !silentLoading;
        server.get('/api/payment/inkasso/get', args).then(function(payments) {
            $rootScope.waitFor(['members', 'staffs', 'sites']).then(function() {
                angular.forEach(payments, function(payment) {
                    $rootScope.transformPayment(payment);
                });

                debtcollections = $scope.bundleTogether(payments, true);
                $scope.broadcastChangeEvent(eventName, debtcollections);
                $scope.loadingStatus.loading = false;
        });
        })
    }

    var showPayments = function(payment) {
        $scope.showPayments(payment, eventName);
    };

    var getRemaining = function(p) {
        return p.remainingAmountToPay;
    };

    var canCancelDebtCollection = function(payment) {
        if (!$rootScope.hasPermission('Inkasso')) { return false; }
        return payment.status == 'inkasso' && _.findWhere(payment.claims, { active: true });
    };

    var cancelDebtCollection = function(payment) {
        $scope.loadingStatus.inkasso = true;
        confirm.show('Are you sure you want to change the debt collection status?', { ladda: true }).then(function(resolve) {
            server.post('/api/inkasso/claim/cancel', { invoice: payment.invoice_id }, null, 'Successfully withdrew debt collection claim', 'Failed to withdraw debt collection claim').then(function() {
                resolve();
                $scope.loadingStatus.inkasso = false;
            });
        });
    };

    $scope.debtcollectionConfig = {
        getItems: function() {
            return debtcollections;
     },
        countSuffix: function() { return $scope.countSuffix($scope.debtcollectionConfig.control.getFilteredItems()); },
        hideSearch: true,
        rowClick: $scope.economyConfig.debtcollection.rowClick || showPayments,
        hidePaymentSearch: $scope.economyConfig.debtcollection.hidePaymentSearch,
        orderColumn: 'date',
        getTitle: function() {
            return 'Debt collection';
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'payer.name', title: 'Payer' },
            legalEntity.column(),
            {field: 'date', title: 'Due date', format: 'date' },
            {field: 'name', title: 'Payment item', getValue: $scope.getProductName },
            {field: 'method', title: 'Payment method', getValue: $scope.getPaymentMethodName },
            {
                field: 'totalamount',
                title: 'Amount',
                format: 'discountedpriceleft',
                visible: type => type != 'excel',
                getExtraValue: (i) => ({discount: i.totaldiscount, left: getRemaining(i)})
            },
            {
                field: 'totalamount',
                title: 'Amount',
                format: 'price',
                visible: type => type == 'excel'
            },
            {
                field: 'remaining',
                title: 'Left to pay',
                format: 'price',
                getValue: i => getRemaining(i),
                visible: type => type == 'excel'
            }
        ],
        buttons: $scope.economyConfig.debtcollection.buttons || [
            { title: 'Change', buttonClass: 'btn-warning', onClick: $scope.economyConfig.debtcollection.rowClick || showPayments},
            { title: 'Withdraw collection claims', buttonClass: 'btn-warning', visible: canCancelDebtCollection, onClick: cancelDebtCollection }
        ],
    }

    $scope.$watch(function() {
        var filter = $scope.getEconomyFilter();
        return (filter.customer && filter.customer.id) || filter.legal_entity_id;
    }, getDebtCollections);

    $scope.economyConfig.debtcollection.update = function() {
        $scope.debtcollection.control.update();
    };

    live.subscribe({
        type: 'payment',
        scope: $scope,
        callback: function(payment, event) {
            if ($scope.shouldUpdate(debtcollections, event)) {
                getDebtCollections(true);
            }
        }
    });
}])

economy.controller('EconomyUnpaidCtrl', ['$rootScope', '$scope', 'server', 'live', 'legalEntity', function($rootScope, $scope, server, live, legalEntity) {
    var unpaid = [];
    var eventName = 'UnpaidPaymentsChanged';
    $scope.loadingStatus = {};

    var getUnpaid = function(silentLoading) {
        var args = {};
        var filter = $scope.getEconomyFilter();
        if (filter.customer) {
            args.payer = filter.customer.id;
        }
        if (filter.legal_entity_id) {
            args.legal_entity_id = filter.legal_entity_id;
        }
        $scope.loadingStatus.loading = !silentLoading;
        server.get('/api/payment/unpaid/get', args).then(function(payments) {
            $rootScope.waitFor(['members', 'staffs', 'sites']).then(function() {
                angular.forEach(payments, function(payment) {
                    $rootScope.transformPayment(payment);
                });

                unpaid = $scope.bundleTogether(payments, true);
                $scope.broadcastChangeEvent(eventName, unpaid);
                $scope.loadingStatus.loading = false;
            });
        });
    };

    $scope.$watch(function() {
        var filter = $scope.getEconomyFilter();
        return (filter.customer && filter.customer.id) || filter.legal_entity_id;
    }, getUnpaid);

    var showPayments = function(payment) {
        $scope.showPayments(payment, eventName);
    };

    var canMarkAsPaid = function(p) {
        return !$rootScope.hasModule('Checkout') && p.status == 'pending' && p.method != 'invoice' && p.method != 'directdebit' && p.method != 'stripe';
    };

    var getRemaining = function(p) {
        return p.remainingAmountToPay;
    };

    $scope.unpaidConfig = {
        getItems: function() {
            return unpaid;
        },
        countSuffix: function() { return $scope.countSuffix($scope.unpaidConfig.control.getFilteredItems()); },
        hideSearch: true,
        rowClick: $scope.economyConfig.unpaid.rowClick || showPayments,
        hidePaymentSearch: $scope.economyConfig.unpaid.hidePaymentSearch,
        orderColumn: 'date',
        getTitle: function() {
            return 'Unpaid';
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'payer.name', title: 'Payer' },
            legalEntity.column(),
            {field: 'date', title: 'Due date', format: 'date' },
            {field: 'name', title: 'Payment item', getValue: $scope.getProductName },
            {field: 'method', title: 'Payment method', getValue: $scope.getPaymentMethodName },
            {
                field: 'totalamount',
                title: 'Amount',
                format: 'discountedpriceleft',
                visible: type => type != 'excel',
                getExtraValue: (i) => ({discount: i.totaldiscount, left: getRemaining(i)})
            },
            {
                field: 'totalamount',
                title: 'Amount',
                format: 'price',
                visible: type => type == 'excel'
            },
            {
                field: 'remaining',
                title: 'Left to pay',
                format: 'price',
                getValue: i => getRemaining(i),
                visible: type => type == 'excel'
            }
        ],
        buttons: $scope.economyConfig.unpaid.buttons || [
            { title: 'Mark as paid', visible: canMarkAsPaid, onClick: $scope.paymentMarkAsPaid },
            { title: 'Pay at checkout', onClick: $scope.checkoutPayment, visible: function(p) { return $rootScope.hasPermission('Checkout handling') && (p.status !== 'sent' || p.method === 'invoice'); } },
            { title: 'Change', buttonClass: 'btn-warning', onClick: $scope.economyConfig.unpaid.rowClick || showPayments}
        ],
        searchButtons: $scope.economyConfig.unpaid.searchButtons || [
            {title: 'Send mailing', onClick: $scope.sendMailing },
            {title: 'Download as Excel', onClick: $scope.getExcel }
        ]
    };

    $scope.economyConfig.unpaid.update = function() {
        $scope.unpaidConfig.control.update();
    };

    live.subscribe({
        type: 'payment',
        scope: $scope,
        callback: function(payment, event) {
            if ($scope.shouldUpdate(unpaid, event)) {
                getUnpaid(true);
            }
        }
    });
}]);

economy.controller('EconomyPendingCtrl', ['$rootScope', '$scope', '$q', 'server', 'live', 'legalEntity', function($rootScope, $scope, $q, server, live, legalEntity) {
    var pending = [];
    var eventName = 'PendingPaymentsChanged';
    var cancelPreviousRequest;
    $scope.loadingStatus = {};

    $scope.getPending = function(silentLoading) {
        var from = _.findWhere($scope.fields, {name: 'fromDate'}).value;
        var to = _.findWhere($scope.fields, {name: 'toDate'}).value;
        var amountRangeField = _.findWhere($scope.fields, {name: 'amountRange'});
        var amountRange = amountRangeField.getValue(amountRangeField);
        if (!to || (from && from.getFullYear() < 1900) || to.getFullYear() < 1900) {
            return;
        }

        if (cancelPreviousRequest) {
            cancelPreviousRequest.resolve();
        }
        cancelPreviousRequest = $q.defer();

        var args = { toDate: to.yyyymmdd() };
        if (from) {
            args.fromDate = from.yyyymmdd();
        }
        var filter = $scope.getEconomyFilter();
        if (filter.customer) {
            args.payer = filter.customer.id;
        }
        if (filter.legal_entity_id) {
            args.legal_entity_id = filter.legal_entity_id;
        }

        $scope.loadingStatus.loading = !silentLoading;
        server.get('/api/payment/pending/get', args, cancelPreviousRequest).then(function(payments) {
            $rootScope.waitFor(['members', 'staffs', 'sites']).then(function() {
                angular.forEach(payments, function(payment) {
                    $rootScope.transformPayment(payment);
                });

                pending = $scope.bundleTogether(payments, true);
                if (amountRange && (amountRange.from || amountRange.to)) {
                    pending = pending.filter(function(p) {
                        if (amountRange.from && p.totalamount < amountRange.from) { return false; }
                        if (amountRange.to && p.totalamount > amountRange.to) { return false; }
                        return true;
                    });
                }
                $scope.broadcastChangeEvent(eventName, pending);
                $scope.loadingStatus.loading = false;
            });
        });
    };

    $scope.$watch(function() {
        var filter = $scope.getEconomyFilter();
        return (filter.customer && filter.customer.id) || filter.legal_entity_id;
    }, $scope.getPending);

    var showPayments = function(payment) {
        $scope.showPayments(payment, eventName);
    };

    var getSendDate = function(payment) {
        if (payment.senddate) {
            return payment.senddate.yyyymmdd();
        }
        if ((payment.method == 'invoice' || payment.method == 'einvoice') && payment.status == 'pending') {
            var d = payment.date.clone();
            d.addDays(-payment.days);
            if (d < Date.today()) {
                d = Date.today();
            }
            payment.senddate = d;
            return d.yyyymmdd();
        } else if (payment.method == 'directdebit' && payment.status == 'pending') {
            var d = payment.date.clone();
            d.addDays(-8);
            if (d < Date.today()) {
                d = Date.today();
            }
            payment.senddate = d;
            return d.yyyymmdd();
        }
    };

    var canMarkAsPaid = function(p) {
        return !$rootScope.hasModule('Checkout') && p.method != 'invoice' && p.method != 'directdebit' && p.method != 'stripe';
    };

    $scope.pendingConfig = {
        getItems: function() {
            return pending;
        },
        countSuffix: function() { return $scope.countSuffix($scope.pendingConfig.control.getFilteredItems()); },
        hideSearch: true,
        rowClick: $scope.economyConfig.pending.rowClick || showPayments,
        orderColumn: 'date',
        hidePaymentSearch: $scope.economyConfig.pending.hidePaymentSearch,
        getTitle: function() {
            return 'Pending payments';
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'payer.name', title: 'Payer' },
            legalEntity.column(),
            {field: 'date', title: 'Due date', format: 'date' },
            {field: 'senddate', title: 'Send date', format: 'date', getValue: getSendDate },
            {field: 'name', title: 'Payment item', getValue: $scope.getProductName },
            {field: 'method', title: 'Payment method', getValue: $scope.getPaymentMethodName },
            {
                field: 'totalamount',
                title: 'Amount',
                format: 'discountedprice',
                getExtraValue: (i) => i.totaldiscount
            }
        ],
        buttons: $scope.economyConfig.pending.buttons || [
            { title: 'Mark as paid', visible: canMarkAsPaid, onClick: $scope.paymentMarkAsPaid },
            { title: 'Pay at checkout', onClick: $scope.checkoutPayment, visible: function() { return $rootScope.hasPermission('Checkout handling'); } },
            { title: 'Change', buttonClass: 'btn-warning', onClick: $scope.economyConfig.pending.rowClick || showPayments}
        ],
        searchButtons: $scope.economyConfig.pending.searchButtons || [
            {title: 'Send mailing', onClick: $scope.sendMailing },
            {title: 'Download as Excel', onClick: $scope.getExcel }
        ]
    };

    $scope.economyConfig.pending.update = function() {
        $scope.pendingConfig.control.update();
    };

    $scope.fields = [
        {name: 'fromDate', title: 'From', required: true, type: 'date', value: Date.today(), change: $scope.getPending, visible: function() { return !$scope.economyConfig.pending.hideFromDate; } },
        {name: 'toDate', title: 'To', required: true, type: 'date', value: Date.today().addDays($scope.economyConfig.pending.days || 60), change: $scope.getPending },
        {name: 'amountRange', title: 'Amount range', required: false, type: 'priceinterval', getValue: function(field) { return field.value && (field.value.from || field.value.to) ? ({from: field.value.from, to: field.value.to}) : null; }, change: $scope.getPending, placeholder: 'No limit' },
    ];
    $scope.hideSubmitButton = true;
    $scope.noFormValidation = true;

    live.subscribe({
        type: 'payment',
        scope: $scope,
        callback: function(payment, event) {
            if ($scope.shouldUpdate(pending, event)) {
                $scope.getPending(true);
            }
        }
    });
}]);

economy.controller('EconomySentCtrl', ['$rootScope', '$scope', '$controller', 'server', 'live', 'legalEntity', 'util', function($rootScope, $scope, $controller, server, live, legalEntity, util) {
    $controller('EconomyCtrl', {$scope: $scope});

    var sent = [];
    var eventName = 'SentPaymentsChanged';
    $scope.loadingStatus = {};

    var getSent = function(silentLoading) {
        var args = {};
        var filter = $scope.getEconomyFilter();
        if (filter.customer) {
            args.payer = filter.customer.id;
        }
        if (filter.legal_entity_id) {
            args.legal_entity_id = filter.legal_entity_id;
        }

        $scope.loadingStatus.loading = !silentLoading;
        server.get('/api/payment/sent/get', args).then(function(payments) {
            $rootScope.waitFor(['members', 'staffs', 'sites']).then(function() {
                angular.forEach(payments, function(payment) {
                    $rootScope.transformPayment(payment);
                });

                sent = $scope.bundleTogether(payments, true);
                $scope.broadcastChangeEvent(eventName, sent);
                $scope.loadingStatus.loading = false;
            });
        });
    };

    $scope.$watch(function() {
        var filter = $scope.getEconomyFilter();
        return (filter.customer && filter.customer.id) || filter.legal_entity_id;
    }, getSent);

    var showPayments = function(payment) {
        $scope.showPayments(payment, eventName);
    };

    var markAsFailed = function(payment) {
        return $scope.markBundleAsFailed(payment.parts);
    };

    var canMarkAsPaid = function(payment) {
        return payment.method == 'invoice' || payment.method == 'einvoice';
    };

    var canMarkAsFailed = function(payment) {
        if (payment.status == 'inkasso') { return false; }
        return payment.method == 'directdebit' && $rootScope.currentStaff.superUser;
    };

    var getSentDate = function(payment) {
        var attempts = payment.attempts;
        var inkassoSent = util.getInkassoSentAttempt(payment);
        if (inkassoSent) {
            return inkassoSent.created.yyyymmdd();
        }
        if (attempts.length && payment.status == 'sent') {
            return attempts[attempts.length-1].created.yyyymmdd();
        }
    };

    $scope.sentConfig = {
        getItems: function() {
            return sent.filter(function(p) { return !p.invoiceNumber?.startsWith('K') && !p.parts.every(part => ['credited', 'paid'].includes(part.status)); });
        },
        countSuffix: function() { return $scope.countSuffix($scope.sentConfig.control.getFilteredItems()); },
        hideSearch: true,
        rowClick: $scope.economyConfig.sent.rowClick || showPayments,
        orderColumn: 'date',
        hidePaymentSearch: $scope.economyConfig.sent.hidePaymentSearch,
        getTitle: function() {
            return 'Sent payments';
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'payer.name', title: 'Payer' },
            legalEntity.column(),
            {field: 'date', title: 'Due date', format: 'date' },
            {field: 'sentdate', title: 'Sent at', format: 'date', getValue: getSentDate },
            {field: 'name', title: 'Payment item', getValue: $scope.getProductName },
            {field: 'method', title: 'Payment method', getValue: $scope.getPaymentMethodName },
            {
                field: 'totalamount',
                title: 'Amount',
                format: 'discountedpriceleft',
                visible: type => type != 'excel',
                getExtraValue: (i) => ({discount: i.totaldiscount, left: i.remainingAmountToPay})
            },
            {
                field: 'totalamount',
                title: 'Amount',
                format: 'price',
                visible: type => type == 'excel'
            },
            {
                field: 'remaining',
                title: 'Left to pay',
                format: 'price',
                getValue: i => i.remainingAmountToPay,
                visible: type => type == 'excel'
            }
        ],
        buttons: $scope.economyConfig.sent.buttons || [
            { title: 'Mark as paid', buttonClass: 'btn-success', visible: canMarkAsPaid, onClick: $scope.paymentMarkAsPaid },
            { title: 'Mark as failed', buttonClass: 'btn-danger', visible: canMarkAsFailed, onClick: markAsFailed },
            { title: 'Pay at checkout', onClick: $scope.checkoutPayment, visible: function(p) { return $rootScope.hasPermission('Checkout handling') && (p.method == 'invoice' || p.method == 'einvoice'); } },
            { title: 'Show', buttonClass: 'btn-info', onClick: $scope.economyConfig.sent.rowClick || showPayments}
        ],
        searchButtons: $scope.economyConfig.sent.searchButtons || [
            {title: 'Send mailing', onClick: $scope.sendMailing },
            {title: 'Download as Excel', onClick: $scope.getExcel }
        ]
    };

    $scope.economyConfig.sent.update = function() {
        $scope.sentConfig.control.update();
    };

    live.subscribe({
        type: 'payment',
        scope: $scope,
        callback: function(payment, event) {
            if ($scope.shouldUpdate(sent, event)) {
                getSent(true);
            }
        }
    });
}]);

economy.controller('GiftCardDataCtrl', ['$rootScope', '$scope', 'options', function($rootScope, $scope, options) {
    $scope.config = _.deep_extend(options.config, {
        datatype: 'trainingcard',
        url: {
            change: '/api/trainingcard/change'
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'legal_entity', title: 'Legal entity', type: 'label', getValue: () => $rootScope.getSite(options.item.site_id)?.legal_entity.name },
                    {name: 'validToDate', title: 'Valid to', required: true, type: 'date' },
                    {name: 'barcode', title: 'Barcode', type: 'text', visible: function() { return options.item.type == 'giftcard'; } }
                ]
            }
        ]
    });
}]);

economy.controller('EconomyGiftCardCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'server', 'formatter', 'util', 'eventlog', 'Link', 'legalEntity', function($rootScope, $scope, $controller, $filter, server, formatter, util, eventlog, Link, legalEntity) {
    $controller('EconomyCtrl', {$scope: $scope});

    var giftcards = [];
    $scope.loadingStatus = {};

    $scope.isForCustomer = function() {
        var filter = $scope.getEconomyFilter();
        if (filter.customer) {
            return true;
        }
        return false;
    };

    var hasBarcode;

    var getGiftcards = function(silentLoading) {
        var args = {};
        var filter = $scope.getEconomyFilter();
        if (filter.customer) {
            args.member_id = filter.customer.id;
        }
        if (filter.legal_entity_id) {
            args.legal_entity_id = filter.legal_entity_id;
        }

        $scope.loadingStatus.loading = !silentLoading;
        server.get('/api/economy/giftcard/get', args).then(function(gcards) {
            $rootScope.waitFor(['members', 'staffs']).then(function() {
                angular.forEach(gcards, function(gcard) {
                    $rootScope.transformTrainingCard(gcard);
                    gcard.member = $rootScope.getMember(gcard.user_id);
                });
                giftcards = gcards;
                hasBarcode = !!giftcards.find(function(gc) { return gc.barcode; });

                $scope.loadingStatus.loading = false;
            });
        });
    };

    $scope.countSuffix = function(items) {
        var total = 0;
        angular.forEach(items, function(item) {
            total += Number(item.price);
        });

        return $filter('translate')(items.length == 1 ? 'card' : 'cards') + ', ' + formatter.format('price', total);
    };

    $scope.getImage = function(p) {
        return $rootScope.smallMemberImage(p.member);
    };

    $scope.change = function(card) {
        util.showDataDialog({ controller: 'GiftCardDataCtrl', item: card});
    };

    $scope.openLog = (card) => {
        eventlog.openDialog({
            filter: new Link(card.type, Number(card.id)),
            noPeriod: true,
            hideFilter: true
        });
    };

    $scope.giftcardConfig = {
        getItems: function() {
            return giftcards;
        },
        countSuffix: function() { return $scope.countSuffix($scope.giftcardConfig.control.getFilteredItems()); },
        hidePaymentSearch: true,
        getTitle: function() {
            return $scope.isForCustomer() ? 'Value cards' : 'Gift cards and value cards';
        },
        rowClick: function(card) {
            $rootScope.gotoCustomer(card.member);
        },
        rowClass: function(card){
            if(card.paymentstatus)
                return card.paymentstatus != 'paid' && card.type == 'giftcard' ? 'danger': null;
            return null;
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'member.name', title: 'Customer' },
            legalEntity.column(),
            {field: 'cardtype_name', title: 'Type' },
            {field: 'code', title: 'Code', visible: function() { return !$scope.isForCustomer(); } },
            {field: 'validFromDate', title: 'Valid from', format: 'date' },
            {field: 'validToDate', title: 'Valid to', format: 'date' },
            {field: 'price', title: 'Amount', format: 'price' },
            {field: 'barcode', title: 'Barcode', visible: function() { return !$scope.isForCustomer() && hasBarcode; } },
        ],
        searchButtons: $scope.economyConfig.giftcard.searchButtons || [
            {title: 'Download as Excel', onClick: $scope.getExcel }
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', onClick: $scope.change },
            { title: 'Event log', buttonClass: 'btn-info', onClick: $scope.openLog }
        ]
    };

    $scope.economyConfig.giftcard.update = function() {
        $scope.giftcardConfig.control.update();
    };

    $scope.$watch(function() {
        var filter = $scope.getEconomyFilter();
        return (filter.customer && filter.customer.id) || filter.legal_entity_id;
    }, getGiftcards);

    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        if (message.type == 'trainingcard') {
            getGiftcards(true);
        }
    });

    $scope.$on('$destroy', function () {
        removeServerChange();
    });
}]);


economy.controller('EconomyHistoryCtrl', ['$rootScope', '$scope', '$http', '$q', '$filter', 'server', 'paymentMethods', 'alertProvider', 'util', 'formatter', 'live', 'legalEntity', function($rootScope, $scope, $http, $q, $filter, server, paymentMethods, alertProvider, util, formatter, live, legalEntity) {
    var payments = [];
    var eventName = 'HistoryPaymentsChanged';
    var cancelPreviousRequest;
    $scope.loadingStatus = {};

    var updatePayments = function(silentLoading) {
        var from = _.findWhere($scope.fields, {name: 'fromDate'}).value;
        var to = _.findWhere($scope.fields, {name: 'toDate'}).value;
        if (!from || !to || from.getFullYear() < 1900 || to.getFullYear() < 1900) {
            return;
        }

        if (cancelPreviousRequest) {
            cancelPreviousRequest.resolve();
        }
        cancelPreviousRequest = $q.defer();

        var args = { fromDate: from.yyyymmdd(), toDate: to.yyyymmdd() };
        var filter = $scope.getEconomyFilter();
        if (filter.customer) {
            args.payer = filter.customer.id;
            $scope.tooMuchHistory = false;
        } else {
            $scope.tooMuchHistory = from.daysUntil(to) > 65;
            if ($scope.tooMuchHistory) {
                payments = [];
                return;
            }
        }
        if (filter.legal_entity_id) {
            args.legal_entity_id = filter.legal_entity_id;
        }

        $scope.loadingStatus.loading = !silentLoading;
        server.get('/api/payment/history/get', args, cancelPreviousRequest).then(function(data) {
            $rootScope.waitFor(['members', 'staffs', 'sites']).then(function() {
                angular.forEach(data, function(payment) {
                    $rootScope.transformPayment(payment);
                });
                payments = $scope.bundleTogether(data, true);
                angular.forEach(payments, function(p) {
                    p.totalVAT = 0;
                    p.vat0 = 0;
                    p.vat6 = 0;
                    p.vat12 = 0;
                    p.vat25 = 0;
                    angular.forEach(p.parts, function(product) {
                        var VAT = product.vat;
                        var withoutVAT = product.amount / (1+(VAT / 100.0));
                        var theVAT = product.amount - withoutVAT;
                        p['vat' + VAT] += theVAT;
                        p.totalVAT += theVAT;
                    });
                });
                $scope.broadcastChangeEvent(eventName, payments);
                $scope.loadingStatus.loading = false;
            });
        });
    };

    var getPaymentDate = function(payment) {
        if (payment.attempts.length) {
            var date = (util.getInkassoPaidAttempt(payment) || payment.attempts[payment.attempts.length-1]).time;
            var formatDate = date.yyyymmddSpacehhmm();
            if (formatDate.endsWith(" 00:00")) {
                formatDate = formatDate.slice(0, -6); // Remove " 00:00" for cleaner look
            }
            return formatDate;
        }
    };

    var paymentPrint = function(payment) {
        $scope.loadingStatus.paymentPrint = true;

        let url;
        if (payment.transactionId) url = '/api/payment/receipt/getForBundle?transaction_id=' + payment.transactionId;
        else url = '/api/payment/receipt/get?all=true&id=' + payment.id;
        $http.get(url, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Receipt') + '.pdf', data, 'application/pdf');
            $scope.loadingStatus.paymentPrint = false;
        }).error(function() {
            alertProvider.show('error', 'Failed to get receipt');
            $scope.loadingStatus.paymentPrint = false;
        });
    };

    var showPayments = function(payment) {
        $scope.showPayments(payment, eventName);
    };

    var getStatus = function(payment) {
        var statusMap = {paid: 'Paid', credited: 'Credited'};
        return $filter('translate')(statusMap[payment.status]);
    };

    var getSentDate = function(payment) {
        var attempts = payment.attempts;
        var inkassoSent = util.getInkassoSentAttempt(payment);
        if (inkassoSent) {
            return inkassoSent.created.yyyymmdd();
        }
        if (attempts.length) {
            for (var i=0; i < attempts.length; ++i) {
                if (attempts[i].status == 'sent') {
                    return attempts[i].created.yyyymmdd();
                }
            }
            return attempts[attempts.length-1].created.yyyymmdd();
        }
    };

    var getAllProducts = function(p) {
        if (p.parts.length == 1) {
            return p.name;
        } else {
            var products = [];
            angular.forEach(p.parts, function(part) {
                products.push( part.name + '(' + part.vat + '%' + $filter('translate')('VAT') + ')' );
            });
            return formatter.format('commaList', products);
        }
    };

    var isExcel = function(format) {
        return format == 'excel';
    };

    $scope.historyConfig = {
        getItems: function() {
            return payments;
        },
        countSuffix: function() { return $scope.countSuffix($scope.historyConfig.control.getFilteredItems()); },
        hideSearch: true,
        rowClick: $scope.economyConfig.history.rowClick || showPayments,
        orderColumn: 'paydate',
        getTitle: function() {
            return 'History';
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'payer.name', title: 'Payer' },
            legalEntity.column(),
            {field: 'senddate', title: 'Sent at', format: 'date', getValue: getSentDate },
            {field: 'date', title: 'Due date', format: 'date', visible: isExcel },
            {field: 'paydate', title: 'Payment date', getValue: getPaymentDate, format: 'date' },
            {field: 'name', title: 'Payment item', getValue: $scope.getProductName, visible: function(format) { return format != 'excel'; } },
            {field: 'method', title: 'Payment method', getValue: $scope.getPaymentMethodName },
            {field: 'status', title: 'Status', getValue: getStatus, visible: isExcel},
            {field: 'referenceNumber', title: 'OCR-number', visible: isExcel, showSum: false},
            {field: 'invoiceNumber', title: 'Invoice number', visible: isExcel, showSum: false},
            {
                field: 'totalamount',
                title: 'Amount',
                format: 'discountedprice',
                getExtraValue: (i) => i.totaldiscount
            },
            {field: 'totalVAT', title: 'VAT', format: 'price', visible: isExcel },
            {field: 'vat0', title: 'VAT0', format: 'price', visible: isExcel },
            {field: 'vat6', title: 'VAT6', format: 'price', visible: isExcel },
            {field: 'vat12', title: 'VAT12', format: 'price', visible: isExcel },
            {field: 'vat25', title: 'VAT25', format: 'price', visible: isExcel },
            {field: 'products', title: 'Products', getValue: getAllProducts, visible: isExcel }
        ],
        buttons: $scope.economyConfig.history.buttons || [
            { title: 'Get receipt', buttonClass: 'btn-success', onClick: paymentPrint, visible: function(p) { return p.status == 'paid'; }, loading: () => $scope.loadingStatus.paymentPrint },
            { title: 'Show', buttonClass: 'btn-info', onClick: $scope.economyConfig.history.rowClick || showPayments}
        ],
        searchButtons: $scope.economyConfig.history.searchButtons || [
            {title: 'Send mailing', onClick: $scope.sendMailing },
            {title: 'Download as Excel', onClick: $scope.getExcel }
        ]
    };

    $scope.economyConfig.history.update = function() {
        $scope.historyConfig.control.update();
    };

    $scope.fields = [
        {name: 'fromDate', title: 'From', required: true, type: 'date', value: Date.firstDayLastMonth(), change: updatePayments },
        {name: 'toDate', title: 'To', required: true, type: 'date', value: Date.today(), change: updatePayments }
    ];
    $scope.hideSubmitButton = true;
    $scope.noFormValidation = true;

    updatePayments();

    $scope.$watch(function() {
        var filter = $scope.getEconomyFilter();
        return (filter.customer && filter.customer.id) || filter.legal_entity_id;
    }, updatePayments);

    live.subscribe({
        type: 'payment',
        scope: $scope,
        callback: function(payment, event) {
            if ($scope.shouldUpdate(payments, event)) {
                updatePayments(true);
            }
        }
    });
}]);

economy.controller('PaymentListModalCtrl', ['$rootScope', '$scope', '$modal', '$http', '$filter', '$location', 'payments', 'eventName', 'server', 'confirm', 'paymentMethods', 'alertProvider', 'util', 'cashiers', 'formatter', 'Link', 'eventlog', 'invoice', 'CreditPaymentDialog', 'live', function($rootScope, $scope, $modal, $http, $filter, $location, payments, eventName, server, confirm, paymentMethods, alertProvider, util, cashiers, formatter, Link, eventlog, invoice, CreditPaymentDialog, live) {

    $scope.loadingStatus = {};

    var getInvoiceId = function() {
        var payment = payments[0];
        if (payment.attempts.length) {
            for (var i=payment.attempts.length-1; i >= 0; --i) {
                var a = payment.attempts[i];
                if (a.status != 'credited' && a.invoice_id) {
                    return a.invoice_id;
                }
            }
        }
    };

    var getExternalReference = function() {
        const isAdyenPayment = payments[0].method.startsWith('adyen');
        if(isAdyenPayment) {
            const bundle_id = payments[0]?.attempts[0]?.bundle_id;
            if (!bundle_id) {
                return;
            }
            server.get('/api/payment/bundle/external_reference/get', {bundle_id: bundle_id}).then(function(reference) {
                $scope.externalReference = JSON.parse(reference);
            });
        };
    };
    getExternalReference();


    var getCreditInvoiceId = function(payment) {
        var p = payment || payments[0];
        return p?.attempts?.find(a => a.status == 'credited')?.invoice_id ||
            p.credited_invoice_id ||
            getInvoiceId();
    };

    $scope.getCustomer = function() {
        return payments[0].payer;
    };

    $scope.getDate = function() {
        return payments[0].date;
    };

    $scope.getCount = function() {
        return payments && payments.length;
    };

    $scope.canGetReceipt = function() {
        var s = payments[0].status;
        return s == 'paid' || s == 'credited';
    };

    $scope.canMarkAsPaid = function() {
        return payments.some(payment => (payment.status == 'pending' && payment.method != 'invoice' && payment.method != 'einvoice' && payment.method != 'directdebit' && payment.method != 'stripe') || (payment.status == 'sent' && (payment.method =='invoice' || payment.method =='einvoice')) || payment.status == 'failed');
    };

    // An included product's payment is bundle-controlled — its row actions are
    // driven from the parent card, so hide them here.
    var isIncludedPaymentRow = function(payment) {
        return !!payment.parent_trainingcard_id && $rootScope.hasFlag('flag-package-trainingcard');
    };

    $scope.canMarkOneAsPaid = function(payment) {
        return (payment.status == 'pending' && payment.method != 'invoice' && payment.method != 'einvoice' && payment.method != 'directdebit' && payment.method != 'stripe' && !isIncludedPaymentRow(payment));
    };

    $scope.canMarkAsFailed = function() {
        var payment = payments[0];
        if (payment.status == 'inkasso') { return false; }
        return payment.status == 'sent' && payment.method == 'directdebit' && $rootScope.currentStaff.superUser;
    };

    $scope.canRefund = function() {
        var payment = payments[0];
        return payment.status == 'paid' && payment.method == 'stripe' && !payment.refunded;
    };

    $scope.canCreditInvoice = function() {
        return payments.some(payment => (payment.status == 'sent' || payment.status == 'paid' || payment.status == 'failed') && (payment.method == 'invoice' || payment.method == 'einvoice' || payment.method == 'directdebit' || (payment.invoice_type == 'directdebit' || payment.invoice_type == 'invoice')) && !payment.credited && (payment.method != 'directdebit' || payment.status != 'sent'));
    };

    $scope.canCreateOldInvoice = function() {
        var payment = payments[0];
        return (payment.method == 'invoice' || payment.method == 'einvoice') && payment.status == 'pending' && $rootScope.currentStaff.superUser && $rootScope.isTestSystem;
    };

    $scope.canSimulateFail = function() {
        return payments.some(payment => payment.status == 'sent') && $rootScope.currentStaff.superUser && $rootScope.isTestSystem;
    };

    $scope.canSendToDebtCollection = function() {
        if (!$rootScope.hasPermission('Inkasso')) { return false; }

        const hasAddress = $scope.getCustomer().address;
        const hasSomeValidPayment = payments.some(payment => payment.date < new Date() && (payment.status == 'sent' || payment.status == 'failed') && (payment.method == 'invoice' || payment.method == 'einvoice' || payment.method == 'directdebit') && !_.findWhere(payment.claims, { active: true }));

        return hasAddress && hasSomeValidPayment;
    };
    $scope.canCancelDebtCollection = function() {
        if (!$rootScope.hasPermission('Inkasso')) { return false; }
        var payment = payments[0];
        return payment.status == 'inkasso' && _.findWhere(payment.claims, { active: true });
    };

    $scope.canGetInvoiceData = function() {
        var payment = payments[0];
        return $rootScope.hasModule('Invoice') && payment.status == 'pending' && (payment.method == 'invoice' || payment.method == 'einvoice');
    };

    $scope.canCreateInvoice = function() {
        var payment = payments[0];
        return $rootScope.hasModule('Invoice') && payment.status == 'pending' && payment.method == 'invoice';
    };

    $scope.canGetCreditInvoice = function() {
        var payment = payments[0];
        return $rootScope.hasModule('Invoice') && payment.status == 'credited' && (payment.original_invoice_id || payment.credited_invoice_id || payment.parent_invoice_id);
    };

    $scope.canGetInvoice = function() {
        var payment = payments[0];
        if(payment.invoice_type && payment.invoice_type != 'invoice') {
            return false;
        }

        return $rootScope.hasModule('Invoice') && (payment.status == 'sent' || payment.status == 'paid' || payment.status == 'credited' || payment.status == 'inkasso') && getInvoiceId();
    };

    $scope.canGetDirectDebitInvoice = function() {
        var payment = payments[0];
        return $rootScope.hasModule('DirectDebit') && (payment.status == 'sent' || payment.status == 'paid' || payment.status == 'failed' || payment.status == 'credited') && payment.invoice_type == 'directdebit' && getInvoiceId();
    };

    $scope.canSendInvoiceMail = function() {
        return $rootScope.hasModule('Invoice') && payments.some(payment => payment.status == 'sent');
    };

    $scope.canRemove = function() {
        var payment = payments[0];
        return payment.status == 'pending';
    };

    $scope.canChangePaymentMethod = function() {
        var payment = payments[0];
        return payment.status == 'pending';
    };

    $scope.canChangeDueDate = function() {
        return payments.some(payment => payment.status == 'pending' || (payment.status == 'sent' && (payment.method == 'invoice' || payment.method == 'einvoice')) || (payment.status == 'failed' && payment.method == 'directdebit'));
    };

    $scope.canChangePaymentTerms = function() {
        return payments.some(payment => (payment.status == 'pending' && (payment.method == 'invoice' || payment.method == 'einvoice')) || (payment.status == 'sent' && (payment.method == 'invoice' || payment.method == 'einvoice')));
    };

    $scope.canPayAtCheckout = function() {
        return payments.some(payment => $rootScope.hasPermission('Checkout handling') && (payment.status == 'pending' || payment.status == 'failed' || (payment.status == 'sent' && (payment.method == 'invoice' || payment.method == 'einvoice'))));
    };

    $scope.canReverse = function() {
        var payment = payments[0];
        return (payment.status == 'paid' && payment.method == 'xcard');
    };

    $scope.canSplit = function() {
        return payments.some(payment => payment.status == 'pending' || (payment.status == 'sent' && payment.method !== 'directdebit'));
    };

    $scope.split = function() {
        $modal.open({
            templateUrl: 'views/splitpayment.html',
            controller: 'SplitPaymentCtrl',
            resolve: {
                payments: function() {
                    return payments;
                }
            }
        });
    };

    $scope.getPaymentDate = function() {
        var payment = payments[0];
        var attempts = payment.attempts;
        if (attempts.length && payment.status == 'paid') {
            return (util.getInkassoPaidAttempt(payment) || attempts[attempts.length-1]).time;
        }
    };

    $scope.getSendDate = function() {
        var payment = payments[0];
        if (payment.senddate) {
            return payment.senddate;
        }

        if ((payment.method == 'invoice' || payment.method == 'einvoice') && payment.status == 'pending') {
            var d = payment.date.clone();
            d.addDays(-payment.days);
            if (d < Date.today()) {
                d = Date.today();
            }
            payment.senddate = d;
            return d;
        }
        // FIXME: For directdebit?
    };

    $scope.getSentDate = function() {
        var payment = payments[0];
        var attempts = payment.attempts;
        var inkassoSent = util.getInkassoSentAttempt(payment);
        if (inkassoSent) {
            return inkassoSent.created;
        }
        if (attempts.length && (payment.status == 'sent' || payment.status == 'paid')) {
            for (var i=0; i < attempts.length; ++i) {
                if (attempts[i].status == 'sent') {
                    return attempts[i].created;
                }
            }
            return attempts[attempts.length-1].created;
        }
    };

    $scope.getMail = function() {
        var payment = payments[0];
        return payment.invoice_sentTo || $scope.getCustomer().mail;
    };

    $scope.getCreditDate = function() {
        var payment = payments[0];
        return payment.credited;
    };

    $scope.getPaymentMethod = function(payment) {
        var methods = paymentMethods.getAll();
        return _.findWhere(methods, {id: payment.method});
    };

    $scope.getPaymentMethodName = function(payment) {
        var method = $scope.getPaymentMethod(payment);
        if (method) {
            return $filter('translate')(method.name);
        }
    };

    $scope.getPaymentMethodImage = function() {
        var method = $scope.getPaymentMethod(payments[0]);
        if (method) {
            return method.imageSrc;
        }
    };

    $scope.showHistory = function() {
        var payment = payments[0];
        var showAttempts = payment.attempts.length > 1 || payment.status == 'failed' || (payment.attempts.length == 1 && payment.attempts[0].status == 'failed');
        var hasTransactions = payment.transactions ? payment.transactions.length : 0;
        var hasReminders = payment.reminders ? payment.reminders.length : 0;
        var hasOpened = invoice && (invoice.opened || invoice.openedMail);
        return showAttempts || hasTransactions || hasReminders || hasOpened;
    };

    $scope.getReminder = function(id) {
        $http.get('/api/invoice/reminder/get?id=' + id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Reminder') + '.pdf', data, 'application/pdf');
        }).error(function() {
            alertProvider.show('error', 'Failed to get data');
        });
    };

    var getInvoiceById = function(id) {
        $scope.loadingStatus.getInvoice = true;
        $http.get('/api/invoice/get?id=' + id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Invoice') + '.pdf', data, 'application/pdf');
            $scope.loadingStatus.getInvoice = false;
        }).error(function() {
            alertProvider.show('error', 'Failed to get invoice');
            $scope.loadingStatus.getInvoice = false;
        });
    };

    function timeCompare(a, b) {
        return a.time < b.time ? -1 : (a.time > b.time ? 1 : 0);
    }

    function formatMessage(message) {
        var message = message.split(';');
        for (var i = 0; i < message.length; i++) {
            var parts = message[i].split(':');
            parts[parts.length-1] = ' ' + $filter('translate')(parts[parts.length-1].trim());
            message[i] = parts.join(':');
        }
        return message.join('<br/>');
    }

    $scope.getHistory = function() {
        if (!$scope.history) {
            const events = [];
            const payment = payments[0];

            const createEvent = (time, message, link = null) => ({
                time,
                message,
                ...(link && { link })
            });

            const formatAttemptMessage = (attempt, status) => {
                const invoiceSentTo = status == 'Sent' && attempt.invoice_sentTo ? ` ${util.t('to')} ${attempt.invoice_sentTo} `: '';

                return `${$filter('translate')($scope.getAttemptMethod(attempt))} ${$filter('translate')(status)}${invoiceSentTo}${attempt.message ? formatMessage(attempt.message) : ''}`;
            };

            // Create the first event unconditionally
            const firstAttempt = payment.attempts[0];
            const firstAttemptStatus = $scope.getAttemptStatus(firstAttempt);
            const firstMessage = formatAttemptMessage(firstAttempt, firstAttemptStatus);

            const originalInvoiceId = payment.invoice_id || getInvoiceId();
            events.push(createEvent($scope.getAttemptTime(firstAttempt), firstMessage, {
                text: 'Download',
                click: () => getInvoiceById(originalInvoiceId),
            }));

            // Check InvoiceCreditFlow.md for more information on the invoice crediting flow
            // Process legacy invoice crediting
            if (payment.credit_invoice_id) {
                payment.attempts.forEach(attempt => {
                    const status = $scope.getAttemptStatus(attempt);
                    const message = formatAttemptMessage(attempt, status);

                    const event = createEvent($scope.getAttemptTime(attempt), message);

                    if (['invoice', 'einvoice'].includes(attempt.method)) {
                        let invoiceId = payment.original_invoice_id || getInvoiceId();
                        if (status == 'Credited' && payment.credited_invoice_id) {
                            invoiceId = payment.credited_invoice_id;
                        }

                        event.link = {
                            text: 'Download',
                            click: () => getInvoiceById(invoiceId),
                        };
                    }

                    events.push(event);
                });
            }

            // Process new invoice crediting (From dec 2024 onwards)
            if (payment.parts?.some(part => part.parent_invoice_id)) {
                payment.parts?.forEach(part => {
                    part.attempts?.forEach(attempt => {
                        if (attempt.status == 'credited') {
                            const creditMessage = `${$filter('translate')('Partially credited')} ${formatter.format('price', attempt.amount)}`;

                            events.push(createEvent(attempt.time, creditMessage, {
                                text: 'Get credit invoice',
                                click: () => getInvoiceById(attempt.invoice_id),
                            }));
                        }
                    });
                });
            }

            if (payment.transactions) {
                payment.transactions.forEach(function(t) {
                    if (!t.claim) {
                        const label = t.method === 'customerloss' ?
                            $filter('translate')('Confirmed customerloss') :
                            $filter('translate')('Partial payment of');
                        events.push({time: t.created, message: label + ' ' + formatter.format('price', t.amount)});
                    }
                });
            }

            if (payment.reminders) {
                payment.reminders.forEach(function(r) {
                    events.push({time: r.created, message: $filter('translate')('Reminder was sent'), link: {text: 'Download', click: function() { $scope.getReminder(r.id); }  } });
                });
            }

            if (payment.claims) {
                payment.claims.forEach(function(claim) {
                    var message = $filter('translate')('Debt collection') + ' ' + (claim.message ? formatMessage(claim.message) : '');
                    events.push({time: claim.created, message: message });
                });
            }

            if (invoice) {
                if (invoice.opened) {
                    events.push({ time: invoice.opened, message: $filter('translate')('Opened invoice PDF') });
                }

                if (invoice.openedMail) {
                    events.push({ time: invoice.openedMail, message: $filter('translate')('Opened invoice mail') });
                }
            }

            $scope.history = Array.mergeSort(events, timeCompare);
        }

        return $scope.history;
    };

    $scope.getAttempts = function() {
        var payment = payments[0];
        return payment.attempts;
    };

    $scope.getAttemptMethod = function(attempt) {
        var method = _.findWhere(paymentMethods.getAll(), {id: attempt.method});
        return method.name;
    };

    $scope.getAttemptStatus = function(attempt) {
        if (attempt.method == 'invoice' && attempt.status == 'sent' && !attempt.invoice_sendMethod) {
            return 'Created and retrieved manually';
        }
        var statuses = {failed: 'Failed', paid: 'Paid', sent: 'Sent', credited: 'Credited', inkasso: 'Debt collection', withdrawn: 'Withdrawn' };
        return statuses[attempt.status];
    };

    $scope.getAttemptTime = function(attempt) {
        if (attempt.status == 'sent') {
            return attempt.created;
        } else {
            return attempt.time;
        }
    };

    var showPayment = function(payment) {
        // Included product payments are bundle-controlled — block opening the change dialog
        // (the row is clickable even though the Change button is hidden for these).
        if (isIncludedPaymentRow(payment)) {
            return;
        }
        $modal.open({
            templateUrl: 'views/payment.html',
            controller: 'PaymentModalCtrl',
            resolve: {
                payment: function() {
                    return payment;
                }
            }
        });
    };

    var paymentRemove = function(payment) {
        confirm.show('Are you sure you want to remove the payment?', {ladda: true}).then(function(resolve) {
            server.post2('/api/payment/remove', {payments: [payment.id]}, null, '{0} was removed', 'Failed to remove {0}', 'Payment').then(resolve);
        });
    };

    var paymentPrint = function(payment) {
        $scope.loadingStatus.paymentPrint = true;
        $http.get('/api/payment/receipt/get?id=' + payment.id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Receipt') + '.pdf', data, 'application/pdf');
            $scope.loadingStatus.paymentPrint = false;
        }).error(function() {
            alertProvider.show('error', 'Failed to get receipt');
            $scope.loadingStatus.paymentPrint = false;
        });
    };

    var paymentMarkAsPaid = function(payment) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'MarkAsPaidCtrl',
            resolve: {
                options: function() {
                    return {
                        payment: payment,
                        method: payment.method,
                    };
                }
            }
        });
    };

    var getProductImage = function(payment) {
        var cardtype = _.findWhere($rootScope.trainingcardtypes, {id: payment.cardtype_id});
        return $rootScope.image('Product', cardtype, 50);
    };

    var getBooking = function(payment) {
        if (payment.booking_id) {
            var service = _.findWhere($rootScope.resourcebookingservices, {id: payment.booking_service_id});
            var date = Date.newFull(payment.booking_date);
            return service.name + ', ' + date.yyyymmdd();
        }
    };

    var getBooker = function(payment) {
        if (payment.booking_booker_id) {
            var booker = $rootScope.getMember(payment.booking_booker_id);
            if (booker) {
                return booker.name;
            }
        }
    };

    var hasBooking = function() {
        return _.some(payments, function(p) { return p.booking_id; });
    };

    var hasBooker = function() {
        return _.some(payments, function(p) { return p.booking_booker_id && p.booking_booker_id != $scope.getCustomer().id; });
    };

    var hasMember = function() {
        return _.some(payments, function(p) { return p.user_id != $scope.getCustomer().id; });
    };

    var hasComment = function() {
        return _.some(payments, function(p) { return p.comment; });
    };

    var hasVariant = function() {
        return _.some(payments, function(p) { return p.product_variant; });
    };

    $scope.getTotalAmount = function() {
        var total = 0;
        angular.forEach(payments, function(payment) {
            total += Number(payment.amount);
        });
        return total;
    };

    $scope.getReceiptForBundle = function() {
        var payment = payments[0];
        $scope.loadingStatus.getReceipt = true;

        let url;
        if (payment.transactionId) url = '/api/payment/receipt/getForBundle?transaction_id=' + payment.transactionId;
        else url = '/api/payment/receipt/get?all=true&id=' + payment.id;
        $http.get(url, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Receipt') + '.pdf', data, 'application/pdf');
            $scope.loadingStatus.getReceipt = false;
        }).error(function() {
            alertProvider.show('error', 'Failed to get receipt');
            $scope.loadingStatus.getReceipt = false;
        });
    };

    $scope.markBundleAsPaid = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'MarkAsPaidCtrl',
            resolve: {
                options: function() {
                    return {
                        payment: payments[0],
                        method: payments[0].method,
                        all: true,
                        remaining: $scope.getRemaining()
                    };
                }
            }
        });
    };

    $scope.changePaymentTerms = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'ChangePaymentTermsModalCtrl',
            resolve: {
                payments: function() {
                    return payments;
                }
            }
        });
    };

    $scope.removeAll = function() {
        confirm.show('Are you sure you want to remove the payment?', {ladda: true}).then(function(resolve) {
            var ids = _.pluck(payments, 'id');
            server.post2('/api/payment/remove', {payments: ids}, null, '{0} was removed', 'Failed to remove {0}', 'Payment').then(resolve);
        });
    };

    $scope.getInvoiceData = function() {
        var ids = _.pluck(payments, 'id');

        $scope.loadingStatus.getInvoiceData = true;
        server.post('/api/invoice/data/get', {ids: ids}, null, null, 'Failed to get invoice data', null, {responseType: 'blob'}).then(function(result) {
            if (result.success) {
                util.download( $filter('translate')('Invoice data') + '.pdf', result.data, 'application/pdf');
            }

            $scope.loadingStatus.getInvoiceData = false;
        });
    };

    $scope.createInvoice = function() {
        var ids = _.pluck(payments, 'id').join(',');
        $scope.loadingStatus.createInvoice = true;
        server.post('/api/invoice/create', {ids: ids}, null, 'Invoice created', 'Failed to create invoice').then(function(result) {
            if (result.success) {
                getInvoiceById(result.data.id);
            }

            $scope.loadingStatus.createInvoice = false;
        });
    };

    $scope.getInvoice = function() {
        var payment = payments[0];

        if (payment.reminders.length) {
            var reminder = _.last(payment.reminders);
            $scope.getReminder(reminder.id);
        } else {
            var invoice_id = payment.original_invoice_id || getInvoiceId();
            getInvoiceById(invoice_id);
        }
    };

    $scope.sendInvoiceMail = function() {
        var payment = payments[0];
        $scope.loadingStatus.sendMail = true;
        server.post('/api/invoice/sendmail', null, {id: payment.invoice_id}, 'Mail sent', 'Failed to send mail').then(function() {
            $scope.loadingStatus.sendMail = false;
        });
    };

    $scope.getCreditInvoice = function() {
        getInvoiceById(getCreditInvoiceId());
    };

    $scope.markBundleAsFailed = function() {
        confirm.show('Are you sure you want to mark the payment as failed?', {ladda: true}).then(function(resolve) {
            var ids = _.pluck(payments, 'id').join(',');
            server.post('/api/payment/markAsFailed', null, {payments: ids}, 'Payment was marked as failed', 'Failed to mark payment as failed').then(resolve);
        });
    };

    $scope.changePaymentMethod = function() {
        var currentMethod = payments[0].method;
        var payerHasCard = payments[0].payer.hasSavedCardForSelectedLegalEntity();
         $modal.open({
            templateUrl: 'views/paychoicemodal.html',
            controller: 'ChoosePaymentMethodCtrl',
            resolve: {
                options: function() {
                    return {
                        change: true,
                        filter: function(m) {
                            if (m.id == 'stripe' && !payerHasCard) {
                                return false;
                            }
                            return m.id != currentMethod;
                        }
                    };
                }
            }
        }).result.then(function(method) {
            if (method.id != currentMethod) {
                var ids = _.pluck(payments, 'id');
                var doChange = function() {
                    server.post('/api/payment/method/change', {payments: ids, method: method.id}, null, 'Payment method changed', 'Failed to change payment method');
                };

                if (method.id == 'stripe' && payments[0].date.isPastDate(true)) {
                    confirm.show('CHARGENOWCONFIRM').then(doChange);
                } else {
                    doChange();
                }
            }
        });
    };

    $scope.changeDueDate = function() {
        var currentDate = payments[0].date;
        var infomessage = '';
        if(payments[0].status == 'sent' || payments[0].status == 'failed') {
            infomessage = 'CHANGEDUEDATEAFTERSENTINFO';
        }
        $modal.open({
            templateUrl: '/views/pickdatemodal.html',
            controller: 'PickDateModalCtrl',
            resolve: {
                date: function() {
                    return currentDate;
                },
                infomessage : function() {
                    return infomessage;
                }
            }
        }).result.then(function(date) {
            if (!Date.dateEquals(date, currentDate)) {
                var ids = _.pluck(payments, 'id').join(',');
                var doChange = function() {
                    server.post('/api/payment/duedate/change', null, {payments: ids, date: date.yyyymmdd()}, 'Due date changed', 'Failed to change due date');
                };

                if (payments[0].method == 'stripe' && date.isPastDate(true)) {
                    confirm.show('CHARGENOWCONFIRM').then(doChange);
                } else {
                    doChange();
                }
            }
        });
    };

    $scope.refund = function() {
        confirm.show('Are you sure you want to refund the payment?', {ladda: true}).then(function(resolve) {
            var payment = payments[0];
            var bundle_id = payment.attempts[payment.attempts.length-1].bundle_id;
            server.post('/api/payment/stripe/refund', null, {bundle_id: bundle_id }, 'Payment refunded', 'Failed to refund payment').then(function(response) {
                resolve();
                if(response.success && response.data && response.data.alert) {
                    alertProvider.modal('Payment refunded', response.data.alert);
                }
            });
        });
    };

    $scope.reverse = function() {
        confirm.show('Are you sure you want to reverse the payment?').then(function() {
            var payment = payments[0];
            var bundle_id = payment.attempts[payment.attempts.length-1].bundle_id;
            server.post2('/api/payment/reverse', {
                bundle_id: bundle_id
            }).then(function() {

            }, function() {

            });
        });
    };

    $scope.canCredit = function() {
        var p = payments[0];
        return p.status == 'paid' && (p.method == 'swishi' || p.method == 'stripe' || p.method.startsWith('adyen-') || p.method == 'epassi');
    };

    $scope.credit = function() {
        CreditPaymentDialog.open({
            bundleId: payments[0].attempts[0].bundle_id
        });
    };

    var creditProduct = function(payment) {
        CreditPaymentDialog.open({
            paymentsIds: [payment.id]
        });
    };

    $scope.creditInvoice = function() {
        $modal.open({
            templateUrl: 'views/creditinvoice.html',
            controller: 'CreditInvoiceCtrl',
            resolve: {
                invoice: function() {
                    return getCreditInvoiceId();
                },
                hasPayments: function() {
                    var payment = payments[0];
                    if (payment.transactions) {
                        return payment.transactions.filter(function(t) { return !t.claim && t.amount > 0; }).length > 0;
                    }
                    return false;
                },
                hasStock: function() {
                    return _.find(payments, function(payment) {
                        var cardtype = _.findWhere($rootScope.trainingcardtypes, {id: payment.cardtype_id});
                        return cardtype && cardtype.stock != null;
                    });
                }
            }
        });
    };

    $scope.createOldInvoice = function() {
        var ids = _.pluck(payments, 'id').join(',');
        $scope.loadingStatus.createInvoice = true;
        server.post('/api/invoice/create', {ids: ids, old: true}, null, 'Invoice created', 'Failed to create invoice').then(function(result) {
            if (result.success) {
                getInvoiceById(result.data.id);
            }

            $scope.loadingStatus.createInvoice = false;
        });
    };

    $scope.simulateFail = function() {
        var payment = payments[0];
        var bundle_id = payment.attempts[payment.attempts.length-1].bundle_id;
        server.post('/api/admin/test', {operation: 'servicebureau_payment_fail', data: { bundle_id: bundle_id}}, null, 'Ok', 'Fail');
    };

    $scope.sendToDebtCollection = function() {
        confirm.show('DEBT_COLLECTION_MARK_CONFIRM', { ladda: true }).then(function(resolve) {
            $scope.loadingStatus.inkasso = true;
            var payment = payments[0];
            server.post('/api/inkasso/claim/create', { invoice: payment.invoice_id }, null, 'Successfully marked invoice for debt collection', 'Failed to mark invoice for debt collection').then(function() {
                resolve();
                $scope.loadingStatus.inkasso = false;
            });
        });
    };
    $scope.cancelDebtCollection = function() {
        confirm.show('Are you sure you want to change the debt collection status?', { ladda: true }).then(function(resolve) {
            $scope.loadingStatus.inkasso = true;
            var payment = payments[0];
            server.post('/api/inkasso/claim/cancel', { invoice: payment.invoice_id }, null, 'Successfully withdrew debt collection claim', 'Failed to withdraw debt collection claim').then(function() {
                resolve();
                $scope.loadingStatus.inkasso = false;
            });
        });
    };

    $scope.closeAndGotoCustomer = function(customer) {
        $scope.$close();
        $rootScope.gotoCustomer(customer);
    };

    $scope.payAtCheckout = function() {
        $scope.$close();
        var payment = payments[0];
        if (payment.referenceNumber) {
            cashiers.transferInvoice(payment);
        } else {
            cashiers.transferPayments(payment.parts);
        }
        var search = {};
        var customerId = payment.payer_id || payment.user_id;
        if (customerId) search.customer_id = customerId;
        if (payment.referenceNumber) {
            if (payment.invoice_id) search.invoice_id = payment.invoice_id;
            if (payment.invoiceNumber) search.invoice_number = payment.invoiceNumber;
            if (payment.remainingAmountToPay != null) search.invoice_amount = payment.remainingAmountToPay;
        } else {
            var ids = (payment.parts || []).map(function(p) { return p.id; }).filter(Boolean);
            if (ids.length) search.payment_ids = ids.join(',');
        }
        $location.path('/checkout').search(search);
    };

    $scope.getCreditedAmount =  function () {
        return payments[0]?.creditedAmount ?? 0;
    }

    $scope.getAlreadyPaid = function() {
        return payments[0]?.alreadyPaidAmount ?? 0;
    };

    $scope.getRemaining = function() {
        return payments[0]?.remainingAmountToPay ?? 0;
    };

    $scope.showInvoiceExtraInfo = function() {
        return payments.some(p => p.method === 'invoice' && p.invoiceExtraInfo != "");
    };

    $scope.getInvoiceExtraInfo = function() {
        var payment = payments.find(p => p.method === 'invoice' && p.invoiceExtraInfo != "");
        return payment ? payment.invoiceExtraInfo : "";
    };

    $scope.showRemaining = function() {
        return payments.some(p => p.status != 'credited') && $scope.getRemaining() > 0;
    };

    $scope.getReferenceNumber = function() {
        var payment = payments[0];
        return payment.referenceNumber;
    };

    $scope.getInvoiceNumber = function() {
        var payment = payments[0];
        return payment.invoiceNumber;
    };

    function openPaymentLog(p) {
        eventlog.openDialog({
            filter: new Link('payment', Number(p.id)),
            noPeriod: true,
            hideFilter: true
        });
    }

    function visibleCreditProduct(p) {
        if(p.parent_trainingcard_id) {return false;}
        if(p.status == 'sent' && ['invoice', 'einvoice'].includes(p.method)) {return true;}
        return p.status == 'paid';
    }

    function canGetCreditInvoiceForPayment(p) {
        return p && p.status == 'credited' && (p.original_invoice_id || p.credited_invoice_id || p.parent_invoice_id) && ['invoice', 'einvoice'].includes(p.method);
    }

    $scope.config = {
        getItems: function() {
            return payments;
        },
        rowClick: showPayment,
        headerClass: 'glyphicon glyphicon-usd',
        hideSearch: true,
        tableLimit: 5,
        columns: [
            {field: 'image', title: '', src: getProductImage },
            {field: 'count', title: 'Count' },
            {field: 'name', title: 'Payment item' },
            {field: 'product_variant', title: 'Product variant', visible: hasVariant },
            {field: 'comment', title: 'Comment', visible: hasComment },
            {field: 'member.name', title: 'Name', visible: hasMember },
            {field: 'booking', title: 'Booking', getValue: getBooking, visible: hasBooking },
            {field: 'booker', title: 'Booker', getValue: getBooker, visible: hasBooker },
            {field: 'method', title: 'Payment method', getValue: $scope.getPaymentMethodName },
            {
                field: 'amount',
                title: 'Amount',
                format: 'discountedprice',
                getExtraValue: (i) => i.discount
            },
            {field: 'from_date', title: 'From date', format: 'date', visible: function() {return _.pluck(payments, 'from_date').some(Boolean);} },
            {field: 'to_date', title: 'To date', format: 'date', visible: function() {return _.pluck(payments, 'to_date').some(Boolean);} }
        ],
        buttons: [
            { title: 'Change', visible: function(p) { return p.status == 'pending' && !isIncludedPaymentRow(p); }, onClick: showPayment, buttonClass: 'btn-warning' },
            { title: 'Mark as paid', buttonClass: 'btn-success', visible: $scope.canMarkOneAsPaid, onClick: paymentMarkAsPaid },
            { title: 'Get receipt', buttonClass: 'btn-success', visible: function(p) { return p.status == 'paid' && Math.abs(p.amount) > 0.5; }, onClick: paymentPrint, loading: () => $scope.loadingStatus.paymentPrint },
            { title: 'Remove', visible: function(p) { return p.status == 'pending' && !p.parent_trainingcard_id; }, onClick: paymentRemove, buttonClass: 'btn-danger' },
            { title: 'Event log', onClick: openPaymentLog, buttonClass: 'btn-info', visible: function() {return $scope.hasPermission('Show event log');} },
            { title: 'Credit product', visible: visibleCreditProduct, onClick: creditProduct, buttonClass: 'btn-danger' },
            { title: 'Credited', visible: function(p) {return p.status == 'credited';}, onClick: angular.noop, buttonClass: ' ' },
            { title: 'Get credit invoice', visible: canGetCreditInvoiceForPayment, onClick: (p) => getInvoiceById(getCreditInvoiceId(p)), buttonClass: 'btn-success' },
        ]
    };

    var afterPaymentsUpdated = function() {
        if (!payments.length) {
            $scope.$close();
        } else {
            $scope.history = null;
            $scope.config.control.rebuild();
        }
    };

    if (eventName) {
        var removeChange = $scope.$on(eventName, function (event, refetcher) {
            payments = refetcher(payments[0]);
            afterPaymentsUpdated();
        });

        $scope.$on('$destroy', function () {
            removeChange();
        });
    } else {
        live.subscribe({
            type: 'payment',
            scope: $scope,
            callback: function(eventData, event) {
                var action = event.action;
                var changed = false;
                for (var i=0; i < event.data.length; ++i) {
                    var payment_id = event.data[i].id;
                    var ourp = _.findWhere(payments, {id: payment_id});
                    if (ourp) {
                        if (action == 'remove') {
                            payments.splice(payments.indexOf(ourp), 1);
                        } else if (action == 'change') {
                            Object.assign(ourp, event.data[i]);
                            $rootScope.transformPayment(ourp);
                        }
                        changed = true;
                    }
                }

                if (changed) {
                    afterPaymentsUpdated();
                }
            }
        });
    }
}]);

economy.controller('EconomyLoadCtrl', ['$rootScope', '$scope', '$http', '$location', '$timeout', '$filter', '$modal', 'confirm', 'server', 'alertProvider', 'util', function($rootScope, $scope, $http, $location, $timeout, $filter, $modal, confirm, server, alertProvider, util) {
    $scope.parsedFiles = [];
    $scope.unknownPayments = [];
    $scope.successfulPayments = [];
    $scope.failedPayments = [];
    $scope.wrongAmountPayments = [];
    $scope.alreadyPaidPayments = [];
    $scope.noAutogiro = [];
    $scope.retry = [];
    $scope.newConsents = [];
    $scope.removedConsents = [];
    $scope.consentErrors = [];
    $scope.fromInternet = [];
    $scope.tabledata = {};
    $scope.isLoadingFile = false;

    $scope.parseDirectDebitFile = function(text) {
        var unknown = { type: 'Okänd' };
        var res = {};

        // Bank statements from the new Swedish payment infrastructure are
        // ISO 20022 XML.  Accept the CAMT reports that the backend can
        // process, rather than rejecting them before they are uploaded.
        var xml = new DOMParser().parseFromString(text, 'application/xml');
        var root = xml.documentElement;
        var parserError = xml.getElementsByTagName('parsererror').length;
        var isoTypes = {
            'urn:iso:std:iso:20022:tech:xsd:camt.053.001.02': 'ISO 20022 CAMT.053',
            'urn:iso:std:iso:20022:tech:xsd:camt.054.001.02': 'ISO 20022 CAMT.054'
        };
        if ($rootScope.hasFlag('flag-iso-20022-camt-import') && !parserError && root && root.localName === 'Document' && isoTypes[root.namespaceURI]) {
            return {type: isoTypes[root.namespaceURI]};
        }

        var lines = text.split('\r\n');
        var line;

        var get = function(pos, text) {
            return line.substring(pos-1).indexOf(text) == 0;
        };

        var geti = function(pos, len) {
            return Number(line.substring(pos-1, pos-1+len));
        };

        var getdate = function(pos) {
            var d = line.substring(pos-1, pos-1+8);
            var year = Number(d.substring(0,4));
            var month = Number(d.substring(4,6));
            var day = Number(d.substring(6,8));
            return new Date(year, month-1, day);
        };

        for (var i=0; i < lines.length; ++i) {
            line = lines[i];
            if (line.length == 0) {
                continue;
            }

            if (line.length > 80) {
                line = line.substring(0, 80);
            } else if (line.length < 80) {
                line = line + ' ' * (80 - line.length);
            }

            var code = line.substring(0, 2);
            if (isNaN(code)) {
                continue;
            }

            switch (code) {
                case '01':
                    if (get(3, 'AUTOGIRO')) {
                        if (get(45, 'AG-MEDAVI')) {
                            res.type = 'Medgivandeavisering - Ny layout';
                            res.date = getdate(25);
                        } else if (get(45, 'BET. SPEC & STOPP TK')) {
                            res.type = 'Betalningsspecifikation - Ny layout';
                            res.date = getdate(25);
                        } else if (get(45, 'AVVISADE BET UPPDR')) {
                            res.type = 'Avvisade betalningsuppdrag - Ny layout';
                            res.date = getdate(25);
                        } else if (get(45, 'MAKULERING/ÄNDRING')) {
                            res.type = 'Makulering/ändring - Ny layout';
                            res.date = getdate(25);
                        }
                        res.customerNumber = geti(65, 6);
                        res.bankgiroNumber = geti(71, 10);
                    } else if (get(3, 'BGMAX')) {
                        res.type = 'BgMax-format';
                        res.date = getdate(25);
                    } else if (get(11, 'AUTOGIRO')) {
                        if (get(23, ' ')) {
                            res.type = 'Betalningsspecifikation - Gammal layout';
                        } else if (get(23, 'FELLISTA REG.KONTRL')) {
                            res.type = 'Avvisade betalningsuppdrag - Gammal layout';
                        } else if (get(23, 'MAK/ÄNDRINGSLISTA')) {
                            res.type = 'Makuleringar/ändringar - Gammal layout';
                        }
                        res.date = getdate(3);
                        res.customerNumber = geti(63, 6);
                        res.bankgiroNumber = geti(69, 10);
                    } else if (get(25, 'AG-MEDAVI')) {
                        res.type = 'Medgivandeavisering - Gammal layout';
                        res.date = getdate(3);
                        res.bankgiroNumber = geti(15, 10);
                    }
                    break;
                case '51':
                    if (get(25, 'AG-EMEDGIV')) {
                        res.type = 'Medgivanden via Internetbanken - Ny layout';
                        res.date = getdate(3);
                        res.bankgiroNumber = geti(15, 10);
                    }
                    break;
            }
        }

        return res.type ? res : unknown;
    };

    $scope.parseFile = function(file) {
        var p = {name: file.name};
        var fileReader = new FileReader();
        fileReader.onloadend = function () {
            var dd = $scope.parseDirectDebitFile(fileReader.result);
            angular.extend(p, dd);

            if (p.type == 'ISO 20022 CAMT.053' || p.type == 'ISO 20022 CAMT.054') {
                p.ok = true;
            } else {
                p.ok = (p.type == 'Betalningsspecifikation - Gammal layout' || p.type == 'Medgivandeavisering - Gammal layout' || p.type == 'Medgivandeavisering - Ny layout' || p.type == 'Betalningsspecifikation - Ny layout' || p.type == 'Avvisade betalningsuppdrag - Gammal layout' || p.type == 'Avvisade betalningsuppdrag - Ny layout' || p.type == 'Makuleringar/ändringar - Gammal layout' || p.type == 'Makulering/ändring - Ny layout' || p.type == 'BgMax-format' || p.type == 'Medgivanden via Internetbanken - Ny layout') && (p.customerNumber == undefined|| $scope.ddsettings.customerNumber == p.customerNumber) && (p.type == 'BgMax-format' || $scope.ddsettings.bankgiroNumber == p.bankgiroNumber);
            }

            $scope.$apply();

            if ($scope.filesAreOk()) {
                $scope.checkFiles();
            }
        };
        fileReader.readAsText(file, 'iso-8859-1');

        $scope.parsedFiles.push(p);
    };

    $scope.filesAreOk = function() {
        return  $scope.selectedFiles.length == $scope.parsedFiles.length && _.every($scope.parsedFiles, function(f) { return f.ok; });
    };

    $scope.parseFiles = function(files) {
        angular.forEach(files, function(file) {
            $scope.parseFile(file);
        });
    };

    $scope.resetFiles = function() {
        $scope.selectedFiles = undefined;
        $scope.parsedFiles = [];
        $scope.unknownPayments = [];
        $scope.successfulPayments = [];
        $scope.failedPayments = [];
        $scope.wrongAmountPayments = [];
        $scope.alreadyPaidPayments = [];
        $scope.noAutogiro = [];
        $scope.retry = [];
        $scope.newConsents = [];
        $scope.changedPayerNumber = [];
        $scope.removedConsents = [];
        $scope.consentErrors = [];
        $scope.fromInternet = [];
        $scope.hasReadFile = undefined;
        $scope.hasIncomingPayments = undefined;
    };

    $scope.areSettingsValid = function() {
        var valid = true;
        if ($rootScope.hasModule('DirectDebit')) {
            valid = $rootScope.missingSettings.indexOf('DirectDebit') == -1;
        }
        if ($rootScope.hasModule('Invoice')) {
            valid &= ($rootScope.missingSettings.indexOf('Invoice') == -1);
        }
        return valid;
    };

    server.get('/api/directdebit/settings/get', {legal_entity_id: $rootScope.selectedSite.legal_entity_id}).then(function(data) {
        $scope.ddsettings = data;
    });

    $http.get('/api/invoice/settings/get').success(function(data) {
        $scope.invoiceSettings = data;
    });

    $scope.acceptChanges = function() {
        $scope.isAcceptingChanges = true;
        server.postFile('/api/economy/loadfile?change=true', $scope.selectedFiles, 'Betalningar och ändringar registrerade', 'Det gick inte att läsa in filen').then(function() {
            $scope.resetFiles();
            $scope.isAcceptingChanges = false;
        });
    };

    $scope.checkFiles = function() {
        $scope.isLoadingFile = true;
        server.postFile('/api/economy/loadfile', $scope.selectedFiles).then(function(result) {
            if (result.success) {
                $scope.hasReadFile = result.data.hasReadFile;
                $scope.hasIncomingPayments = result.data.hasIncomingPayments;
                angular.forEach(result.data.tasks, function(task) {
                    task.date = Date.newFull(task.date);
                    task.totalamount = Number(task.amount);
                });
                angular.forEach(result.data.paid, function(payment) {
                    $rootScope.transformPayment(payment);
                });
                angular.forEach(result.data.failed, function(payment) {
                    $rootScope.transformPayment(payment);
                });
                angular.forEach(result.data.noauto, function(payment) {
                    $rootScope.transformPayment(payment);
                });
                angular.forEach(result.data.retry, function(payment) {
                    $rootScope.transformPayment(payment);
                });
                angular.forEach(result.data.wrongamount, function(payment) {
                    $rootScope.transformPayment(payment);
                });
                angular.forEach(result.data.alreadypaid, function(payment) {
                    $rootScope.transformPayment(payment);
                });

                var newConsents = [];
                var changedPayerNumber = [];
                var removedConsents = [];
                var consentErrors = [];
                var removedPayerNumber = [];
                var fromInternet = [];
                var id = 1; // Invent an id to get rowClick working
                angular.forEach(result.data.consents, function(consent) {
                    consent.id = id;
                    consent.date = Date.newFull(consent.date);

                    var pcode = util.normalizePersonalCodeNumber(consent.personalCodeNumber);
                    consent.member = _.findWhere($rootScope.members, {personalCodeNumber: pcode});

                    var arrays = {'add': newConsents, 'remove': removedConsents,  'error': consentErrors, 'changenew': changedPayerNumber, 'changeremove': removedPayerNumber, 'addinternet': fromInternet};
                    arrays[consent.type].push(consent);
                    id += 1;
                });

                angular.forEach(removedPayerNumber, function(consent) {
                    var change = _.findWhere(changedPayerNumber, {member_id: consent.member_id});
                    if (!change) {
                        consentErrors.push(consent);
                    }
                });

                for (var i=0; i < changedPayerNumber.length; ++i) {
                    var consent = changedPayerNumber[i];
                    if (!consent.member) {
                        consentErrors.push(consent);
                        changedPayerNumber.splice(i, 1);
                        --i;
                    }
                }

                angular.forEach(result.data.tasks, function(p) {
                    p.id = id;
                    id += 1;
                });

                $scope.unknownPayments = result.data.tasks;
                $scope.successfulPayments = $scope.bundleTogether(result.data.paid, true);
                $scope.failedPayments = $scope.bundleTogether(result.data.failed, true);
                $scope.wrongAmountPayments = $scope.bundleTogether(result.data.wrongamount, true);
                $scope.alreadyPaidPayments = $scope.bundleTogether(result.data.alreadypaid, true);
                $scope.noAutogiro = $scope.bundleTogether(result.data.noauto, true);
                $scope.retry = $scope.bundleTogether(result.data.retry, true);
                $scope.newConsents = newConsents;
                $scope.changedPayerNumber = changedPayerNumber;
                $scope.removedConsents = removedConsents;
                $scope.consentErrors = consentErrors;
                $scope.fromInternet = fromInternet;
            } else {
                angular.forEach($scope.parsedFiles, function(f) {
                    f.ok = false;
                });
                alertProvider.show('error', 'Error loading file');
            }

            $scope.isLoadingFile = false;
        });
    };

    $scope.waitingWatch = $scope.$watch('selectedFiles', function(newValue) {
        if (newValue) {
            $scope.parsedFiles = [];
            $scope.parseFiles($scope.selectedFiles);
        }
    });

    $scope.$on('$destroy', function () {
        $scope.waitingWatch();
    });

    var getCustomerNumber = function(p) {
        if (p.customerNumber == undefined) {
            return;
        }

        var res = p.customerNumber;
        if (p.customerNumber != undefined && $scope.ddsettings.customerNumber != p.customerNumber) {
            res += ' ' + '(' + $filter('translate')('ERROR_MATCHBGCCUSTOMER') + ')';
        }
        return res;
    };

    var getBankgiroNumber = function(p) {
        if (p.bankgiroNumber == undefined) {
            return;
        }

        var res = p.bankgiroNumber;
        if ($scope.ddsettings.bankgiroNumber != p.bankgiroNumber) {
            res += ' ' + '(' + $filter('translate')('ERROR_MATCHBANKGIRO') + ')';
        }
        return res;
    };

    var findInvoice = function(p) {
        $modal.open({
            templateUrl: 'views/findinvoice.html',
            controller: 'FindInvoiceModalCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                payment: function() {
                    return p;
                }
            }
        }).result.then(function (payment) {
            if (payment) {
                p.hideMatchButton = true;
                $scope.unknownPaymentsConfig.control.update();
            }
        });
    };

    $scope.parsedFilesTableConfig = {
        getItems: function() { return $scope.parsedFiles; },
        columns: [
            {field: 'name', title: 'Filnamn' },
            {field: 'date', title: 'Date', getValue: function(f) { if (f.date) { return f.date.yyyymmdd(); } } },
            {field: 'customerNumber', title: 'BGC customer number', getValue: getCustomerNumber },
            {field: 'bankgiroNumber', title: 'Bankgiro number', getValue: getBankgiroNumber },
            {field: 'type', title: 'Type' }
        ],
        rowClass: function(item) {
            return item.ok == false ? 'danger' : 'success';
        }
    };

    $scope.unknownPaymentsConfig = {
        getItems: function() { return $scope.unknownPayments; },
        countSuffix: function() { return $scope.countSuffix($scope.unknownPaymentsConfig.control.getFilteredItems()); },
        columns: [
            {field: 'date', title: 'Date', format: 'date' },
            {field: 'amount', title: 'Amount', format: 'price' },
            {field: 'payer', title: 'Payer'},
            {field: 'reference', title: 'Reference'},
            {field: 'recipient_bankgironummer', title: 'Recipient'}
        ],
        rowClick: findInvoice,
        buttons: [
            { title: 'Find matching invoice', buttonClass: 'btn-success', visible: function(p) { return p.invoice && !p.hideMatchButton; }, onClick: findInvoice }
        ]
    };

    $scope.getImage = function(p) {
        return $rootScope.smallMemberImage(p.member);
    };

    var addCustomer = function(consent) {
        var member = {
            name: consent.name,
            city: consent.city,
            address: consent.address,
            zipCode: consent.zipCode,
            personalCodeNumber: consent.personalCodeNumber
         };
        server.post('/api/member/add', member, {}, 'Customer added', 'Failed to add customer').then(function(result) {
            if (result.success) {
                $scope.parsedFiles = [];
                $scope.parseFiles($scope.selectedFiles);
            }
        });
    };

    $scope.successfulPaymentsConfig = {
        getItems: function() { return $scope.successfulPayments; },
        countSuffix: function() { return $scope.countSuffix($scope.successfulPaymentsConfig.control.getFilteredItems()); },
        rowClick: function(payment) {
            $scope.showPayments(payment, 'SuccessfulPayments');
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'member.name', title: 'Name' },
            {
                field: 'totalamount',
                title: 'Amount',
                format: 'discountedprice',
                getExtraValue: (i) => i.totaldiscount
            },
            {field: 'date', title: 'Date', format: 'date' },
            {field: 'name', title: 'Payment item', getValue: $scope.getProductName },
            {field: 'payer.name', title: 'Payer'},
            {field: 'recipient_bankgironummer', title: 'Recipient'}
        ]
    };

    $scope.failedPaymentsConfig = {
        getItems: function() { return $scope.failedPayments; },
        countSuffix: function() { return $scope.countSuffix($scope.failedPaymentsConfig.control.getFilteredItems()); },
        rowClick: function(payment) {
            $scope.showPayments(payment, 'FailedPayments');
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'member.name', title: 'Name' },
            {
                field: 'totalamount',
                title: 'Amount',
                format: 'discountedprice',
                getExtraValue: (i) => i.totaldiscount
            },
            {field: 'date', title: 'Date', format: 'date' },
            {field: 'name', title: 'Payment item', getValue: $scope.getProductName },
            {field: 'payer.name', title: 'Payer'},
            {field: 'recipient_bankgironummer', title: 'Recipient'}
        ]
    };

    $scope.wrongAmountPaymentsConfig = {
        getItems: function() { return $scope.wrongAmountPayments; },
        countSuffix: function() { return $scope.countSuffix($scope.wrongAmountPaymentsConfig.control.getFilteredItems()); },
        rowClick: function(payment) {
            $scope.showPayments(payment, 'WrongAmountPayments');
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'member.name', title: 'Name' },
            {
                field: 'totalamount',
                title: 'Amount',
                format: 'discountedprice',
                getExtraValue: (i) => i.totaldiscount
            },
            {field: 'paidamount', title: 'Paid amount', format: 'price' },
            {field: 'date', title: 'Date', format: 'date' },
            {field: 'name', title: 'Payment item', getValue: $scope.getProductName },
            {field: 'payer.name', title: 'Payer'},
            {field: 'recipient_bankgironummer', title: 'Recipient'}
        ]
    };

    $scope.alreadyPaidPaymentsConfig = {
        getItems: function() { return $scope.alreadyPaidPayments; },
        countSuffix: function() { return $scope.countSuffix($scope.alreadyPaidPaymentsConfig.control.getFilteredItems()); },
        rowClick: function(payment) {
            $scope.showPayments(payment, 'AlreadyPaidPayments');
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'member.name', title: 'Name' },
            {
                field: 'totalamount',
                title: 'Amount',
                format: 'discountedprice',
                getExtraValue: (i) => i.totaldiscount
            },
            {field: 'date', title: 'Date', format: 'date' },
            {field: 'name', title: 'Payment item', getValue: $scope.getProductName },
            {field: 'payer.name', title: 'Payer'},
            {field: 'recipient_bankgironummer', title: 'Recipient'}
        ]
    };

    $scope.noAutogiroConfig = {
        getItems: function() { return $scope.noAutogiro; },
        countSuffix: function() { return $scope.countSuffix($scope.noAutogiroConfig.control.getFilteredItems()); },
        rowClick: function(payment) {
            $scope.showPayments(payment, 'NoAutogiro');
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'member.name', title: 'Name' },
            {
                field: 'totalamount',
                title: 'Amount',
                format: 'discountedprice',
                getExtraValue: (i) => i.totaldiscount
            },
            {field: 'date', title: 'Date', format: 'date' },
            {field: 'name', title: 'Payment item', getValue: $scope.getProductName },
            {field: 'payer.name', title: 'Payer'},
            {field: 'recipient_bankgironummer', title: 'Recipient'}
        ]
    };

    $scope.retryPaymentsConfig = {
        getItems: function() { return $scope.retry; },
        countSuffix: function() { return $scope.countSuffix($scope.retryPaymentsConfig.control.getFilteredItems()); },
        rowClick: function(payment) {
            $scope.showPayments(payment, 'Retry');
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'member.name', title: 'Name' },
            {
                field: 'totalamount',
                title: 'Amount',
                format: 'discountedprice',
                getExtraValue: (i) => i.totaldiscount
            },
            {field: 'date', title: 'Date', format: 'date' },
            {field: 'name', title: 'Payment item', getValue: $scope.getProductName },
            {field: 'payer.name', title: 'Payer'},
            {field: 'recipient_bankgironummer', title: 'Recipient'}
        ]
    };

    $scope.newConsentsConfig = {
        getItems: function() { return $scope.newConsents; },
        countSuffix: function() {
            return 'consents';
        },
        rowClick: function(consent) {
            $rootScope.gotoCustomer(consent.member);
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'member.name', title: 'Name' },
            {field: 'member.personalCodeNumber', title: 'Personal code number', format: 'personalCodeNumber' },
            {field: 'date', title: 'Date', format: 'date' },
            {field: 'account', title: 'Bank account number' }
        ]
    };

    $scope.changedPayerNumberConfig = {
        getItems: function() { return $scope.changedPayerNumber; },
        countSuffix: function() {
            return 'consents';
        },
        rowClick: function(consent) {
            $rootScope.gotoCustomer(consent.member);
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'member.name', title: 'Name' },
            {field: 'member.personalCodeNumber', title: 'Personal code number', format: 'personalCodeNumber' },
            {field: 'date', title: 'Date', format: 'date' },
            {field: 'account', title: 'Bank account number' }
        ]
    };

    $scope.removedConsentsConfig = {
        getItems: function() { return $scope.removedConsents; },
        countSuffix: function() {
            return 'consents';
        },
        rowClick: function(consent) {
            if (consent.member) {
                $rootScope.gotoCustomer(consent.member);
            }
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'member.name', title: 'Name' },
            {field: 'personalCodeNumber', title: 'Personal code number', format: 'personalCodeNumber' },
            {field: 'date', title: 'Date', format: 'date' }
        ]
    };

    $scope.fromInternetConfig = {
        getItems: function() { return $scope.fromInternet; },
        countSuffix: function() {
            return 'consents';
        },
        rowClick: function(consent) {
            $rootScope.gotoCustomer(consent.member);
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'name', title: 'Name' },
            {field: 'personalCodeNumber', title: 'Personal code number', format: 'personalCodeNumber' },
            {field: 'date', title: 'Date', format: 'date' },
            {field: 'account', title: 'Bank account number' },
            {field: 'message', title: 'Message' }
        ],
        buttons: [
            { title: 'Add customer', onClick: addCustomer, visible: function(c) { return !c.member; } }
        ]
    };

    var getConsentError = function(c) {
        var res = 'Unknown';
        if (c.commentcode == 23) {
            res = 'Incorrect account number';
        } else if (c.infocode == 42 && c.commentcode == 5) {
            res = 'Incorrect bank account or personal information';
        }

        return $filter('translate')(res);
    };

    $scope.consentErrorsConfig = {
        getItems: function() { return $scope.consentErrors; },
        countSuffix: function() {
            return 'consents';
        },
        rowClick: function(consent) {
            if (consent.member) {
                $rootScope.gotoCustomer(consent.member);
            }
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'member.name', title: 'Name' },
            {field: 'personalCodeNumber', title: 'Personal code number', format: 'personalCodeNumber' },
            {field: 'date', title: 'Date', format: 'date' },
            {field: 'account', title: 'Bank account number'},
            {field: 'error', title: 'Error', getValue: getConsentError },
            {field: 'errorCode', title: 'Error code', getValue: function(p) { return p.infocode + ', ' + p.commentcode; } }
        ]
    };
}]);

economy.controller('FindInvoiceModalCtrl', ['$scope', '$controller', 'payment', 'confirm', 'server', function($scope, $controller, payment, confirm, server) {
    $controller('EconomySentCtrl', {$scope: $scope});

    $scope.payment = payment;

    $scope.sentConfig.columns.push({ field: 'referenceNumber', title: 'Reference'});

    if(payment.mode == 'markAsPaid') {
        $scope.sentConfig.buttons = [{
            title: 'Mark as paid',
            buttonClass: 'btn-success',
            onClick: function(payment) {
                confirm.show('Are you sure you want to mark the payment as paid?', {ladda: true}).then(function(resolve) {
                    var ids = _.pluck(payment.parts, 'id').join(',');
                    var date = Date.today().yyyymmdd();
                    server.post('/api/payment/markAsPaid', null, {payments: ids, date: date, method: 'bank'}, 'Payment was marked as paid', 'Failed to mark payment as paid').then(resolve);
                });
            }
        }];
    } else if(payment.mode == 'markAsFailed') {
        $scope.sentConfig.buttons = [{
            title: 'Mark as failed',
            buttonClass: 'btn-danger',
            onClick: function(payment) {
                confirm.show('Are you sure you want to mark the payment as failed?', {ladda: true}).then(function(resolve) {
                    var ids = _.pluck(payment.parts, 'id').join(',');
                    server.post('/api/payment/markAsFailed', null, {payments: ids}, 'Payment was marked as failed', 'Failed to mark payment as failed').then(resolve);
                });
            }
        }];
    } else {
        _.findWhere($scope.sentConfig.buttons, {title: 'Mark as paid'}).onClick = function(payment) {
            $scope.paymentMarkAsPaid(payment, 'bank');
        };

        $scope.onPaymentPaid = function(paidPayment) {
            $scope.$close(paidPayment);
        };
    }
}]);

economy.controller('FindInvoiceModalCtrl2', ['$scope', '$controller', 'transaction', 'paid', 'confirm', 'server', function($scope, $controller, transaction, paid, confirm, server) {
    $controller('EconomyInvoicesCtrl', {$scope: $scope});

    $scope.transaction = transaction;

    var match = function(i) {
        confirm.show('Are you sure you want to match the transaction with this invoice?', {ladda: true}).then(function(resolve) {
            server.post('/api/invoice/match', null, {transaction_id: transaction.id, invoice_id: i.id, paid: paid}, 'Invoice payment matched', 'Failed to match invoice payment').then(function(result) {
                resolve();
                if (result.success) {
                    $scope.$close(true);
                }
            });
        });
    };

    _.findWhere($scope.fields, {name: 'fromDate'}).required = false;
    _.findWhere($scope.fields, {name: 'fromDate'}).value = null;
    _.findWhere($scope.fields, {name: 'toDate'}).required = false;
    _.findWhere($scope.fields, {name: 'toDate'}).value = null;
    _.findWhere($scope.fields, {name: 'unpaid'}).value = true;
    _.findWhere($scope.fields, {name: 'credit'}).required = false;
    _.findWhere($scope.fields, {name: 'credit'}).value = false;
    _.findWhere($scope.fields, {name: 'credit'}).visible = function() { return false; };
    $scope.invoicesConfig.searchButtons = [];
    $scope.invoicesConfig.buttons.push(
        { title: 'DOMATCH', onClick: match }
    );
}]);


economy.controller('EconomyUnconfirmedInvoicesCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', 'paymentMethods', 'server', function($rootScope, $scope, $controller, $filter, $modal, paymentMethods, server) {
    $controller('EconomyPendingCtrl', {$scope: $scope});

    $scope.getEconomyFilter = function() {
        return {
            legal_entity_id: $rootScope.selectedSite.legal_entity_id
        };
    };

    var getIds = function(payments) {
        var ids = [];
        angular.forEach(payments, function(payment) {
            ids = ids.concat(_.pluck(payment.parts, 'id'));
        });
        return ids;
    };

    var confirming = [];
    $scope.confirm = function(payment) {
        var payments = payment ? [payment] : $scope.pendingConfig.control.getFilteredItems();
        confirming = _.pluck(payments, 'id');
        $scope.loadingStatus.confirming = true;
        var confirmPayments = function(delayBelowMin) {
            var ids = getIds(payments);
            server.post2('/api/payment/confirm', {payments: ids, delayBelowMin: !!delayBelowMin}, {
                successAlert: 'Invoices confirmed',
                errorAlert: 'Failed to confirm invoices'
            }).then(function() {
                $scope.loadingStatus.confirming = false;
            }, function() {
                $scope.loadingStatus.confirming = false;
            });
        };
        var delay = function() { confirmPayments(true); };
        var skipDelay = function() { confirmPayments(false); };
        if (!$scope.allAboveMinAmount(payments)) {
            $modal.open({
                templateUrl: 'views/paymentconfirmationoptionmodal.html',
                controller: 'PaymentConfirmationOptionModalCtrl',
            }).result.then(function(result) {
                if (result.delayBelowMin) { delay(); }
                else { skipDelay(); }
            }, function() {
                $scope.loadingStatus.confirming = false;
            });
        } else {
            skipDelay();
        }
    };

    $scope.allAboveMinAmount = function(payments) {
        if (!$scope.invsettings || !$scope.invsettings.minAmount) {
            return true;
        }
        var minAmount = Number($scope.invsettings.minAmount);
        var hasPaymentBelowMin = !!_.find(payments, function(p) { return p.amount < minAmount; });
        return !hasPaymentBelowMin;
    };

    server.get('/api/invoice/settings/get').then(function(data) {
        $scope.invsettings = data;
    });

    // When confirming hundreds of payments, this is to avoid reloading too much
    var oldShouldUpdate = $scope.shouldUpdate;
    $scope.shouldUpdate = function(payments, event) {
        if (oldShouldUpdate(payments, event)) {
            // Go through all events and see if they are all related to payments which we are confirming
            var mustUpdate = false;
            event.data.forEach(function(p) {
                var ci = confirming.indexOf(p.id);
                if (p.confirmed && ci != -1) {
                    // Payment is now confirmed as we wanted
                    var i = payments.findIndex(function(x) { return x.id == p.id; });
                    if (i != -1) {
                        payments.splice(i, 1);
                    }
                    confirming.splice(ci, 1);
                } else {
                    mustUpdate = true;
                }
            });
            return mustUpdate;
        }

        return false;
    };

    $scope.pendingConfig.countSuffix = function() {
        return $filter('translate')($scope.pendingConfig.control.getFilteredItems().length == 1 ? 'invoice' : 'invoices');
    };
    var fromDate = _.findWhere($scope.fields, {name: 'fromDate'});
    fromDate.value = null;
    fromDate.visible = function() { return false; };

    $scope.pendingConfig.giveFocus = function() { return false; };

    $rootScope.waitFor(['paymentmethods']).then(function() {
        $scope.pendingConfig.searchMethod = ['invoice', 'einvoice'];
        $scope.pendingConfig.unconfirmed = true;
        _.findWhere($scope.pendingConfig.columns, {field: 'date'}).visible = function() { return false; };
        $scope.pendingConfig.columns.push( {field: 'days', title: 'Payment terms', getValue: function(p) { return p.days + ' ' + $filter('translate')('days'); } } );

        $scope.pendingConfig.buttons = [
            { title: 'Confirm', buttonClass: 'btn-success', onClick: $scope.confirm }
        ];

        $scope.getPending();
    });
}]);

economy.controller('EconomyInvoicesCtrl', ['$rootScope', '$scope', '$filter', '$q', '$timeout', 'server', '$http', 'alertProvider', 'util', '$controller', '$modal', 'live', function($rootScope, $scope, $filter, $q, $timeout, server, $http, alertProvider, util, $controller, $modal, live) {
    $controller('EconomyCtrl', {$scope: $scope});
    var invoices = [];
    var cancelPreviousRequest;
    $scope.loadingStatus = {
        getInvoice: []
    };
    var paymentMap = {};
    var eventName = 'InvoicesChanged';
    $scope.getImage = function(p) {
        return $rootScope.smallMemberImage(p.payer);
    };
    var getInvoice = function(i) {
        $scope.loadingStatus.getInvoice[i.id] = true;
        $http.get('/api/invoice/get?id=' + i.id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Invoice') + '.pdf', data, 'application/pdf');
        }).error(function() {
            alertProvider.show('error', 'Failed to get invoice');
        }).finally(function() {
            $scope.loadingStatus.getInvoice[i.id] = false;
        });
    };

    $scope.getExcel = function(config) {
        config.control.exportTo('excel').then(function(blob) {
            util.download($filter('translate')(config.getTitle()) + '.xlsx', null, null, blob);
        });
    };

    var isExcel = function(format) {
        return format == 'excel';
    };

    var showPayments = function(i) {
        $modal.open({
            templateUrl: 'views/paymentlist.html',
            controller: 'PaymentListModalCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                payments: function() {
                    if (i.payments && i.payments.length) {
                        return i.payments[0].parts;
                    } else {
                        return server.get('/api/payment/bundle/get', {bundle_id: i.bundle_id}).then(function(payments) {
                            payments.forEach($rootScope.transformPayment);
                            return $scope.bundleTogether(payments, true)[0].parts;
                        });
                    }
                },
                eventName: function() {
                    return eventName;
                },
                invoice: function() {
                    return i;
                }
            }
        });
    };

    $scope.invoicesConfig = {
        getItems: function() {
            return invoices;
        },
        countSuffix: function() {
            return $filter('translate')($scope.invoicesConfig.control.getFilteredItems().length == 1 ? 'invoice' : 'invoices');
        },
        orderColumn: 'invoiceNumber',
        rowClick: showPayments,
        getTitle: function() {
            return 'Invoices';
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'payer.name', title: 'Payer' },
            {field: 'invoiceNumber', title: 'Invoice number', showSum: false },
            {field: 'referenceNumber', title: 'OCR-number', showSum: false },
            {field: 'senddate', title: 'Invoice date', format: 'date' },
            {field: 'duedate', title: 'Due date', format: 'date' },
            {field: 'paydate', title: 'Payment date', format: 'date' },
            {field: 'creditdate', title: 'Credited date', format: 'date' },
            {field: 'amount', title: 'Amount', format: 'price' },
            {field: 'totalVAT', title: 'VAT', format: 'price', visible: isExcel },
            {field: 'vat0', title: 'VAT0', format: 'price', visible: isExcel },
            {field: 'vat6', title: 'VAT6', format: 'price', visible: isExcel },
            {field: 'vat12', title: 'VAT12', format: 'price', visible: isExcel },
            {field: 'vat25', title: 'VAT25', format: 'price', visible: isExcel }
        ],
        buttons: [
            {title: 'Get invoice', onClick: getInvoice, loading: i => $scope.loadingStatus.getInvoice[i.id] },
            {title: 'Show', onClick: showPayments}
        ],
        searchButtons: [
            {title: 'Download as Excel', onClick: $scope.getExcel }
        ]
    };

    $scope.getInvoices = function(silentLoading) {
        var from = _.findWhere($scope.fields, {name: 'fromDate'}).value;
        var to = _.findWhere($scope.fields, {name: 'toDate'}).value;
        if ((from && from.getFullYear() < 1900) || (to && to.getFullYear() < 1900)) {
            return;
        }

        if (cancelPreviousRequest) {
            cancelPreviousRequest.resolve();
        }
        cancelPreviousRequest = $q.defer();

        var args = {};
        args.legal_entity_id = $rootScope.selectedSite.legal_entity_id;
        if (from) {
            args.fromDate = from.yyyymmdd();
        }
        if (to) {
            args.toDate = to.yyyymmdd();
        }
        args.unpaid = _.findWhere($scope.fields, {name: 'unpaid'}).value;
        args.credit = _.findWhere($scope.fields, {name: 'credit'}).value;

        $scope.loadingStatus.loading = !silentLoading;
        var allp = [];
        server.get('/api/economy/invoices/get', args, cancelPreviousRequest).then(function(data) {
            $rootScope.waitFor(['members', 'sites']).then(function() {
                paymentMap = {};
                angular.forEach(data, function(i) {
                    i.payer = $rootScope.getMember(i.payer_id);
                    i.payername = i.payer ? i.payer.name : null;
                    i.senddate = Date.newFull(i.senddate);
                    i.duedate = Date.newFull(i.duedate);
                    i.paydate = Date.newFull(i.paydate);
                    i.creditdate = Date.newFull(i.creditdate);
                    i.totalVAT = 0;
                    angular.forEach(i.vats, function(value, key) {
                        i.totalVAT = Number(value);
                        i['vat' + key] = value;
                    });
                    angular.forEach(i.payments, function(p) {
                        $rootScope.transformPayment(p);
                        paymentMap[p.id] = true;
                    });
                    i.payments = i.payments ? $scope.bundleTogether(i.payments, true) : [];
                    Array.prototype.push.apply(allp, i.payments);
                });
                invoices = data;
                $scope.broadcastChangeEvent(eventName, allp);
                $scope.loadingStatus.loading = false;
            });
        });
    };

    $scope.fields = [
        {name: 'fromDate', title: 'From', required: true, type: 'date', value: Date.firstDayLastMonth(), change: $scope.getInvoices },
        {name: 'toDate', title: 'To', required: true, type: 'date', value: Date.today(), change: $scope.getInvoices },
        {name: 'unpaid', title: 'Show only unpaid', required: true, type: 'checkbox', value: false, change: $scope.getInvoices },
        {name: 'credit', title: 'Show credit invoices', required: true, type: 'checkbox', value: true, change: $scope.getInvoices, visible: function() { return !_.findWhere($scope.fields, {name: 'unpaid'}).value; } }
    ];
    $scope.hideSubmitButton = true;
    $scope.noFormValidation = true;

    $timeout($scope.getInvoices, 0);

    live.subscribe({
        type: 'payment',
        scope: $scope,
        callback: function(eventData, event) {
            for (var i=0; i < event.data.length; ++i) {
                var p = event.data[i].id;
                if (paymentMap[p]) {
                    $scope.getInvoices(true);
                    return;
                }
            }
        }
    });
}]);

economy.controller('EconomyInvoicesDebtsCtrl', ['$rootScope', '$scope', '$filter', '$http', 'server', 'util', 'alertProvider', 'formatter', function($rootScope, $scope, $filter, $http, server, util, alertProvider, formatter) {
    $scope.loadingStatus = {
        getInvoice: []
    };
    $scope.fields = [
        {name: 'date', title: 'Debts at', required: true, type: 'date', value: Date.lastDayLastMonth() }
    ];

    $scope.getButtonText = function() {
        return 'Fetch invoice debts';
    };

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        const args = {
            date: $scope.fields[0].value.yyyymmdd(),
            legal_entity_id: $rootScope.selectedSite.legal_entity_id
        };
        server.get('/api/economy/debts/get', args).then(function(data) {
            $rootScope.waitFor(['members']).then(function() {
                angular.forEach(data, function(i) {
                    i.payer = $rootScope.getMember(i.payer_id);
                    i.senddate = Date.newFull(i.senddate);
                    i.duedate = Date.newFull(i.duedate);
                    i.paydate = Date.newFull(i.paydate);
                });
                $scope.invoices = data;
                $scope.loadingStatus.loading = false;
                $scope.invoicesConfig.countSuffixList = [$filter('translate')('invoice') + ', {0}'.format($scope.totalInvoiceDebts()), $filter('translate')('invoices') + ', {0}'.format($scope.totalInvoiceDebts())];
            });
        });
    };

    var isExcel = function(format) {
        return format == 'excel';
    };

    $scope.getExcel = function(config) {
        config.control.exportTo('excel').then(function(blob) {
            util.download($filter('translate')(config.getTitle()) + '.xlsx', null, null, blob);
        });
    };

    var getInvoice = function(i) {
        $scope.loadingStatus.getInvoice[i.id] = true;
        $http.get('/api/invoice/get?id=' + i.id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Invoice') + '.pdf', data, 'application/pdf');
        }).error(function() {
            alertProvider.show('error', 'Failed to get invoice');
        }).finally(function() {
            $scope.loadingStatus.getInvoice[i.id] = false;
        });
    };

    $scope.getImage = function(p) {
        return $rootScope.smallMemberImage(p.payer);
    };

    $scope.totalInvoiceDebts = function() {
        var totalInvoiceDebts = 0;
        angular.forEach($scope.invoices, function(invoice) {
            totalInvoiceDebts += Number(invoice.lefttopay);
        });
        return formatter.format('price', totalInvoiceDebts);
    };

    $scope.invoicesConfig = {
        getItems: function() {
            return $scope.invoices;
        },
        orderColumn: 'invoiceNumber',
        //rowClick: showPayments,
        getTitle: function() {
            return 'Invoice debts';
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'payer.name', title: 'Payer' },
            {field: 'invoiceNumber', title: 'Invoice number', showSum: false },
            {field: 'referenceNumber', title: 'OCR-number', showSum: false },
            {field: 'senddate', title: 'Invoice date', format: 'date' },
            {field: 'duedate', title: 'Due date', format: 'date' },
            {field: 'amount', title: 'Amount', format: 'price' },
            {field: 'lefttopay', title: 'Left to pay', format: 'price' },
            {field: 'totalVAT', title: 'VAT', format: 'price', visible: isExcel },
            {field: 'vat0', title: 'VAT0', format: 'price', visible: isExcel },
            {field: 'vat6', title: 'VAT6', format: 'price', visible: isExcel },
            {field: 'vat12', title: 'VAT12', format: 'price', visible: isExcel },
            {field: 'vat25', title: 'VAT25', format: 'price', visible: isExcel }
        ],
        buttons: [
            {title: 'Get invoice', onClick: getInvoice, loading: i => $scope.loadingStatus.getInvoice[i.id] },
//            {title: 'Show', onClick: showPayments}
        ],
        searchButtons: [
            {title: 'Download as Excel', onClick: $scope.getExcel }
        ]
    };
}]);

economy.controller('EconomyTransactionsCtrl', ['$rootScope', '$scope', '$filter', '$q', 'server', '$http', 'alertProvider', 'util', '$modal', 'confirm', 'paymentMethods', 'live', 'formatter', 'accounts', 'pdf', function($rootScope, $scope, $filter, $q, server, $http, alertProvider, util, $modal, confirm, paymentMethods, live, formatter, accounts, pdf) {
    var transactions = [];
    var cancelPreviousRequest;
    $scope.includePreliminary = true;
    $scope.loadingStatus = {};
    $scope.getImage = function(p) {
        return $rootScope.smallMemberImage(p.payer);
    };

    $scope.getPDF = function(config) {
        config.control.exportTo('pdf').then(function(blob) {
            util.download($filter('translate')(config.getTitle()) + '.pdf', null, null, blob);
        });
    };

    $scope.getAccountSummaryPDF = function(config) {
        var items = config.control.getFilteredItems();

        // Aggregate amounts per account
        var accountSummary = {};
        angular.forEach(items, function(transaction) {
            if (transaction.accounting && transaction.accounting.accounting) {
                angular.forEach(transaction.accounting.accounting, function(arow) {
                    var account = arow.account;
                    var amount = Number(arow.amount);
                    var name = transaction.accounting.accountnames[account] || '';

                    if (!accountSummary[account]) {
                        accountSummary[account] = { name: name, debit: 0, credit: 0 };
                    }

                    if (amount > 0) {
                        accountSummary[account].debit += amount;
                    } else {
                        accountSummary[account].credit += Math.abs(amount);
                    }
                });
            }
        });

        // Sort accounts numerically
        var sortedAccounts = Object.keys(accountSummary).sort(function(a, b) {
            return parseInt(a) - parseInt(b);
        });

        if (sortedAccounts.length === 0) {
            alertProvider.show('warning', $filter('translate')('No transactions to summarize'));
            return;
        }

        // Generate PDF
        pdf.load().then(function() {
            var doc = new PDFDocument();
            var stream = doc.pipe(blobStream());

            // Title
            doc.fontSize(20);
            doc.text($filter('translate')('Account summary'), 20, 20);

            // Subtitle with date range
            doc.fontSize(12);
            var fromField = _.findWhere($scope.fields, {name: 'fromDate'});
            var toField = _.findWhere($scope.fields, {name: 'toDate'});
            var from = fromField && fromField.value;
            var to = toField && toField.value;
            if (from && to && typeof from.yyyymmdd === 'function' && typeof to.yyyymmdd === 'function') {
                doc.text(from.yyyymmdd() + ' ' + $filter('translate')('to') + ' ' + to.yyyymmdd(), 20);
                doc.moveDown();
            }

            // Headers
            doc.fontSize(10);
            var y = doc.y;
            doc.text($filter('translate')('Account'), 20, y, {lineBreak: false});
            doc.text($filter('translate')('Account name'), 80, y, {lineBreak: false});
            doc.text($filter('translate')('ACCOUNTING_DEBIT'), 350, y, {lineBreak: false});
            doc.text($filter('translate')('ACCOUNTING_CREDIT'), 450, y, {lineBreak: false});
            doc.moveDown();

            var totalDebit = 0;
            var totalCredit = 0;

            // Account rows
            angular.forEach(sortedAccounts, function(account) {
                var data = accountSummary[account];

                if (doc.y > 700) {
                    doc.addPage();
                }

                y = doc.y;
                doc.text(account, 20, y, {lineBreak: false});
                doc.text(data.name, 80, y, {lineBreak: false});
                doc.text(formatter.format('float', data.debit), 350, y, {lineBreak: false});
                doc.text(formatter.format('float', data.credit), 450, y, {lineBreak: false});
                doc.moveDown();

                totalDebit += data.debit;
                totalCredit += data.credit;
            });

            // Totals
            doc.moveDown();
            y = doc.y;
            doc.fontSize(12);
            doc.text($filter('translate')('Total') + ':', 20, y, {lineBreak: false});
            doc.text(formatter.format('float', totalDebit), 350, y, {lineBreak: false});
            doc.text(formatter.format('float', totalCredit), 450, y, {lineBreak: false});

            doc.end();

            stream.on('finish', function() {
                var blob = stream.toBlob('application/pdf');
                util.download($filter('translate')('Account summary') + '.pdf', null, null, blob);
            });
        });
    };

    var showTransaction = function(t) {
        $modal.open({
                templateUrl: 'views/transaction.html',
                controller: 'TransactionCtrl',
                windowClass: 'huge-modal-window',
                resolve: {
                    options: function() {
                        return {transaction: t};
                    }
                }
            });
    };

    var getMethod = function() {
        return _.findWhere($scope.fields, {name: 'method'}).value;
    };

    var getCashRegister = function() {
        return _.findWhere($scope.fields, {name: 'cashregister'}).value;
    };

    var getCustomer = function() {
        return _.findWhere($scope.fields, {name: 'customer'}).value;
    };

    function getLedgers() {
        server.get('/api/economy/ledger/get').then(function(ledgers) {
            $scope.ledgers = ledgers;
        });
    }
    getLedgers();

    function getAccounts() {
        accounts.getAll().then(function(a) {
            $scope.accounts = a;
        });
    }
    getAccounts();

    function getCostCenters() {
        server.get('/api/economy/costcenter/get').then(function(result) {
            $scope.costcenters = result;
        });
    }
    getCostCenters();

    function getTags() {
        if (!$rootScope.hasModule('CostHandling')) { return; }
        server.get('/api/economy/accountingtemplate/tag/get').then(function(result) {
            $scope.tags = result;
        });
    }
    getTags();

    live.subscribe({
        type: 'ledger',
        scope: $scope,
        callback: getLedgers
    });

    $scope.getTransactions = _.throttle(function() {
        var tjournal = _.findWhere($scope.fields, {name: 'tjournal'}).value;
        var ledger = _.findWhere($scope.fields, {name: 'ledger'}).value;
        var number = _.findWhere($scope.fields, {name: 'number'}).value;
        var cashregister = getCashRegister();
        var from = _.findWhere($scope.fields, {name: 'fromDate'}).value;
        var to = _.findWhere($scope.fields, {name: 'toDate'}).value;
        var method = getMethod();
        var unknown = _.findWhere($scope.fields, {name: 'unknown'}).value;
        var debetKreditFails = _.findWhere($scope.fields, {name: 'debetKreditFails'}).value;
        var account = _.findWhere($scope.fields, {name: 'account'}).value;
        var costcenter = _.findWhere($scope.fields, {name: 'costcenter'}).value;
        var tags = _.findWhere($scope.fields, {name: 'tags'}).value;
        var customer = getCustomer();
        if (!tjournal && (!from || !to || from.getFullYear() < 1900 || to.getFullYear() < 1900)) {
            return;
        }

        if (cancelPreviousRequest) {
            cancelPreviousRequest.resolve();
        }
        cancelPreviousRequest = $q.defer();

        var args = {};
        args.legal_entity_id = $rootScope.selectedSite.legal_entity_id;
        if (tjournal || number) {
            args.tjournal = tjournal;
            args.number = number;
        } else {
            args.fromDate = from.yyyymmdd();
            args.toDate = to.yyyymmdd();
        }
        args.method = method ? method.id : null;
        args.cashregister = cashregister ? cashregister.id : null;
        args.preliminary = $scope.includePreliminary;
        args.ledger = ledger ? ledger.prefix : null;
        args.unknown = unknown;
        args.debetKreditFails = debetKreditFails;
        args.account = account ? account.id : null;
        args.costcenter_code = costcenter ? costcenter.code : null;
        if (customer) {
            args.customer = customer.id;
        }

        if ($rootScope.hasModule('CostHandling') && tags && tags.length) {
            args.tags = _.pluck(tags, 'id').join(',');
        }

        $scope.loadingStatus.loading = true;
        server.get('/api/economy/transactions/get', args, cancelPreviousRequest).then(function(data) {
            $rootScope.waitFor(['members', 'paymentmethods']).then(function() {
                $scope.useCostCenter = false;
                angular.forEach(data, function(i) {
                    i.payer = $rootScope.getMember(i.payer_id);
                    i.payername = i.payer ? i.payer.name : null;
                    i.created = Date.newFull(i.created);
                    i.accountingdate = Date.newFull(i.accountingdate);
                    if (i.accounting && !$scope.useCostCenter) {
                        if (_.some(i.accounting.accounting, function(r) { return !!r.costcenter_code; })) {
                            $scope.useCostCenter = true;
                        }
                    }
                    if (i.accrualparent_id) {
                        i.accrualparent = _.findWhere(data, { id: i.accrualparent_id });
                    }
                });
                transactions = data;
                $scope.loadingStatus.loading = false;
            });
        });
    }, 500);
    $scope.getExcel = function(config) {
        var customRows = [];
        for (var i=0; i < transactions.length; i++){
            if(transactions[i].accounting){
                for( var j=0; j < transactions[i].accounting.accounting.length; j++){
                    var newObj = {};
                    for (var key in transactions[i]) {
                        newObj[key] = transactions[i][key];
                    }
                    newObj.account = transactions[i].accounting.accounting[j].account;
                    newObj.costcenter = transactions[i].accounting.accounting[j].costcenter_code;
                    newObj.accountname = transactions[i].accounting.accountnames[transactions[i].accounting.accounting[j].account];

                    if(parseFloat(transactions[i].accounting.accounting[j].amount) > 0){
                        newObj.debit = transactions[i].accounting.accounting[j].amount;
                    }
                    else{
                        newObj.credit = transactions[i].accounting.accounting[j].amount.substring(1);
                    }
                    customRows.push(newObj);
                }
            }
        }

        config.control.exportTo('excel', null,customRows).then(function(blob) {
            util.download($filter('translate')(config.getTitle()) + '.xlsx', null, null, blob);
        });
    };

    var addTransaction = function(t) {
        $modal.open({
            templateUrl: 'views/economyaddincomemodal.html',
            controller: 'EconomyAddIncomeModalCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                options: function() {
                    return { origin: t.id, date: t.created, amount: t.amount, method: t.method };
                }
            }
        });
    };

    var removeTransaction = function(t) {
        confirm.show('Are you sure you want to remove this transaction from accounting?', {ladda: true}).then(function(resolve) {
            server.post('/api/economy/transaction/remove', null, {id: t.id}, 'Transaction was removed', 'Failed to remove transaction').then(function() {
                resolve();
                $scope.getTransactions();
            });
        });
    };

    var changeDate = function(t) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: ['$scope', '$controller', function($scope, $controller) {
                $controller('ChangeModalCtrl', {$scope});
                $scope.postUrl = '/api/economy/transaction/change';
                $scope.callCloseOnSuccess = true;
                $scope.item = t;
                $scope.titleSuffix  = () => util.t('transaction')

                $scope.fields = [
                    { name: 'created', title: 'Date', type: 'date', value: t.created }
                ];
            }]
        });
    }

    var findInvoice = function(t) {
        $modal.open({
            templateUrl: 'views/findinvoice2.html',
            controller: 'FindInvoiceModalCtrl2',
            windowClass: 'huge-modal-window',
            resolve: {
                transaction: function() {
                    return t;
                },
                paid: function() {
                    return true;
                }
            }
        }).result.then(function (matched) {
            if (matched) {
                $scope.getTransactions();
            }
        });
    };

    var canAdd = function(t) {
        return !t.readonly;
    };

    var canRemove = function(t) {
        return !t.readonly;
    };

    var canMatch = function(t) {
        return t.unknown && !t.invoice_id;
    };

    var canChangeDate = function(t) {
        return $scope.includePreliminary && !t.number && $scope.next && t.created < $scope.next;
    };

    $scope.getPaymentMethod = function(payment) {
        var methods = paymentMethods.getAll();
        return _.findWhere(methods, {id: payment.method});
    };

    $scope.getPaymentMethodName = function(payment) {
        if (payment.accrualaccounting) {
            return util.t('Accrual accounting');
        } else if (payment.cost) {
            return util.t('Debt');
        }
        var method = $scope.getPaymentMethod(payment);
        if (method) {
            return $filter('translate')(method.name);
        }
    };

    var getType = function(t) {
        return $filter('translate')(t.cost ? (t.userPayoutStatus == 'done' ? 'Payout' : 'Cost') : (t.claim ? 'Customer claim' : (t.clientaccount ? 'Client account' : 'Payment')));
    };

    var getAccountingForPdf = function(doc, transaction) {
        if (doc.y > 600) {
            doc.addPage();
        }
        var dstart = $scope.useCostCenter ? 400 : 300;

        doc.moveDown();
        doc.fontSize(12);
        doc.text(transaction.number, 20, doc.y, {lineBreak: false});
        doc.text(formatter.format('date', transaction.created), 100, doc.y, {lineBreak: false});
        doc.fontSize(10);
        doc.moveDown();
        doc.text($filter('translate')('Account'), 20, doc.y, {lineBreak: false});
        doc.text($filter('translate')('Account name'), 100, doc.y, {lineBreak: false});
        if ($scope.useCostCenter) {
            doc.text('Kostnadsställe', 300, doc.y, {lineBreak: false});
        }
        doc.text('Debet', dstart, doc.y, {lineBreak: false});
        doc.text('Kredit', dstart + 100, doc.y, {lineBreak: false});
        doc.moveDown();
        var debetSum = 0;
        var kreditSum = 0;
        angular.forEach(transaction.accounting.accounting, function(arow) {
            var account = arow.account;
            var amount = Number(arow.amount);
            var name = transaction.accounting.accountnames[account];
            doc.text(account, 20, doc.y, {lineBreak: false});
            doc.text(name, 100, doc.y, {lineBreak: false});
            if ($scope.useCostCenter) {
                doc.text(arow.costcenter_code || '', 300, doc.y, {lineBreak: false});
            }
            doc.text(Math.abs(amount), dstart + (amount < 0 ? 100 : 0), doc.y, {lineBreak: false});
            doc.moveDown();

            if (amount > 0) {
                debetSum += amount;
            } else {
                kreditSum += -amount;
            }
        });
        var y = doc.y;
        doc.text('SUMMA:', 0, doc.y, {align: 'right', width: dstart-20, lineBreak: false });
        doc.text(formatter.format('float', debetSum), dstart, y, {lineBreak: false});
        doc.text(formatter.format('float', kreditSum), dstart + 100, y, {lineBreak: false});
        doc.moveDown();
    };

    $scope.itemNames = ['transaction', 'transactions'];

    $scope.config = {
        getItems: function() {
            return transactions;
        },
        countSuffix: function() {
            return $filter('translate')($scope.itemNames[$scope.config.control.getFilteredItems().length == 1 ? 0 : 1]);
        },
        orderColumn: 'created',
        getTitle: function() {
            if ($scope.includePreliminary) {
                return 'Preliminary accounting entries';
            }
            return 'Daybook';
        },
        getSubTitle: function() {
            var from = _.findWhere($scope.fields, {name: 'fromDate'}).value;
            var to = _.findWhere($scope.fields, {name: 'toDate'}).value;
            return from.yyyymmdd() + ' ' + $filter('translate')('to') + ' ' + to.yyyymmdd();
        },
        giveFocus: function() {
            return false;
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'payer.name', title: 'Customer' },
            {field: 'number', title: 'Verification number'},
            {field: 'journal_id', title: 'Verification main ledger', format: 'number', showSum: false },
            {field: 'created', title: 'Date', format: 'date'},
            {field: 'account', title: 'Account', format: 'number', visible: function(type){ return type == 'excel'}},
            {field: 'accountname', title:'Account name', visible: function(type){ return type == 'excel'}},
            {field: 'costcenter', title:'Cost center', format: 'string', visible: function(type){ return type == 'excel'}},
            {field: 'debit', title:'Debit', format: 'number', visible: function(type){ return type == 'excel'}},
            {field: 'credit', title:'Credit', format: 'number', visible: function(type){ return type == 'excel'}},
            {field: 'amount', title: 'Amount', format: 'price', visible: function(type){ return type != 'excel'} },
            {field: 'claim', title: 'Type', getValue: getType, visible: function(type){ return type != 'excel'}},
            {field: 'method', title: 'Payment method', getValue: $scope.getPaymentMethodName, visible: function(type){ return type != 'excel'}},
            {field: 'accounting', title: 'Accounting', renderPdf: getAccountingForPdf, visible: function(type) { return type == 'pdf'; } }
        ],
        rowClick: showTransaction,
        buttons: [
            { title: 'Show', onClick: showTransaction },
            { title: 'Find matching invoice', onClick: findInvoice, visible: canMatch },
            { title: 'Create accounting post', onClick: addTransaction, visible: canAdd },
            { title: 'Remove from accounting', onClick: removeTransaction, visible: canRemove, buttonClass: 'btn-danger' },
            { title: 'Change', onClick: changeDate, visible: canChangeDate, buttonClass: 'btn-warning' }
        ],
        searchButtons: [
            {title: 'Download as Excel', onClick: $scope.getExcel, visible: function() { return !$scope.includePreliminary; } },
            {title: 'Download daybook', onClick: $scope.getPDF, visible: function() { return !$scope.includePreliminary; } },
            {title: 'Download summary', onClick: $scope.getAccountSummaryPDF, visible: function() { return !$scope.includePreliminary; } }
        ]
    };

    var showDates = function() {
        return !_.findWhere($scope.fields, {name: 'tjournal'}).value && !_.findWhere($scope.fields, {name: 'number'}).value;
    };

    var getAccountName = function(a) {
        return a.name + ', ' + a.id;
    };

    $scope.fields = [
        {name: 'tjournal', title: 'Verification main ledger', required: false, type: 'number', change: $scope.getTransactions },
        {name: 'ledger', title: 'Ledger', required: false, type: 'select', options: function() { return $scope.ledgers; }, change: $scope.getTransactions, visible: function() { return $scope.ledgers && $scope.ledgers.length; } },
        {name: 'number', title: 'Verification number', required: false, type: 'number', change: $scope.getTransactions },
        {name: 'method', title: 'Payment method', required: false, type: 'paymentmethod' },
        {name: 'cashregister', title: 'Cashier', required: false, type: 'cashier' },
        {name: 'customer', title: 'Customer', required: false, type: 'customer' },
        {name: 'unknown', title: 'Show unknown', required: false, type: 'checkbox', change: $scope.getTransactions },
        {name: 'debetKreditFails', title: 'Visa debet/kredit-fel', required: false, type: 'checkbox', change: $scope.getTransactions, visible: function() { return $rootScope.currentStaff.superUser; } },
        {name: 'account', title: 'Account', required: false, type: 'select', change: $scope.getTransactions, options: function() { return $scope.accounts; }, getName: getAccountName },
        {name: 'costcenter', title: 'Cost center', required: false, type: 'select', change: $scope.getTransactions, options: function() { return $scope.costcenters; }, visible: function() { return $scope.costcenters && $scope.costcenters.length; } },
        {name: 'fromDate', title: 'From', required: true, type: 'date', visible: showDates, value: Date.firstDayLastMonth(), change: $scope.getTransactions },
        {name: 'toDate', title: 'To', required: true, type: 'date', visible: showDates, value: Date.today(), change: $scope.getTransactions },
        {name: 'tags', title: 'Tags', required: false, type: 'multiselect', options: function() { return $scope.tags; }, useId: true, visible: function() { return $rootScope.hasModule('CostHandling'); }, change: $scope.getTransactions },
    ];
    $scope.hideSubmitButton = true;
    $scope.noFormValidation = true;

    $scope.$watch(getMethod, $scope.getTransactions);
    $scope.$watch(getCashRegister, $scope.getTransactions);
    $scope.$watch(getCustomer, $scope.getTransactions);

    live.subscribe({
        type: 'accounting',
        callback: $scope.getTransactions
    });
}]);

economy.controller('EconomyDaybookCtrl', ['$rootScope', '$scope', '$controller', 'fileManager', function($rootScope, $scope, $controller, fileManager) {
    $controller('EconomyTransactionsCtrl', {$scope: $scope});
    $scope.includePreliminary = false;
    _.findWhere($scope.fields, {name: 'unknown'}).visible = function() { return false; };
    $scope.itemNames = ['accounting entry', 'accounting entries'];

    $scope.openFileManager = function() {
        fileManager.open({
            originType: 'accounting',
            visibleTabs: 'files',
            mode: 'displayFiles'
        });
    };

    $scope.config.orderColumn = 'number';
    $scope.config.searchButtons.push({title: 'Show archive', onClick: $scope.openFileManager});

    $scope.getTransactions();
}]);

economy.controller('EconomyPreliminaryTransactionsCtrl', ['$rootScope', '$scope', '$controller', '$modal', 'server', function($rootScope, $scope, $controller, $modal, server) {
    $controller('EconomyTransactionsCtrl', {$scope: $scope});
    $scope.includePreliminary = true;
    $scope.itemNames = ['preliminary accounting entry', 'preliminary accounting entries'];
    _.findWhere($scope.fields, {name: 'tjournal'}).visible = function() { return false; };
    _.findWhere($scope.fields, {name: 'number'}).visible = function() { return false; };
    _.findWhere($scope.config.columns, {field: 'number'}).visible = function() { return false; };
    _.findWhere($scope.config.columns, {field: 'journal_id'}).visible = function() { return false; };

    $scope.addTransactionEntry = function() {
        $modal.open({
            templateUrl: 'views/addtransactionentrymodal.html',
            controller: 'AddTransactionEntryModalCtrl'
        });
    };

    $scope.config.searchButtons.push({title: 'Add transaction', onClick: $scope.addTransactionEntry});

    $scope.next = null;
    const args = {legal_entity_id: $rootScope.selectedSite.legal_entity_id };
    server.get('/api/economy/accounting/next', args).then(function(result) {
        $scope.next = Date.newFull(result.next)?.clearTime();
    });

    $scope.getTransactions();
}]);

economy.controller('EconomyAccountingCtrl', ['$rootScope', '$scope', '$controller', '$filter',  'server', 'util', 'fileManager', function($rootScope, $scope, $controller, $filter, server, util, fileManager) {
    $controller('EconomyTransactionsCtrl', {$scope: $scope});
    $scope.includePreliminary = true;
    $scope.itemNames = ['preliminary accounting entry', 'preliminary accounting entries'];

    _.findWhere($scope.fields, {name: 'tjournal'}).visible = function() { return false; };
    _.findWhere($scope.fields, {name: 'ledger'}).visible = function() { return false; };
    _.findWhere($scope.fields, {name: 'number'}).visible = function() { return false; };
    _.findWhere($scope.fields, {name: 'method'}).visible = function() { return false; };
    _.findWhere($scope.fields, {name: 'cashregister'}).visible = function() { return false; };
    _.findWhere($scope.fields, {name: 'customer'}).visible = function() { return false; };
    _.findWhere($scope.fields, {name: 'unknown'}).visible = function() { return false; };
    _.findWhere($scope.fields, {name: 'account'}).visible = function() { return false; };
    _.findWhere($scope.fields, {name: 'costcenter'}).visible = function() { return false; };
    _.findWhere($scope.fields, {name: 'debetKreditFails'}).visible = function() { return false; };

    _.findWhere($scope.fields, {name: 'fromDate'}).value = null;
    _.findWhere($scope.fields, {name: 'fromDate'}).readonly = true;
    _.findWhere($scope.fields, {name: 'toDate'}).value = Date.lastDayLastMonth();
    _.findWhere($scope.config.columns, {field: 'number'}).visible = function() { return false; };
    _.findWhere($scope.config.columns, {field: 'journal_id'}).visible = function() { return false; };

    $scope.getNumberOfTransactions = function() {
        if ($scope.config.control) {
            return $scope.config.control.getNumberOfItems();
        }
    };

    $scope.config.searchButtons = [];

    var getNext = function() {
        const args = {legal_entity_id: $rootScope.selectedSite.legal_entity_id };
        server.get('/api/economy/accounting/next', args).then(function(result) {
            var last = Date.newFull(result.last);
            var next = Date.newFull(result.next);
            _.findWhere($scope.fields, {name: 'fromDate'}).value = next;
            _.findWhere($scope.fields, {name: 'fromDate'}).readonly = last;
            $scope.showFirstTimeMessage = !last;
            if (next > _.findWhere($scope.fields, {name: 'toDate'}).value) {
                _.findWhere($scope.fields, {name: 'toDate'}).value = next;
            }
            $scope.getTransactions();
        });
    };

    $controller('AddCtrl', {$scope: $scope});

    var getNumberOfUnknowns = function() {
        if ($scope.config.control) {
            return $scope.config.control.getItems().filter(function(i) { return i.unknown; }).length;
        }
    };

    $scope.toDateIsPastDate = function() {
        var to = _.findWhere($scope.fields, {name: 'toDate'}).value;
        return to && to.isPastDate();
    };

    $scope.canSubmit = function() {
        var fromDate = _.findWhere($scope.fields, {name: 'fromDate'}).value;
        var to = _.findWhere($scope.fields, {name: 'toDate'}).value;
        var dateok = fromDate && to && to.isPastDate() && to.clone().clearTime() >= fromDate.clone().clearTime();
        var hasUnknowns = getNumberOfUnknowns() > 0;
        var unknownOk = !hasUnknowns;
        var moreThanZero = $scope.getNumberOfTransactions() && $scope.getNumberOfTransactions() > 0;
        return dateok && unknownOk && moreThanZero;
    };

    $scope.submit = function() {
        var item = $scope.getSubmitItem();
        $scope.loadingStatus.doaccounting = true;
        var data = {};
        data.fromDate = item.fromDate;
        data.toDate = item.toDate;
        data.legal_entity_id = $rootScope.selectedSite.legal_entity_id;
        server.post2('/api/accounting/export', data, { errorAlert: 'Failed to get accounting export' }).then(function(downloadKey) {
            fileManager.downloadFile(downloadKey);
            getNext();
            $scope.loadingStatus.doaccounting = false;
        }, function() {
            $scope.loadingStatus.doaccounting = false;
        });
    };

    $scope.hideSubmitButton = true;

    getNext();
}]);

economy.controller('PaymentFileCtrl', ['$rootScope', '$scope', 'options', 'server', function($rootScope, $scope, options, server) {
    var payments;
    server.get('/api/economy/parsefile', {file_id: options.bgcfile_id}).then(function(bgcfile) {
        payments = bgcfile.inbetalningar;
        angular.forEach(payments, function(p) {
            p.betalningsdag = Date.newFull(p.betalningsdag);
        });
    });

    var getStatus = function(p) {
        if (p.betald) {
            return 'Godkänd betalning, betalningen är genomförd.';
        } else if (p.pengarsaknas) {
            return 'Täckning saknas, betalningen har inte genomförts.';
        } else if (p.autogirosaknas) {
            return 'Koppling till Autogiro saknas (bankkontot avslutat), Annan orsak. Betalningen har inte genomförts.';
        } else if (p.retry) {
            return 'Förnyad täckning, betalningen har inte genomförts men nytt försök ska göras om avtal finns.';
        }
    };

    $scope.config = {
        getItems: function() { return payments; },
        hideSearch: true,
        columns: [
            {field: 'betalningsdag', title: 'Betalningsdag', format: 'date' },
            {field: 'betalarnummer', title: 'Betalarnummer'},
            {field: 'betalningsreferens', title: 'Betalningsreferens' },
            {field: 'bankgironummer', title: 'Bankgironummer' },
            {field: 'belopp', title: 'Belopp', format: 'price' },
            {field: 'status', title: 'Status', getValue: getStatus},
            {field: 'faktura.info', title: 'Info'}
        ]
    };
}]);

economy.controller('TransactionCtrl', ['$rootScope', '$scope', 'options', '$http', 'server', 'alertProvider', 'util', '$filter', '$modal', 'paymentMethods', 'fileManager', 'pdf', function($rootScope, $scope, options, $http, server, alertProvider, util, $filter, $modal, paymentMethods, fileManager, pdf) {
    $scope.transaction = options.transaction;
    $scope.loadingStatus = {
        getReceipt: false,
        getCheckoutReceipt: false,
        getTransactionJournal: false,
        getInvoice: false,
        getZReport: false,
        getPayoutFile: false,
        getAdyenReport: false
    };

    var setAccounting = function() {
        if ($scope.transaction.accounting) {
            $scope.accounting = [];
            $scope.debetSum = 0;
            $scope.kreditSum = 0;
            $scope.useCostCenter = false;
            angular.forEach($scope.transaction.accounting.accounting, function(arow) {
                var account = arow.account;
                var amount = arow.amount;
                var name = $scope.transaction.accounting.accountnames[account] || '';
                var debet = amount > 0 ? amount : null;
                var kredit = amount < 0 ? Math.abs(amount) : null;
                $scope.accounting.push( { account: account, accountname: name, debet: debet, kredit: kredit, costcenter_code: arow.costcenter_code } );
                $scope.debetSum += debet ? Number(debet) : 0;
                $scope.kreditSum += kredit ? Number(kredit) : 0;
                if (arow.costcenter_code) {
                    $scope.useCostCenter = true;
                }
            });
        }
    };

    if (!$scope.transaction.accounting) {
        server.get('/api/economy/transaction/accounting', {id: $scope.transaction.id}).then(function(accounting) {
            $scope.transaction.accounting = accounting;
            setAccounting();
        });
    } else {
        setAccounting();
    }

    $scope.getPaymentMethod = function(payment) {
        var methods = paymentMethods.getAll();
        return _.findWhere(methods, {id: payment.method});
    };

    $scope.getPaymentMethodName = function(payment) {
        if (payment.accrualaccounting) {
            return util.t('Accrual accounting');
        }
        var method = $scope.getPaymentMethod(payment);
        if (method) {
            return $filter('translate')(method.name);
        } else if (payment.method == 'multi') {
            return $filter('translate')('Multiple');
        }
    };

    $scope.closeAndGotoCustomer = function(customer) {
        $scope.$close();
        $rootScope.gotoCustomer(customer);
    };

    $scope.getCheckoutReceipt = function() {
        $scope.loadingStatus.getCheckoutReceipt = true;
        $http.get('/api/payment/receipt/getCheckout?id=' + $scope.transaction.checkoutreceipt_id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Receipt') + '.pdf', data, 'application/pdf');
        }).error(function() {
            alertProvider.show('error', 'Failed to get receipt');
        }).finally(function() {
            $scope.loadingStatus.getCheckoutReceipt = false;
        });
    };

    $scope.getReceipt = function() {
        $scope.loadingStatus.getReceipt = true;
        $http.get('/api/payment/receipt/getForBundle?id=' + $scope.transaction.bundle_id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Receipt') + '.pdf', data, 'application/pdf');
        }).error(function() {
            alertProvider.show('error', 'Failed to get receipt');
        }).finally(function() {
            $scope.loadingStatus.getReceipt = false;
        });
    };

    $scope.showBgcFile = function() {
        $modal.open({
            templateUrl: 'views/paymentfile.html',
            windowClass: 'huge-modal-window',
            controller: 'PaymentFileCtrl',
            resolve: {
                options: function() {
                    return {bgcfile_id: $scope.transaction.bgcfile_id};
                }
            }
        });
    };

    $scope.getCashRegister = function() {
        if ($scope.transaction.cashregister_id) {
            return _.findWhere($rootScope.cashregisters, {id: $scope.transaction.cashregister_id});
        }
    };

    $scope.getTransactionJournal = function() {
        $scope.loadingStatus.getTransactionJournal = true;
        $http.get('/api/stats/transactionjournal?id=' + $scope.transaction.journal_id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Verification main ledger') + '.pdf', data, 'application/pdf');
        }).error(function() {
            alertProvider.show('error', 'Failed to get journal');
        }).finally(function() {
            $scope.loadingStatus.getTransactionJournal = false;
        });
    };

    $scope.getInvoice = function() {
        $scope.loadingStatus.getInvoice = true;
        $http.get('/api/invoice/get?id=' + $scope.transaction.invoice_id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Invoice') + '.pdf', data, 'application/pdf');
        }).error(function() {
            alertProvider.show('error', 'Failed to get invoice');
        }).finally(function() {
            $scope.loadingStatus.getInvoice = false;
        });
    };

    $scope.getZReport = function() {
        $scope.loadingStatus.getZReport = true;
        $http.get('/api/economy/zreport/get?id=' + $scope.transaction.checkoutreceipt_id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Z report') + '.pdf', data, 'application/pdf');
        }).error(function() {
            alertProvider.show('error', 'Failed to get data');
        }).finally(function() {
            $scope.loadingStatus.getZReport = false;
        });
    };

    $scope.getExternalTransactionId = function() {
        var id = $scope.transaction.source_data && $scope.transaction.source_data.id;
        if (id && id.startsWith('txn')) {
            id = $scope.transaction.source_data.source;
        }
        return id;
    };

    $scope.getIncomeFile = function() {
        fileManager.downloadFile($scope.transaction.incomefile_id);
    };

    $scope.getPayoutFile = function() {
        $scope.loadingStatus.getPayoutFile = true;
        $http.get('/api/economy/clientaccount/payouts/get?id=' + $scope.transaction.payoutfile_id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Payout file') + '.pdf', data, 'application/pdf');
        }).error(function() {
            alertProvider.show('error', 'Failed to get data');
        }).finally(function() {
            $scope.loadingStatus.getPayoutFile = false;
        });
    };

    $scope.getAdyenReport = function() {
        $scope.loadingStatus.getAdyenReport = true;

        const batchNumber = $scope.transaction.adyen_batch_number;
        const legalEntityId = $scope.transaction.legal_entity.id;
        const legalEntityName = $scope.transaction.legal_entity.name;
        const url = `/api/adyen/accounting/report/get?batch_number=${batchNumber}&legal_entity_id=${legalEntityId}`;

        $http.get(url, {responseType: 'blob'}).success(function(data) {
            let fileName = `${$filter('translate')('Payout report')}_${legalEntityName}_batch_${batchNumber}`;
            util.download(fileName , null, null, data);
        }).error(function() {
            alertProvider.show('error', 'Failed to get data');
        }).finally(function() {
            $scope.loadingStatus.getAdyenReport = false;
        });
    };

    $scope.showVerification = function() {
        $modal.open({
                templateUrl: 'views/verification.html',
                controller: 'VerificationCtrl',
                windowClass: 'huge-modal-window',
                resolve: {
                    options: function() {
                        return {transaction: $scope.transaction};
                    }
                }
            });
    };

    $scope.showAccrualParent = function() {
        $modal.open({
            templateUrl: 'views/transaction.html',
            controller: 'TransactionCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                options: function() {
                    return {transaction: $scope.transaction.accrualparent};
                }
            }
        });
    };

    $scope.getAccrualData = function() {
        $modal.open({
            templateUrl: 'views/accrualaccountingdatamodal.html',
            windowClass: 'huge-modal-window',
            controller: 'AccrualAccountingDataModalCtrl',
            resolve: {
                transaction: function() {
                    return $scope.transaction;
                }
            }
        });

    };

    $scope.showPayoutOrigin = function() {
        $modal.open({
            templateUrl: 'views/transaction.html',
            controller: 'TransactionCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                options: function() {
                    return {transaction: $scope.transaction.payoutorigin};
                }
            }
        });
    };

    $scope.getValuecardData = function() {
        $modal.open({
            templateUrl: 'views/valuecardaccountingdatamodal.html',
            resolve: {
                transaction: function() {
                    return $scope.transaction;
                }
            },
            controller: ['$scope', '$filter', 'transaction', function($scope, $filter, transaction) {
                $scope.data = transaction.source_data.valuecard;
                $scope.data.amount = transaction.amount;
                $scope.getCustomerName = function() {
                    return transaction.payer ? transaction.payer.name : $filter('translate')('Anonymous');
                };
            }]
        });
    };

    $scope.getTravelCompensationData = function() {
        pdf.load().then(function() {
            var doc = new PDFDocument();
            var stream = doc.pipe(blobStream());
            var data = $scope.transaction.source_data.travelcompensation;
            var x = 20;

            doc.fontSize(28);
            doc.text(util.t('Travel bill'), x, 30);

            doc.fontSize(20);
            doc.text($scope.transaction.created.yyyymmdd(), x, doc.y);
            doc.fontSize(18);
            doc.text($scope.transaction.payer.name);
            doc.moveDown();

            var y = doc.y;

            var addRow = function(title, value, indent) {
                y = doc.y;
                doc.fontSize(18);
                doc.text(title + ':', (!!indent ? x*2 : x), y);
                doc.fontSize(15);
                doc.text(value, 400, y+2);
            };

            addRow(util.t('Departure'), data.departure);
            addRow(util.t('Journey home'), data.journeyHome);
            doc.moveDown();

            addRow(util.t('Own car'), util.t(!!data.droveOwnCar ? 'Yes' : 'No'));
            if (!!data.droveOwnCar) {
                addRow(util.t('Number of miles'), data.numberMiles + ' ' + util.t('miles'));
            }
            doc.moveDown();
            doc.moveDown();

            addRow(util.t('The company has offered food'), util.t(!!data.companyOfferedFood ? 'Yes' : 'No'));
            if (!!data.companyOfferedFood) {
                doc.moveDown();
                doc.fontSize(18);
                doc.text(util.t('Half days'), x, doc.y);
                addRow(util.t('Breakfast'), data.halfDaysBreakfast || 0, true);
                addRow(util.t('Lunch / Dinner'), data.halfDaysLunchDinner || 0, true);

                doc.moveDown();
                doc.fontSize(18);
                doc.text(util.t('Full days'), x, doc.y);
                addRow(util.t('Breakfast'), data.fullDaysBreakfast || 0, true);
                addRow(util.t('Lunch / Dinner'), data.fullDaysLunchDinner || 0, true);
            }

            if ($scope.transaction.comment) {
                doc.moveDown();
                doc.moveDown();
                doc.fontSize(18);
                doc.text(util.t('Comment') + ':', x, doc.y);
                doc.fontSize(15);
                doc.text($scope.transaction.comment, x*2, doc.y);
            }

            doc.end();

            stream.on('finish', function() {
                var filename = util.t('Travel bill') + '_' + $scope.transaction.created.yyyymmdd();
                pdf.download(stream, filename);
            });

        });
    };

}]);

economy.controller('VerificationCtrl', ['$rootScope', '$scope', 'options', '$http', 'server', 'alertProvider', 'util', '$filter', '$modal', function($rootScope, $scope, options, $http, server, alertProvider, util, $filter, $modal) {
    $scope.transaction = options.transaction;
    $scope.loadingStatus = {
        getCheckoutReceipt: false,
        getReceipt: false,
        getInvoice: false,
        getZReport: false,
        getPayoutFile: false,
        getAdyenReport: false
    };

    var setAccounting = function() {
        if ($scope.transaction.accounting) {
            $scope.accounting = [];
            $scope.debetSum = 0;
            $scope.kreditSum = 0;
            angular.forEach(_.keys($scope.transaction.accounting.accounting), function(account) {
                var value = $scope.transaction.accounting.accounting[account];
                var name = $scope.transaction.accounting.accountnames[account] || '';
                var debet = value > 0 ? value : null;
                var kredit = value < 0 ? Math.abs(value) : null;
                $scope.accounting.push( { account: account, accountname: name, debet: debet, kredit: kredit } );
                $scope.debetSum += debet ? Number(debet) : 0;
                $scope.kreditSum += kredit ? Number(kredit) : 0;
            });
        }
    };

    if (!$scope.transaction.accounting) {
        server.get('/api/economy/transaction/accounting', {id: $scope.transaction.id}).then(function(accounting) {
            $scope.transaction.accounting = accounting;
            setAccounting();
        });
    } else {
        setAccounting();
    }

    $scope.closeAndGotoCustomer = function(customer) {
        $scope.$close();
        $rootScope.gotoCustomer(customer);
    };

    $scope.getCheckoutReceipt = function() {
        $scope.loadingStatus.getCheckoutReceipt = true;
        $http.get('/api/payment/receipt/getCheckout?id=' + $scope.transaction.checkoutreceipt_id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Receipt') + '.pdf', data, 'application/pdf');
        }).error(function() {
            alertProvider.show('error', 'Failed to get receipt');
        }).finally(function() {
            $scope.loadingStatus.getCheckoutReceipt = false;
        });
    };

    $scope.getReceipt = function() {
        $scope.loadingStatus.getReceipt = true;
        $http.get('/api/payment/receipt/getForBundle?id=' + $scope.transaction.bundle_id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Receipt') + '.pdf', data, 'application/pdf');
        }).error(function() {
            alertProvider.show('error', 'Failed to get receipt');
        }).finally(function() {
            $scope.loadingStatus.getReceipt = false;
        });
    };

    $scope.showBgcFile = function() {
        $modal.open({
            templateUrl: 'views/paymentfile.html',
            windowClass: 'huge-modal-window',
            controller: 'PaymentFileCtrl',
            resolve: {
                options: function() {
                    return {bgcfile_id: $scope.transaction.bgcfile_id};
                }
            }
        });
    };

    $scope.getCashRegister = function() {
        if ($scope.transaction.cashregister_id) {
            return _.findWhere($rootScope.cashregisters, {id: $scope.transaction.cashregister_id});
        }
    };

    $scope.getInvoice = function() {
        $scope.loadingStatus.getInvoice = true;
        $http.get('/api/invoice/get?id=' + $scope.transaction.invoice_id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Invoice') + '.pdf', data, 'application/pdf');
        }).error(function() {
            alertProvider.show('error', 'Failed to get invoice');
        }).finally(function() {
            $scope.loadingStatus.getInvoice = false;
        });
    };

    $scope.getZReport = function() {
        $scope.loadingStatus.getZReport = true;
        $http.get('/api/economy/zreport/get?id=' + $scope.transaction.checkoutreceipt_id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Z report') + '.pdf', data, 'application/pdf');
        }).error(function() {
            alertProvider.show('error', 'Failed to get data');
        }).finally(function() {
            $scope.loadingStatus.getZReport = false;
        });
    };

    $scope.getExternalTransactionId = function() {
        var id = $scope.transaction.source_data && $scope.transaction.source_data.id;
        if (id && id.startsWith('txn')) {
            id = $scope.transaction.source_data.source;
        }
        return id;
    };

    $scope.getPayoutFile = function() {
        $scope.loadingStatus.getPayoutFile = true;
        $http.get('/api/economy/clientaccount/payouts/get?id=' + $scope.transaction.payoutfile_id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Payout file') + '.pdf', data, 'application/pdf');
        }).error(function() {
            alertProvider.show('error', 'Failed to get data');
        }).finally(function() {
            $scope.loadingStatus.getPayoutFile = false;
        });
    };

    $scope.getAdyenReport = function() {
        $scope.loadingStatus.getAdyenReport = true;

        const batchNumber = $scope.transaction.adyen_batch_number;
        const legalEntityId = $scope.transaction.legal_entity.id;
        const legalEntityName = $scope.transaction.legal_entity.name;
        const url = `/api/adyen/accounting/report/get?batch_number=${batchNumber}&legal_entity_id=${legalEntityId}`;

        $http.get(url, {responseType: 'blob'}).success(function(data) {
            let fileName = `${$filter('translate')('Payout report')}_${legalEntityName}_batch_${batchNumber}`;
            util.download(fileName , null, null, data);
        }).error(function() {
            alertProvider.show('error', 'Failed to get data');
        }).finally(function() {
            $scope.loadingStatus.getAdyenReport = false;
        });
    };
}]);


economy.controller('InvoiceUnconfirmedMasterCtrl', ['$rootScope', '$scope', 'server', function($rootScope, $scope, server) {
    var refetchNumUnconfirmed = function() {
        server.get('/api/payment/invoices/unconfirmed').then(function(result) {
            $rootScope.numUnconfirmedInvoices = result;
        });
    };
    refetchNumUnconfirmed();

    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        if (message.type == 'payment') {
            refetchNumUnconfirmed();
        }
    });

    $scope.$on('$destroy', function () {
        removeServerChange();
    });
}]);

economy.controller('CreditInvoiceCtrl', ['$rootScope', '$scope', 'server', 'invoice', 'hasPayments', 'hasStock', 'paymentMethods', 'util', 'BankAccount', function($rootScope, $scope, server, invoice, hasPayments, hasStock, paymentMethods, util, BankAccount) {
    $scope.loadingStatus = {};
    $scope.hasPayments = hasPayments;

    function getField(name) {
        return _.findWhere($scope.fields, {name: name});
    }

    var invoiceDetails;
    server.get('/api/invoice/get_details', {id: invoice}).then(function(result) {
        invoiceDetails = result;
        if(invoiceDetails.paid_amount) {
            getField('amount').value = invoiceDetails.paid_amount;
        }
    });

    $scope.setInitialValues = function() {
        _.findWhere($scope.fields, {name: 'method'}).value = _.findWhere(paymentMethods.getRefund(), {id: 'bank'});
        _.findWhere($scope.fields, {name: 'update_stock'}).value = true;
    };

    function isMethod(name) {
        var method = getField('method');
        return method.value && method.value.id == name;
    }

    function payoutAmount() {
        return invoiceDetails && invoiceDetails.paid_amount;
    }

    function visibleIfAutoPayouts() {
        return payoutAmount() && $rootScope.hasModule('Payout') && isMethod('bank');
    }

    function chooseBankAccount() {
        if(!invoiceDetails || !invoiceDetails.payer_id) {return;}
        var payer = $rootScope.getMember(invoiceDetails.payer_id);
        BankAccount.selectDialog(payer).then(function(account) {
            getField('bankaccount').value = account;
        });
    }

    $scope.fields = [
        {name: 'sendMail', title: 'E-mail', type: 'checkbox' },
        {name: 'sendSms', title: 'SMS', type: 'checkbox', visible: function() { return $rootScope.hasModule('SMS'); } },
        {name: 'messageToCustomer', title: 'Message', type: 'textarea' },
        {name: 'amount', title: 'Amount', readonly: true, type: 'price', visible: function() {return invoiceDetails && invoiceDetails.paid_amount;} },
        {name: 'method', title: 'Payment method', type: 'paymentmethod', required: true, visible: function() { return hasPayments; }, options: {refund: true}, useId: true },
        {hint: 'CREDITINVOICESTOCK', visible: function() { return hasStock; } },
        {name: 'update_stock', title: 'Update stock', type: 'checkbox', visible: function() { return hasStock; } },

        {name: 'nearest', title: 'Nearest possible day', required: false, type: 'checkbox', visible: visibleIfAutoPayouts },
        {name: 'date', title: 'Payment date', required: true, type: 'date', value: Date.today(), visible: function() { return visibleIfAutoPayouts() && !getField('nearest').value; } },
        {name: 'bankaccount', title: 'Account', required: true, visible: visibleIfAutoPayouts, type: 'customobject', useId: true,
            getName: function() { return this.value.fullname; }, buttonClick: chooseBankAccount, buttonTitle: 'Choose' },
        {name: '_', hint: 'REPAY_VALUECARD_HINT', hintClass: 'alert-info', visible: function() { return !visibleIfAutoPayouts() && !isMethod('valuecard') && payoutAmount(); } },
        {name: '_', hint: 'REPAY_VALUECARD_BANK_HINT', hintClass: 'alert-info', visible: function() { return visibleIfAutoPayouts() && getField('nearest').value; } }
    ];

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        var data = util.getSubmitItem($scope.fields);
        data.invoice = invoice;
        if (!hasStock) {
            data.update_stock = false;
        }

        server.post('/api/invoice/credit', data, null, 'Invoice credited', 'Failed to credit invoice').then(function(result) {
            $scope.loadingStatus.loading = false;
            if (result) {
                $scope.$close();
            }
        });
    };

    $scope.setInitialValues();
}]);

economy.controller('EconomyAccountingExportOldCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'server', 'util', function($rootScope, $scope, $controller, $filter, server, util) {
    $controller('AddCtrl', {$scope: $scope});
    $scope.fields = [
        {name: 'fromDate', title: 'From', required: true, type: 'date', value: Date.firstDayLastMonth() },
        {name: 'toDate', title: 'To', required: true, type: 'date', value: Date.lastDayLastMonth() }
    ];
    $scope.getButtonText = function() {
        return 'Download';
    };

    $scope.canSubmit = function() {
        var dateok = _.findWhere($scope.fields, {name: 'fromDate'}).value < _.findWhere($scope.fields, {name: 'toDate'}).value && _.findWhere($scope.fields, {name: 'toDate'}).value.isPastDate();
        return dateok;
    };

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        var item = $scope.getSubmitItem();
        server.post('/api/accounting/exportOld', null, item, null, 'Failed to get accounting export', null, {responseType: 'blob'}).then(function(result) {
            if (result.success) {
                util.download( $filter('translate')('Accounting export') + '.zip', result.data, 'application/zip');
            }
            $scope.loadingStatus.loading = false;
        });
    };
}]);

economy.controller('InvoicesTabsetController', ['$rootScope', '$scope', '$controller', '$timeout', function($rootScope, $scope, $controller, $timeout) {
    $controller('BaseTabsetController', {$scope: $scope});

    var getNumUnconfirmed = function() {
        return $rootScope.numUnconfirmedInvoices;
    };

    $scope.init('invoices');

    var removeWatch = $scope.$watch(getNumUnconfirmed, function() {
        if (getNumUnconfirmed() !== undefined) {
            $scope.init(Number($rootScope.numUnconfirmedInvoices)  ? 'confirm' : 'invoices');
            removeWatch();
        }
    });

    var invoiceGuide = function() {
        var steps = [];
        var hasInvoice = $rootScope.hasModule('Invoice');
        if (hasInvoice) {
            steps = steps.concat([{
                element: '.ui-tab-container .ui-tab .nav-tabs > li.active',
                popover: {
                    description: 'When a membership or other product is added to an invoice, an invoice basis is first created. To send the invoice, you must confirm it. You will find all unconfirmed payments under this tab.'
                },
                tab: 'confirm'
            }, {
                element: '.ui-tab-container .tab-content div.active > button',
                popover: {
                    description: 'This button makes so that all payments in the list are confirmed and sent to the customers. You can therefore add memberships to everyone in the association first and then send all invoices at the same time. You can also confirm the payments one by one by clicking on Confirm on each line.'
                },
                tab: 'confirm'
            }]);
        }

        steps.push({
            element: '.ui-tab-container .tab-content > div:nth-child('+(hasInvoice?'2':'1')+')',
            popover: {
                description: 'You can retrieve all accounts for a specific date. You see, among other things, who the invoice refers to, reference number and due date.',
                doneBtnText: 'Next'
            },
            tab: 'debts'
        });

        return steps;
    };

    var economyInvoicingGetStartedTour = function() {
        var id = 'economyinvoiceguide';
        var guide = $scope.$getGuide(id);
        if (guide.tab) {
            $scope.setTab(guide.tab);
        }

        $timeout(function() {
            $scope.$startGuide(id).then(function() {
                $timeout($rootScope.guides.membershipinvoicingtour4);
            });
        }, 400);
    };

    var cancelGuideWatch = $scope.$watch('$registerGuide', function() {
        if (!$scope.$registerGuide) { return; }
        cancelGuideWatch();

        $scope.$registerGuide({ id: 'economyinvoiceguide', title: 'Invoice handling', tab: 'confirm', steps: invoiceGuide });
        $scope.$registerGuide({ id: 'economyinvoicinggetstartedtour', title: 'Invoice handling', redirect: economyInvoicingGetStartedTour, hidden: true });
    });
}]);

economy.controller('ZoeziPayPortalCtrl', ['$rootScope', '$scope', function($rootScope, $scope) {

    $scope.openZoeziPayPortal = () => {
        var newTab = window.open('about:blank', '_blank')
        newTab.location.href = $rootScope.isTestSystem ? 'https://essentials-test.adyen.com/' : 'https://essentials-live.adyen.com/';
    };
}]);

economy.controller('ClientAccountCtrl', ['$rootScope', '$scope', '$filter', '$controller', 'formatter', 'server', function($rootScope, $scope, $filter, $controller, formatter, server) {
    $controller('EconomyCtrl', {$scope: $scope});

    function getClientAccountInfo() {
        server.get('/api/economy/clientaccount/get', {date: $scope.historyDate && $scope.historyDate.yyyymmdd()}).then(function(result) {
            $rootScope.waitFor(['members']).then(function() {
                result.periodFrom = Date.newFull(result.periodFrom);
                result.periodTo = Date.newFull(result.periodTo);
                result.nextPayout = Date.newFull(result.nextPayout);
                angular.forEach(result.onAccountPayments, function(payment) {
                    payment.created = Date.newFull(payment.created);
                    payment.payer = $rootScope.getMember(payment.payer_id);
                    payment.totalamount = Number(payment.amount);
                });
                $scope.clientaccount = result;
            });
        });
    }

    $scope.historyDate = Date.today();
    $scope.changeHistoryDate = function() {
        getClientAccountInfo();
    };

    $scope.getPayoutInfo = function() {
        return $filter('translate')('CLIENTACCOUNT_PAYINFO').format(formatter.format('date', $scope.clientaccount.periodFrom), formatter.format('date', $scope.clientaccount.periodTo), formatter.format('date', $scope.clientaccount.nextPayout), formatter.format('price', $scope.clientaccount.periodAmount));
    };

    $scope.config = {
        getItems: function() {
            return $scope.clientaccount.onAccountPayments;
        },
        countSuffixList: ['payment', 'payments'],
        orderColumn: 'created',
        getTitle: function() {
            return 'Client account';
        },
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'payer.name', title: 'Payer' },
            {field: 'created', title: 'Payment date', format: 'date' },
            {field: 'method', title: 'Payment method', getValue: $scope.getPaymentMethodName },
            {field: 'amount', title: 'Amount', format: 'price' }
        ]
    };

    getClientAccountInfo();
}]);

economy.controller('ClientAccountPayoutCtrl', ['$rootScope', '$scope', '$filter', '$controller', '$http', '$modal', 'formatter', 'server', 'alertProvider', 'util', function($rootScope, $scope, $filter, $controller, $http, $modal, formatter, server, alertProvider, util) {

    function getClientAccountPayouts() {
        server.get('/api/economy/clientaccount/payouts/list').then(function(result) {
            angular.forEach(result, function(p) {
                p.fromDate = Date.newFull(p.fromDate);
                p.toDate = Date.newFull(p.toDate);
                p.payoutDate = Date.newFull(p.payoutDate);
                p.topay = Math.round(Number(p.amount) + Number(p.amountRefund) - Number(p.fee) - Number(p.feeRefund));
            });
            $scope.payouts = result;
        });
    }

    function getPayoutFile(payout) {
        $http.get('/api/economy/clientaccount/payouts/get?id=' + payout.id, {responseType: 'blob'}).success(function(data) {
            util.download( $filter('translate')('Payout') + '.pdf', data, 'application/pdf');
        }).error(function() {
            alertProvider.show('error', 'Failed to get data');
        });
    }

    function showPayments(payout) {
        var data = { fromDate: payout.fromDate.yyyymmdd(), toDate: payout.toDate.yyyymmdd() };
        server.get('/api/economy/clientaccount/payout/payments/get', data).then(function(payments) {
            angular.forEach(payments, $rootScope.transformPayment);
            $modal.open({
                templateUrl: 'views/payoutpaymentlist.html',
                controller: 'PayoutPaymentListModalCtrl',
                windowClass: 'huge-modal-window',
                resolve: {
                    payments: function() {
                        return payments;
                    },
                    fromDate: function() {
                        return payout.fromDate;
                    },
                    toDate: function() {
                        return payout.toDate;
                    }
                }
            });
        });
    }

    $scope.config = {
        getItems: function() {
            return $scope.payouts;
        },
        countSuffixList: ['payout', 'payouts'],
        orderColumn: '-payoutDate',
        columns: [
            {field: 'fromDate', title: 'From date', format: 'date'},
            {field: 'toDate', title: 'To date', format: 'date'},
            {field: 'payoutDate', title: 'Paid out', format: 'date'},
            {field: 'topay', title: 'Disbursed', format: 'price'}
        ],
        buttons: [
            { title: 'Download', onClick: getPayoutFile },
            { title: 'Show', buttonClass: 'btn-info', onClick: showPayments }
        ]
    };

    getClientAccountPayouts();
}]);

economy.controller('EconomyInvoicesTestCtrl', ['$rootScope', '$scope', '$controller', 'server', function($rootScope, $scope, $controller, server) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.fields = [
        {name: 'amount', title: 'Amount', required: true, type: 'price', value: 1000 },
        {name: 'date', title: 'Date', required: true, type: 'date', value: new Date() },
        {name: 'ocr', title: 'OCR eller meddelande', required: true, type: 'text', value: 1234 }
    ];

    $scope.submit = function() {
        var data = $scope.getSubmitItem();
        data.legal_entity_id = $rootScope.selectedSite.legal_entity_id;
        server.post('/api/admin/test', {operation: 'servicebureau_payment_unknown', data: data}, null, 'Ok', 'Fail');
    };
}]);

economy.controller('SplitPaymentCtrl', ['$rootScope', '$scope', '$controller', 'server', 'payments', 'paymentMethods', function($rootScope, $scope, $controller, server, payments, paymentMethods) {
    $scope.data = {payments: [{date: Date.today(), amount: 100}, {date: Date.today(), amount: 100}, {date: Date.today(), amount: 100}]};

    $controller('AddCtrl', {$scope: $scope});
    $scope.postUrl = '/api/payment/split';
    $scope.callCloseOnSuccess = true;
    $scope.successTitle = 'Payment was split';
    $scope.failedTitle = 'Failed to split payment';

    var SPLIT_LIMIT = 100;

    function getTotal() {
        var total = payments[0]?.remainingAmountToPay ?? 0;
        total += Number(_.findWhere($scope.fields, {name: 'fee'}).value);
        return total;
    }

    function getSplittedTotal() {
        var total = 0;
        angular.forEach($scope.data.payments, function(payment) {
            total += Number(payment.amount);
        });
        return total;
    }

    $scope.getDiff = function() {
        return getTotal() - getSplittedTotal();
    };

    $scope.canSubmit = function() {
        var count = _.findWhere($scope.fields, {name: 'months'}).value;
        return count > 1 && count <= SPLIT_LIMIT && $scope.getDiff() == 0;
    };

    function split() {
        var count = Math.max(2, Math.min(SPLIT_LIMIT, _.findWhere($scope.fields, {name: 'months'}).value));
        var itemsum = Math.floor(getTotal() / count);
        var rest = getTotal() % count;
        var d = Date.today();

        $scope.data.payments = [];
        for(var i=0; i < count; ++i) {
            $scope.data.payments.push({amount: itemsum + (i == 0 ? rest : 0), date: d});
            d = d.clone().addMonths(1);
            if (i == 0) {
                d.setDate($rootScope.billingDay);
            }
        }

        _.findWhere($scope.fields, {name: 'total'}).value = getTotal();
    }

    $scope.fields = [
        {name: 'months', title: 'Count', type: 'infoNumber', info: 'months', min: 2, max: SPLIT_LIMIT, change: split, value: 12},
        {name: 'total', title: 'Total amount', type: 'price', readonly: true},
        {name: 'fee', title: 'Fee', type: 'price', change: split, value: 0},
        {name: 'method', title: 'Payment method', required: true, type: 'paymentmethod', value: _.findWhere(paymentMethods.getAll(), {id: payments[0].method}), options: {create: true}, change: split }
    ];

    split();

    var oldSubmitItem = $scope.getSubmitItem;
    $scope.getSubmitItem = function() {
        var item = oldSubmitItem();
        item.new_payments = $scope.data.payments.map(function(p) { return {amount: p.amount, date: p.date.yyyymmdd()}; });
        item.original_payments = _.pluck(payments, 'id');
        return item;
    };
}]);

economy.controller('BudgetRevenueOrCostDataCtrl', ['$scope', 'server', 'options', function($scope, server, options) {
    function getFromLastYear(field) {
        var date = options.date;
        var fromDate = Date.newFull(date.fromDate).addMonths(-12).yyyymmdd();
        var toDate = Date.newFull(date.toDate).addMonths(-12).yyyymmdd();
        var item = $scope.config.control.getSubmitItem();
        if (item.products.length == 0) {
            return;
        }

        field.loading = true;
        server.post('/api/economy/budget/get_last_year', {fromDate: fromDate, toDate: toDate, period: options.date.period, products: item.products }).then(function(result) {
            for (var i=0; i < result.data.length; ++i) {
                $scope.config.control.getField('numbers.' + i).value = result.data[i];
            }
            field.loading = false;
        });
    }

    function addNumberColumns(columns) {
        if (options.revenue) {
            columns.push( { name: 'getold', buttonTitle: 'Get from previous year', type: 'button', buttonClass: 'btn-success', click: getFromLastYear } );
        }

        var date = options.date;
        var d = Date.newFull(date.fromDate);
        var i = 0;
        while (d <= Date.newFull(date.toDate)) {
            var title = date.period == 'month' ? d.yyyymmdd().substring(0, 7) : d.getFullYear();
            columns.push( {name: 'numbers.' + i, title: title, type: 'price' } );
            ++i;
            d = d.clone().addMonths(date.period == 'month' ? 1 : 12);
        }

        return columns;
    }

    $scope.config = _.deep_extend(options.config, {
        datatype: 'post',
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'name', title: 'Name', type: 'text', required: true },
                    {name: 'products', title: 'Products', type: 'products', required: true, itemTypes: 'product', useId: true, itemFilter: options.itemFilter, visible: function() { return options.revenue; } }
                ]
            },
            {
                name: 'Budget',
                fields: addNumberColumns([])
            }
        ],
        canSubmit: function() {
            return options.forbiddenNames.indexOf($scope.config.control.getField('name').value) == -1;
        }
    });
}]);

economy.controller('BudgetDataCtrl', ['$scope', 'util', 'options', function($scope, util, options) {

    function getItemFilter(item) {
        var f = $scope.config.control.getField('revenue').value || [];
        var products_arrays = _.pluck(f.filter(function(r) { return r != item; }), 'products');
        var itemFilter = function(p) {
            for (var i=0; i < products_arrays.length; ++i) {
                if (products_arrays[i].indexOf(p.id) != -1) {
                    return false;
                }
            }
            return true;
        };
        return itemFilter;
    }

    function getAllNames(field_name, item) {
        var f = $scope.config.control.getField(field_name).value || [];
        return _.pluck(f.filter(function(r) { return r != item; }), 'name');
    }

    function addRevenue() {
        var i = $scope.config.control.getSubmitItem();
        var date = {fromDate: i.fromDate, toDate: i.toDate, period: i.period};
        util.showDataDialog({controller: 'BudgetRevenueOrCostDataCtrl', itemFilter: getItemFilter(), forbiddenNames: getAllNames('revenue'), revenue: true, date: date}).result.then(function(result) {
            $scope.config.control.getField('revenue').value.push(result);
            $scope.config.control.getField('revenue').config.control.update();
        });
    }

    function changeRevenue(item) {
        var i = $scope.config.control.getSubmitItem();
        var date = {fromDate: i.fromDate, toDate: i.toDate, period: i.period};
        util.showDataDialog({controller: 'BudgetRevenueOrCostDataCtrl', item: item, itemFilter: getItemFilter(item), forbiddenNames: getAllNames('revenue', item), revenue: true, date: date}).result.then(function(result) {
            _.extend(item, result);
            $scope.config.control.getField('revenue').config.control.update();
        });
    }

    function addExpense() {
        var i = $scope.config.control.getSubmitItem();
        var date = {fromDate: i.fromDate, toDate: i.toDate, period: i.period};
        util.showDataDialog({controller: 'BudgetRevenueOrCostDataCtrl', forbiddenNames: getAllNames('expenses'), date: date}).result.then(function(result) {
            $scope.config.control.getField('expenses').value.push(result);
            $scope.config.control.getField('expenses').config.control.update();
        });
    }

    function changeExpense(item) {
        var i = $scope.config.control.getSubmitItem();
        var date = {fromDate: i.fromDate, toDate: i.toDate, period: i.period};
        util.showDataDialog({controller: 'BudgetRevenueOrCostDataCtrl', item: item, forbiddenNames: getAllNames('expenses', item), date: date}).result.then(function(result) {
            _.extend(item, result);
            $scope.config.control.getField('expenses').config.control.update();
        });
    }

    function addNumberColumns(columns) {
        if ($scope.config && $scope.config.control) {
            var d = $scope.config.control.getField('fromDate').value;
            var i = 0;
            while (d < $scope.config.control.getField('toDate').value) {
                var title = $scope.config.control.getField('period').id == 'month' ? d.yyyymmdd().substring(0, 7) : d.getFullYear();
                columns.push( {name: 'numbers.' + i, title: title, type: 'price' } );
                ++i;
                d = d.clone().addMonths($scope.config.control.getField(('period').id == 'month' ? 1 : 12));
            }
        }

        return columns;
    }

    $scope.config = _.deep_extend(options.config, {
        datatype: 'budget',
        url: {
            add: '/api/economy/budget/add',
            change: '/api/economy/budget/change'
        },
        data: {
            periods: [{id: 'month', name: 'Month'}, {id: 'year', name: 'Year'}]
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'name', title: 'Name', type: 'text', required: true },
                    {name: 'fromDate', title: 'From', type: 'month', required: true },
                    {name: 'toDate', title: 'To', type: 'month', required: true },
                    {name: 'period', title: 'Enter numbers every', type: 'select', required: true, options: function() { return $scope.config.data.periods; }, useId: true }
                ]
            },
            {
                name: 'Revenue',
                fields: [
                    {name: 'revenue', title: 'Revenue', type: 'customertable', getValue: function(f) { return f.config.control && f.config.control.getItems(); }, config: {
                        getItems: function() {
                            return $scope.config.control.getField('revenue').value;
                        },
                        idKey: 'name',
                        countSuffixList: ['post', 'posts'],
                        orderColumn: 'name',
                        columns: [
                            {field: 'name', title: 'Name'},
                            {field: 'products', title: 'Products', format: 'count'}
                        ],
                        searchButtons: [
                            {title: 'Add', onClick: addRevenue, showOnEmpty: true }
                        ],
                        buttons: [
                            { title: 'Change', buttonClass: 'btn-warning', onClick: changeRevenue },
                            { title: 'Remove', buttonClass: 'btn-danger', onClick: function(r) { var rev = $scope.config.control.getField('revenue').value; var i = rev.indexOf(r); rev.splice(i, 1); $scope.config.control.getField('revenue').config.control.update(); } }
                        ]
                    }}
                ]
            },
            {
                name: 'Expenses',
                fields: [
                    {name: 'expenses', title: 'Expenses', type: 'customertable', getValue: function(f) { return f.config.control && f.config.control.getItems(); }, config: {
                        getItems: function() {
                            return $scope.config.control.getField('expenses').value;
                        },
                        idKey: 'name',
                        countSuffixList: ['post', 'posts'],
                        orderColumn: 'name',
                        columns: addNumberColumns([
                            {field: 'name', title: 'Name'}
                        ]),
                        searchButtons: [
                            {title: 'Add', onClick: addExpense, showOnEmpty: true }
                        ],
                        buttons: [
                            { title: 'Change', buttonClass: 'btn-warning', onClick: changeExpense },
                            { title: 'Remove', buttonClass: 'btn-danger', onClick: function(r) { var exp = $scope.config.control.getField('expenses').value; var i = exp.indexOf(r); exp.splice(i, 1); $scope.config.control.getField('expenses').config.control.update(); } }
                        ]
                    }}
                ]
            }
        ],
        init: function() {
            if (!options.item) {
                return {
                    fromDate: new Date(Date.today().getFullYear()+1, 1-1, 1),
                    toDate: new Date(Date.today().getFullYear()+1, 12-1, 31),
                    period: 'month',
                    revenue: [],
                    expenses: []
                };
            } else {
                if (!options.item.revenue) {
                    options.item.revenue = [];
                }
                if (!options.item.expenses) {
                    options.item.expenses = [];
                }
            }
        },
        canSubmit: function() {
            return $scope.config.control && ($scope.config.control.getField('fromDate').value < $scope.config.control.getField('toDate').value);
        }
    });
}]);

economy.controller('BudgetListCtrl', ['$rootScope', '$scope', '$location', '$filter', 'util', 'confirm', 'server', function($rootScope, $scope, $location, $filter, util, confirm, server) {
    function addBudget() {
        util.showDataDialog({controller: 'BudgetDataCtrl'});
    }

    function changeBudget(budget) {
        util.showDataDialog({controller: 'BudgetDataCtrl', item: budget});
    }

    function gotoBudget(budget) {
        $location.path('/economy/budget/' + budget.id);
    }

    function copyBudget(budget) {
        budget = angular.copy(budget);
        budget.name = $filter('translate')('Copy of') + ' ' + budget.name;
        util.showDataDialog({controller: 'BudgetDataCtrl', initial: budget});
    }

    function removeBudget(budget) {
        confirm.show('Are you sure you want to remove the budget?', {ladda: true}).then(function(resolve) {
            server.post('/api/economy/budget/remove', null, {id: budget.id}, 'Budget removed', 'Failed to remove budget').then(resolve);
        });
    }

    $scope.config = {
        api: {
            url: '/api/economy/budget/get',
            triggers: [ {type: 'budget'}],
            transform: $rootScope.transformBudget
        },
        countSuffixList: ['budget', 'budgets'],
        rowClick: gotoBudget,
        columns: [
            {field: 'name', title: 'Name'},
            {field: 'fromDate', title: 'From', format: 'date'},
            {field: 'toDate', title: 'To', format: 'date'}
        ],
        searchButtons: [
            {title: 'Create new budget', onClick: addBudget, showOnEmpty: true }
        ],
        buttons: [
            { title: 'Result', buttonClass: 'btn-success', onClick: gotoBudget},
            { title: 'Change', buttonClass: 'btn-warning', onClick: changeBudget},
            { title: 'Copy', buttonClass: 'btn-info', onClick: copyBudget},
            { title: 'Remove', buttonClass: 'btn-danger', onClick: removeBudget}
        ]
    };
}]);

economy.controller('BudgetCtrl', ['$rootScope', '$scope', '$routeParams', '$filter', 'server', 'util', 'alertProvider', 'live', function($rootScope, $scope, $routeParams, $filter, server, util, alertProvider, live) {

    function getResult(tab) {
        server.post('/api/economy/budget/update_with_real_result', null, {budget_id: $scope.budget.id, fromDate: tab.dates.from.yyyymmdd() }).then(function(result) {
            if (!result.success) {
                alertProvider.modal('Failed to save information', 'Failed to save information');
            }
        });
    }

    function saveBudget(isRevenue, index, name, result) {
        server.post('/api/economy/budget/update_result', {budget_id: $scope.budget.id, index: index, revenue: isRevenue ? name : null, expenses: isRevenue ? null : name, result: result }, null).then(function(result) {
            if (!result.success) {
                alertProvider.modal('Failed to save information', 'Failed to save information');
            }
        });
    }

    function toNumber(x) {
        if (x == undefined || x == null) {
            return 0;
        }
        if (!angular.isString(x)) {
            x = String(x);
        }
        x = x.replace(',', '.');
        return Number(x);
    }

    function getDiff(r) {
        if (r.result == undefined || r.budget == undefined) {
            return undefined;
        }

        return toNumber(r.result) - toNumber(r.budget);
    }

    function sum(list) {
        var total = 0;
        if (_.isObject(list) || _.isArray(list)) {
            _.each(list, function(val) {
                var x = toNumber(val);
                if (!isNaN(x)) {
                    total += x;
                }
            });
        } else {
            total = toNumber(list);
        }
        return total;
    }

    function updateSum(items) {
        var sum_item = items[items.length-1];
        sum_item.result = 0;
        sum_item.budget = 0;
        items.forEach(function(r) {
            if (r == sum_item) {
                return;
            }
            if (r.result) {
                sum_item.result += sum(r.result);
            }
            if (r.budget) {
                sum_item.budget += sum(r.budget);
            }
        });
    }

    function createConfig() {
        var tabs = [];

        var d = $scope.budget.fromDate;
        while (d <= $scope.budget.toDate) {
            var tab = {};
            var title = $scope.budget.period == 'month' ? d.yyyymmdd().substring(0, 7) : d.getFullYear();
            tab.name = title;
            tab.dates = {from: d};

            tabs.push(tab);

            d = d.clone().addMonths($scope.budget.period == 'month' ? 1 : 12);
            tab.dates.to = d;
        }

        tabs.forEach(function(tab, i) {
            var revenue = angular.copy($scope.budget.revenue);
            revenue.forEach(function(r) {
                if (!r.result) {
                    r.result = 0;
                } else {
                    r.result = r.result[i];
                }
                r.budget = r.numbers[i];
            });
            revenue.push({name: $filter('translate')('Sum'), isSum: true});

            tab.revenueConfig = {
                getItems: function() {
                    return revenue;
                },
                giveFocus: function() {
                    return false;
                },
                idKey: 'name',
                countSuffixList: ['post', 'posts'],
                columns: [
                    {field: 'name', title: 'Name'},
                    {field: 'budget', title: 'Budget', format: 'price' },
                    {field: 'result_fixed', title: 'Result', format: 'price', getValue: function(r) { return r.result; } },
                    {field: 'result', title: 'Result', getFormat: function(row) { return row.isSum ?  'price' : 'editable'; },  change: function(r) { saveBudget(true, i, r.name, r.result); } },
                    {field: 'diff', title: 'Difference', format: 'price', getValue: getDiff }

                ],
                searchButtons: [
                    {title: 'Fetch real result', onClick: function() { getResult(tab); }, showOnEmpty: true, visible: function() { return tab.dates.to.isPastDate(); } }
                ],
                getRowStyle: function(rownr) {
                    if (revenue[rownr-1].isSum) {
                        return {'font-weight': 'bold'};
                    }
                },
                updateSum: function() {
                    updateSum(revenue);
                }
            };
            tab.revenueConfig.updateSum();

            var expenses = angular.copy($scope.budget.expenses);
            expenses.forEach(function(e) {
                if (!e.result) {
                    e.result = 0;
                } else {
                    e.result = e.result[i];
                }
                e.budget = e.numbers[i];
            });
            expenses.push({name: $filter('translate')('Sum'), isSum: true});

            tab.expensesConfig = {
                getItems: function() {
                    return expenses;
                },
                giveFocus: function() {
                    return false;
                },
                idKey: 'name',
                countSuffixList: ['post', 'posts'],
                columns: [
                    {field: 'name', title: 'Name'},
                    {field: 'budget', title: 'Budget', format: 'price' },
                    {field: 'result_fixed', title: 'Result', format: 'price', getValue: function(r) { return r.result; } },
                    {field: 'result', title: 'Result', getFormat: function(row) { return row.isSum ?  'price' : 'editable'; },  change: function(r) { saveBudget(false, i, r.name, r.result); } },
                    {field: 'diff', title: 'Difference', format: 'price', getValue: getDiff }
                ],
                getRowStyle: function(rownr) {
                    if (expenses[rownr-1].isSum) {
                        return {'font-weight': 'bold'};
                    }
                },
                updateSum: function() {
                    updateSum(expenses);
                }
            };
            tab.expensesConfig.updateSum();
        });

        $scope.tabs = tabs;
    }

    function createTotalConfigs(budget) {
        var trevenue = angular.copy(budget.revenue);
        trevenue.forEach(function(r) {
            r.budget = r.numbers;
        });
        trevenue.push({name: $filter('translate')('Sum'), isSum: true});
        $scope.totalRevenueConfig = {
            getItems: function() {
                return trevenue;
            },
            giveFocus: function() {
                return false;
            },
            idKey: 'name',
            countSuffixList: ['post', 'posts'],
            columns: [
                {field: 'name', title: 'Name'},
                {field: 'budget', title: 'Budget', format: 'price', getValue: function(r) { return sum(r.budget); } },
                {field: 'result', title: 'Result', format: 'price', getValue: function(r) { return sum(r.result); } }
            ],
            getRowStyle: function(rownr) {
                if (trevenue[rownr-1].isSum) {
                    return {'font-weight': 'bold'};
                }
            },
            updateSum: function() {
                updateSum(trevenue);
            }
        };
        $scope.totalRevenueConfig.updateSum();

        var texpenses = angular.copy(budget.expenses);
        texpenses.forEach(function(r) {
            r.budget = r.numbers;
        });
        texpenses.push({name: $filter('translate')('Sum'), isSum: true});
        $scope.totalExpensesConfig = {
            getItems: function() {
                return texpenses;
            },
            giveFocus: function() {
                return false;
            },
            idKey: 'name',
            countSuffixList: ['post', 'posts'],
            columns: [
                {field: 'name', title: 'Name'},
                {field: 'budget', title: 'Budget', format: 'price', getValue: function(r) { return sum(r.budget); } },
                {field: 'result', title: 'Result', format: 'price', getValue: function(r) { return sum(r.result); } }
            ],
            getRowStyle: function(rownr) {
                if (texpenses[rownr-1].isSum) {
                    return {'font-weight': 'bold'};
                }
            },
            updateSum: function() {
                updateSum(texpenses);
            }
        };
        $scope.totalExpensesConfig.updateSum();
    }

    function getBudget() {
        server.get('/api/economy/budget/get', {id: $routeParams.budgetId}).then(function(result) {
            $scope.budget = $rootScope.transformBudget(result);
            createConfig();
            createTotalConfigs($scope.budget);
        });
    }
    getBudget();

    function fundamentallyChanged(budget) {
        if (budget.revenue.length != $scope.budget.revenue.length || budget.expenses.length != $scope.budget.expenses.length) {
            return true;
        }

        if (!_.all(budget.revenue, function(r) { return _.findWhere($scope.budget.revenue, {name: r.name}); })) {
            return true;
        }

        if (!_.all(budget.expenses, function(r) { return _.findWhere($scope.budget.expenses, {name: r.name}); })) {
            return true;
        }

        if (budget.period != $scope.budget.period) {
            return true;
        }
    }

    live.subscribe({type: 'budget', scope: $scope, callback: function(budget) {
        if (budget.id == $scope.budget.id) {
            if (fundamentallyChanged(budget)) {
                getBudget();
                return;
            }
            $scope.budget.name = budget.name;
            budget.revenue.forEach(function(r) {
                $scope.tabs.forEach(function(tab, i) {
                    var item = _.findWhere(tab.revenueConfig.getItems(), {name: r.name});
                    item.result = r.result && r.result[i];
                    item.budget = r.numbers && r.numbers[i];
                    tab.revenueConfig.updateSum();
                    tab.revenueConfig.control.update();
                });
            });

            budget.expenses.forEach(function(r) {
                $scope.tabs.forEach(function(tab, i) {
                    var item = _.findWhere(tab.expensesConfig.getItems(), {name: r.name});
                    item.result = r.result && r.result[i];
                    item.budget = r.numbers && r.numbers[i];
                    tab.expensesConfig.updateSum();
                    tab.expensesConfig.control.update();
                });
            });

            createTotalConfigs(budget);
        }
    }});
}]);

economy.controller('PayoutPaymentListModalCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'paymentMethods', 'util', 'payments', 'fromDate', 'toDate',
    function($rootScope, $scope, $controller, $filter, paymentMethods, util, payments, fromDate, toDate) {
    $controller('EconomyCtrl', { $scope: $scope });

    $scope.payments = $scope.bundleTogether(payments);
    $scope.fromDate = fromDate;
    $scope.toDate = toDate;

    $scope.getTitle = function() {
        return $filter('translate')('Payments for period {0} to {1}').format(fromDate.yyyymmdd(), toDate.yyyymmdd());
    };

    var getSentDate = function(payment) {
        var attempts = payment.attempts;
        if (attempts.length) {
            var attempt = util.getInkassoSentAttempt(payment) || _.findWhere(attempts, { status: 'sent' });
            return attempt ? attempt.created.yyyymmdd() : attempts[attempts.length-1].created.yyyymmdd();
        }
    };

    var getPaymentDate = function(payment) {
        if (payment.attempts.length) {
            var date = (util.getInkassoPaidAttempt(payment) || payment.attempts[payment.attempts.length-1]).time;
            return date.yyyymmdd();
        }
    };

    $scope.tableConfig = {
        getItems: function() {
            return $scope.payments;
        },
        rowClick: $scope.showPayments,
        countSuffix: ['payment', 'payments'],
        orderColumn: '-paydate',
        columns: [
            {field: 'image', title: '', src: $scope.getImage },
            {field: 'payer.name', title: 'Payer' },
            {field: 'senddate', title: 'Sent at', format: 'date', getValue: getSentDate },
            {field: 'paydate', title: 'Payment date', getValue: getPaymentDate, format: 'date' },
            {field: 'name', title: 'Payment item', getValue: $scope.getProductName },
            {field: 'method', title: 'Payment method', getValue: $scope.getPaymentMethodName },
            {
                field: 'totalamount',
                title: 'Amount',
                format: 'discountedprice',
                getExtraValue: (i) => i.totaldiscount
            }
        ],
    };
}]);

economy.controller('EconomyAddIncomeModalCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$http', '$sce', '$modalInstance', 'alertProvider', 'paymentMethods', 'util', 'options', function($rootScope, $scope, $controller, $filter, $http, $sce, $modalInstance, alertProvider, paymentMethods, util, options) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.totalAmount = options.amount || 0;

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;

        var item = util.getSubmitItem($scope.fields);
        if (options.origin) {
            item.origin = options.origin;
        }

        var products = [];
        angular.forEach(Object.keys(item), function(key) {
            if (!key.startsWith('product')) { return; }
            var product = item[key];
            var rowNr = key.split('_')[1];
            var amount = item['amount_'+rowNr];
            products.push({ id: product, amount: amount });
            delete item[key];
            delete item['amount_'+rowNr];
        });
        item.products = products;

        var fd = new FormData();
        if (item.incomefile) {
            fd.append('file', item.incomefile);
            delete item.incomefile;
        }
        item.legal_entity_id = $rootScope.selectedSite.legal_entity_id;
        fd.append('data', JSON.stringify(item));

        $http.post('/api/economy/income/add', fd, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).success(function() {
            alertProvider.show('success', 'New income added');
            $modalInstance.close();
        }).error(function() {
            alertProvider.show('error', 'Failed to add new income');
            $scope.loadingStatus.loading = false;
        });
    };

    $scope.canSubmit = function() {
        return util.fieldsValid($scope.fields);
    };

    $scope.incomeFile = {};
    var onFileChange = function() {
        var f = _.findWhere($scope.fields, { name: 'incomefile' }).value;
        if (!f) { return; }
        if (['image/png', 'image/jpg', 'image/jpeg'].indexOf(f.type) != -1) {
            $scope.incomeFile.type = 'image';
        } else {
            $scope.incomeFile.type = 'pdf';
        }
        $scope.incomeFile.url = $sce.trustAsResourceUrl(window.URL.createObjectURL(f));
    };

    $scope.$watch(function() {
        var f = _.findWhere($scope.fields, { name: 'incomefile' }).value;
        return f && f.name;
    }, onFileChange);

    var hasSavedCard = function() {
        var customer = _.findWhere($scope.fields, {name: 'customer'}).value;
        return customer && $rootScope.getMember(customer).hasSavedCardForSelectedLegalEntity();
    };

    var setPaymentMethod = function() {
        return _.findWhere(paymentMethods.get(), { id: options.method || 'bank' });
    };

    var allProductsSet = function() {
        return !$scope.fields.filter(function(f) { return f.name && f.name.startsWith('product') && !f.value; }).length;
    };

    var getProductTotal = function() {
        var amounts = _.pluck($scope.fields.filter(function(f) { return f.name && f.name.startsWith('amount'); }), 'value');
        return _.reduce(amounts, function(sum, amount) { return sum + (amount || 0); });
    };

    var displayError = function() {
        var productTotal = getProductTotal();
        return $scope.totalAmount && $scope.totalAmount != productTotal;
    };

    var addRow = function() {

        var rowCount = $scope.fields.filter(function(f) { return f.name && f.name.startsWith('product'); }).length;
        var rowNr = rowCount + 1;

        var clearRow = function() {
            var hasValue = !!_.findWhere($scope.fields, { name: 'product_'+rowNr }).value;
            if (hasValue) { return; }
            var index = _.findIndex($scope.fields, function(f) { return f.name == 'product_'+rowNr; });
            $scope.fields.splice(index, 2);
        };

        var product = { name: 'product_' + rowNr, title: $filter('translate')('Product')+' '+rowNr, type: 'product', required: false, itemTypes: 'product', useId: true, change: clearRow };
        var amount = { name: 'amount_' + rowNr, title: $filter('translate')('Amount')+' '+rowNr, type: 'number', min: 1, required: true };

        var buttonIndex = _.findIndex($scope.fields, function(f) { return f.name == 'add_product'; });
        $scope.fields.splice(buttonIndex, 0, amount);
        $scope.fields.splice(buttonIndex, 0, product);
    };

    $scope.fields = [
        { name: 'incomefile', title: 'Economic basis', type: 'file', required: false, accept: '.pdf,.png,.jpg' },
        { name: 'comment', title: 'Comment', type: 'textarea', required: false },
        { name: 'customer', title: 'Customer', type: 'customer', required: false },
        { name: 'method', title: 'Payment method', required: true, type: 'paymentmethod', setValue: setPaymentMethod, hasSavedCard: hasSavedCard, options: {change: true} },
        { name: 'date', title: 'Event date', type: 'date', required: true, max: new Date().yyyymmdd(), visible: function() { return !options.origin; } },
        { name: 'date', title: 'Event date', type: 'date', required: true, visible: function() { return options.origin; } },
        { type: 'label', title: 'Type of income' },
        { name: 'product_1', title: 'Product', type: 'product', required: true, itemTypes: 'product', useId: true },
        { name: 'amount_1', title: 'Amount', type: 'number', min: 1, required: true, setValue: function() { return options.amount && Number(options.amount); } },
        { name: 'add_product', type: 'button', buttonTitle: 'Add additional product links', buttonClass: 'btn-primary', click: addRow, visible: allProductsSet },
        { hint: util.t('ECONOMY_ADD_INCOME_ERROR').format($scope.totalAmount), hintClass: 'alert-danger', visible: displayError }
    ];

    util.setValues($scope.fields, options);

}]);

economy.controller('PaymentConfirmationOptionModalCtrl', ['$scope', function($scope) {
    $scope.delay = function() {
        $scope.$close({ delayBelowMin: true });
    };
    $scope.confirmAll = function() {
        $scope.$close({ delayBelowMin: false });
    };
}]);

economy.controller('AccrualAccountingDataModalCtrl', ['$rootScope', '$scope', 'util', 'transaction', function($rootScope, $scope, util, transaction) {
    $scope.transaction = transaction;

    const getType = () => {
        const types = {
            'courses': 'Courses',
            'resourcebookings': 'Resource bookings',
            'trainingcards': 'Training cards',
            'punchcards': 'Punch cards'
        };
        return util.t(types[$scope.transaction.source_data.type]) || '';
    };

    const getExcel = function(config) {
        config.control.exportTo('excel').then(function(blob) {
            util.download(util.t('Accrual accounting') + '_' + getType() + '_' + $scope.transaction.created.yyyymmdd() + '.xlsx', null, null, blob);
        });
    };

    const isCourse = () => $scope.transaction.source_data.type == 'courses';
    const isResourceBooking = () => $scope.transaction.source_data.type == 'resourcebookings';
    const isTrainingCard = () => $scope.transaction.source_data.type == 'trainingcards';
    const isPunchCard = () => $scope.transaction.source_data.type == 'punchcards';

    $scope.config = {
        getItems: () => $scope.transaction.source_data.accrualaccountingdata,
        getTitle: function() {
            return util.t('Accrual accounting') + ' ('+ getType() +')';
        },
        countSuffixList: ['post', 'posts'],
        searchButtons: [
            { title: 'Download as Excel', onClick: getExcel },
        ],
        columns: [
            { field: 'name', title: 'Name' },
            { field: 'customerName', title: 'Customer name' },
            { field: 'payerName', title: 'Payer', visible: isTrainingCard },
            { field: 'originalValue', title: 'Original value', format: 'price' },
            { field: 'value', title: 'Remaining value', format: 'price' },
            { field: 'account', title: 'Income account', showSum: false },
            { field: 'vat', title: 'VAT', showSum: false, format: 'percentNoMult' },
            { field: 'startTime', title: 'Start time', format: 'datetime', visible: () => isCourse() || isResourceBooking() },
            { field: 'endTime', title: 'End time', format: 'datetime', visible: isCourse },
            { field: 'validFromDate', title: 'Valid from', format: 'date', visible: isTrainingCard },
            { field: 'validToDate', title: 'Valid to', format: 'date', visible: () => isTrainingCard() || isPunchCard() },
            { field: 'trainingsLeft', title: 'Trainings left', visible: isPunchCard },
        ]
    };

}]);


economy.controller('AddCostModalCtrl', ['$rootScope', '$scope', '$controller', '$http', '$sce', '$timeout', 'accounts', 'util', 'alertProvider', 'BankAccount', 'fileManager', 'options',
    function($rootScope, $scope, $controller, $http, $sce, $timeout, accounts, util, alertProvider, BankAccount, fileManager, options) {
    $controller('AddCtrl', {$scope: $scope});

    options = options || {};
    if (!options.performer) {
        options.performer = $rootScope.currentStaff;
    }
    $scope.change = !!options.origin;

    var isReceipt = function() {
        return options.type == 'receipt';
    };
    var isSupplierInvoice = function() {
        return options.type == 'supplierinvoice';
    };
    var isOutlay = function() {
        return options.type == 'outlay';
    };
    var isValueCard = function() {
        return options.type == 'valuecard';
    };

    $scope.getHeader = function() {
        var prefix = util.t($scope.change ? 'Change' : 'Add') + ' ';
        if (isReceipt()) {
            return prefix + util.t('receipt');
        } else if (isSupplierInvoice()) {
            return prefix + util.t('supplier invoice');
        } else if (isOutlay()) {
            return prefix + util.t('outlay');
        } else if (isValueCard()) {
            return prefix + util.t('value card');
        } else {
            return prefix + util.t('cost');
        }
    };

    var canEditAccounts = function() {
        return $rootScope.hasPermission('Accounting') && (isReceipt() || isSupplierInvoice() || isOutlay());
    };

    var amountsValid = function() {
        var totalAmount = _.findWhere($scope.fields, { name: 'amount' }).value;
        if (!totalAmount) { return false; }
        totalAmount = Number(totalAmount.replace(',', '.'));

        var typeFields = $scope.fields.filter(function(f) { return f.name && f.name.startsWith('type_') && !!f.value; });
        if (!typeFields || !typeFields.length) { return false; }

        var kreditAmount = 0;
        var debetAmount = 0;
        angular.forEach(typeFields, function(f) {
            var rowNr = f.name.split('_')[1];
            var amount = _.findWhere($scope.fields, { name: 'amount_'+rowNr }).value;
            if (!amount) { return; }
            if (isNaN(Number(amount))) { amount = amount.replace(',', '.'); }
            amount = Number(amount);
            var type = f.value.id;
            if (type == 'kredit') {
                kreditAmount += amount;
            } else {
                debetAmount += amount;
            }
        });

        return kreditAmount == totalAmount && debetAmount == totalAmount;
    };


    var getSubmitItem = function() {
        var item = util.getSubmitItem($scope.fields);
        item.type = options.type;
        item.accountingTemplate = item.accountingTemplate && item.accountingTemplate.id;
        if (options.origin) {
            item.id = options.origin;
        }

        var accounting = [];
        angular.forEach(Object.keys(item), function(field) {
            if (field.startsWith('account_')) {
                var rowNr = field.split('_')[1];
                if (item[field]) {
                    accounting.push({
                        account: item[field],
                        amount: item['amount_'+rowNr],
                        type: item['type_'+rowNr]
                    });
                }
                delete item[field];
                delete item['amount_'+rowNr];
                delete item['type_'+rowNr];
            }
        });
        item.accounting = accounting;

        var fd = new FormData();
        if (item.costfile) {
            fd.append('file', item.costfile);
            delete item.costfile;
        }
        fd.append('data', JSON.stringify(item));

        return fd;
    };

    $scope.saveDraft = function() {
        $scope.loadingStatus.loading = true;
        var fd = getSubmitItem();
        $http.post('/api/economy/cost/draft/save', fd, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).success(function(draftOrigin) {
            options.origin = draftOrigin;
            alertProvider.show('success', 'Draft saved successfully');
            $scope.$close();
        }).error(function() {
            alertProvider.show('error', 'Failed to save draft');
            $scope.loadingStatus.loading = false;
        });
    };

    $scope.costFile = {};
    var setCostFile = function(f) {
        if (!f) { return; }
        if (['image/png', 'image/jpg', 'image/jpeg'].indexOf(f.type) != -1) {
            $scope.costFile.type = 'image';
        } else {
            $scope.costFile.type = 'pdf';
        }
        $scope.costFile.url = $sce.trustAsResourceUrl(window.URL.createObjectURL(f));
    };
    var onFileChange = function() {
        var f = _.findWhere($scope.fields, { name: 'costfile' }).value;
        setCostFile(f);
    };
    if (options.costfile_id) {
        fileManager.getFileContentByKey(options.costfile_id).then(setCostFile);
    }

    $scope.$watch(function() {
        var f = _.findWhere($scope.fields, { name: 'costfile' }).value;
        return f && f.name;
    }, onFileChange);

    var getBankAccountUser = function() {
        var field = isOutlay() ? 'performer' : 'supplier';
        return _.findWhere($scope.fields, { name: field }).value;
    };

    var showAutoPayout = function() {
        var user = getBankAccountUser();
        return isSupplierInvoice() && user;
    };

    var showPayoutAccount = function() {
        var user = getBankAccountUser();
        if (showAutoPayout()) {
            return !_.findWhere($scope.fields, { name: 'autoPayout' }).value;
        }
        return (isSupplierInvoice() || isOutlay() || isValueCard()) && user;
    };

    var choosePayoutAccount = function() {
        var user = getBankAccountUser();
        BankAccount.selectDialog(user).then(function(account) {
            _.findWhere($scope.fields, { name: 'payoutAccount' }).value = account;
        });
    };

    var getDefaultPayoutAccount = function() {
        var user = getBankAccountUser();
        if (user) {
            BankAccount.getFirst(user).then(function(account) {
                _.findWhere($scope.fields, { name: 'payoutAccount' }).value = account;
            });
        }
    };

    var setAccount = function(field, value) {
        if (value) {
            return BankAccount.transform(value);
        }
        getDefaultPayoutAccount();
    };

    var onUserChange = function() {
        var account = _.findWhere($scope.fields, { name: 'payoutAccount' }).value;
        var user = getBankAccountUser();
        if (!account || account.user_id != user.id) {
            _.findWhere($scope.fields, { name: 'payoutAccount' }).value = null;
            getDefaultPayoutAccount();
        }
    };

    var canAddRow = function() {
        return canEditAccounts() && !!_.findWhere($scope.fields, { name: 'accountingTemplate' }).value;
    };

    var types = [
        { id: 'kredit', name: 'Kredit' },
        { id: 'debet', name: 'Debet' },
    ];

    var addRow = function() {
            var rowCount = $scope.fields.filter(function(f) { return f.name && f.name.startsWith('account_'); }).length;
            var rowNr = rowCount + 1;

            var label = { name: 'label_'+rowNr, title: util.t('Account')+' '+rowNr, type: 'label' };
            var account = accounts.getFieldsRow($scope, function() { return $rootScope.hasPermission('Accounting'); }, null, 'cost', null, 'account_'+rowNr, util.t('Account'), null, null, 'accounts_'+rowNr, null);
            var amount = { name: 'amount_'+rowNr, title: util.t('Amount'), required: true, type: 'price' };
            var type = { name: 'type_'+rowNr, title: 'Type', type: 'select', required: true, options: function() { return types; }, useId: true };

            var buttonIndex = _.findIndex($scope.fields, function(f) { return f.name == 'add_account'; });
            $scope.fields.splice(buttonIndex, 0, label, account, amount, type);
            return rowNr;
    };

    var onAccountingTemplateChange = function() {
        if (!canEditAccounts()) { return; }

        for (var i = $scope.fields.length-1; i >= 0; i--) {
            var field = $scope.fields[i];
            if (field.name && field.name.startsWith('label_')) {
                $scope.fields.splice(i, 4);
            }
        }

        var template = _.findWhere($scope.fields, { name: 'accountingTemplate' }).value;
        if (!template) { return; }

        var totalAmount = _.findWhere($scope.fields, { name: 'amount' }).value || 0;
        if (totalAmount) {
            totalAmount = Number(totalAmount.replace(',', '.'));
        }

        angular.forEach(template.accounts, function(a) {
            var rowNr = addRow();

            $timeout(function() {
                var accountField = _.findWhere($scope.fields, { name: 'account_'+rowNr });
                accountField.value = _.findWhere(accountField.options(), { id: a.account });
                _.findWhere($scope.fields, { name: 'amount_'+rowNr }).value = Number(String((totalAmount * (a.percent / 100)).toFixed(2)));
                _.findWhere($scope.fields, { name: 'type_'+rowNr }).value = _.findWhere(types, { id: a.type });
            });
        });
    };

    var displayMismatchWarning = function() {
        if (!canEditAccounts()) { return false; }
        var template = _.findWhere($scope.fields, { name: 'accountingTemplate' }).value;
        if (!template) { return false; }
        return !amountsValid();
    };

    $scope.fields = [
        { name: 'costfile', title: 'Economic basis', type: 'file', required: false, accept: '.pdf,.png,.jpg' },
        { name: 'performer', title: 'Reference', type: 'customer', required: false, useId: true, change: onUserChange },
        { name: 'comment', title: 'Comment', type: 'textarea', required: false },
        { name: 'supplier', title: isValueCard() ? 'Receiver' : 'Supplier', type: 'supplier', required: isSupplierInvoice() || isValueCard(), visible: function() { return !isOutlay(); }, useId: true, change: onUserChange },
        { name: 'autoPayout', title: 'Automatically paid out', type: 'checkbox', visible: showAutoPayout, helpText: 'AUTOMATICALLY_PAID_OUT_INFO' },
        { name: 'payoutAccount', title: 'Payout account', required: true, visible: showPayoutAccount, type: 'customobject', useId: true, getName: function() { return this.value ? this.value.fullname : ''; }, buttonClick: choosePayoutAccount, buttonTitle: 'Choose', setValue: setAccount },
        { name: 'invoiceDate', title: 'Invoice date', type: 'date', required: true, visible: isSupplierInvoice },
        { name: 'dueDate', title: 'Due date', type: 'date', required: true, visible: isSupplierInvoice },
        { name: 'date', title: 'Payment date', type: 'date', required: true, visible: function() { return isReceipt() || isOutlay(); }, max: new Date().yyyymmdd(), helpText: 'COST_DATE_INFO' },
        { name: 'date', title: 'Payment date', type: 'date', required: true, visible: isValueCard },
        { name: 'referenceNumber', title: 'OCR-number', type: 'text', visible: isSupplierInvoice },
        { name: 'amount', title: 'Amount', type: 'price', required: true },
        { name: 'accountingTemplate', title: 'Accounting template', type: 'accountingTemplate', required: true, visible: function() { return !isValueCard(); }, change: onAccountingTemplateChange },
        { name: 'add_account', type: 'button', buttonTitle: 'Add additional account links', buttonClass: 'btn-primary', click: addRow, visible: canAddRow },
        { hint: 'ADDCOST_MISMATCH_WARNING', hintClass: 'alert-warning', visible: displayMismatchWarning }
    ];

    util.setValues($scope.fields, options, { callChange: !options.accounting });

    if (options.accounting) {
        angular.forEach(options.accounting, function(row) {
            var rowNr = addRow();
            options['account_'+rowNr] = row.account;
            options['amount_'+rowNr] = row.amount;
            options['type_'+rowNr] = row.type;
            $timeout(function() {
                _.findWhere($scope.fields, { name: 'account_'+rowNr }).value = _.findWhere($scope['accounts_'+rowNr], { id: row.account });
                _.findWhere($scope.fields, { name: 'amount_'+rowNr }).value = row.amount;
                _.findWhere($scope.fields, { name: 'type_'+rowNr }).value = _.findWhere(types, { id: row.type });
            });
        });
    }
}]);

economy.controller('AddTravelCompensationCostModalCtrl', ['$rootScope', '$scope', '$controller', '$http', '$timeout', 'util', 'alertProvider', 'server', 'BankAccount', 'options',
    function($rootScope, $scope, $controller, $http, $timeout, util, alertProvider, server, BankAccount, options) {
    $controller('AddCtrl', {$scope: $scope});

    options = options || {};
    $scope.change = !!options.origin;

    $scope.loadingStatus = {};
    $scope.halfDays = [];
    $scope.fullDays = [];
    $scope.compensation = 0;

    $scope.getHeader = function() {
        return util.t($scope.change ? 'Change' : 'Add') + ' ' + util.t('travel bill');
    };

    $scope.travelCompensationTable = null;
    var getTravelCompensationTable = function() {
        server.get('/api/economy/travelcompensationtable/get').then(function(table) {
            $scope.travelCompensationTable = table;
        });
    };
    getTravelCompensationTable();

    var getSubmitItem = function() {
        var item = $scope.getSubmitItem();
        item.type = 'travelcompensation';
        if (options.origin) {
            item.id = options.origin;
        }
        item.performer = options.performer_id || $rootScope.currentStaff.id;
        var fd = new FormData();
        fd.append('data', JSON.stringify(item));
        return fd;
    };

    $scope.saveDraft = function() {
        $scope.loadingStatus.loading = true;
        var fd = getSubmitItem();
        $http.post('/api/economy/cost/draft/save', fd, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).success(function(draftOrigin) {
            options.origin = draftOrigin;
            alertProvider.show('success', 'Draft saved successfully');
            $scope.$close();
        }).error(function() {
            alertProvider.show('error', 'Failed to save draft');
            $scope.loadingStatus.loading = false;
        });
    };

    $scope.isSameDay = function() {
        var departure = _.findWhere($scope.fields, { name: 'departure' }).value;
        var journeyHome = _.findWhere($scope.fields, { name: 'journeyHome' }).value;
        if (!departure || !journeyHome) { return false; }
        return Date.dateEquals(departure, journeyHome);
    };

    var droveOwnCar = function() {
        return !!_.findWhere($scope.fields, { name: 'droveOwnCar' }).value;
    };
    var companyOfferedFood = function() {
        return !!_.findWhere($scope.fields, { name: 'companyOfferedFood' }).value;
    };

    var getCompensationRow = function(year, type) {
        if (!$scope.travelCompensationTable) { return; }
        var data = $scope.travelCompensationTable[year];
        if (!data) {
            var latest = _.max(Object.keys($scope.travelCompensationTable));
            data = $scope.travelCompensationTable[latest];
        }
        return _.findWhere(data, { compensationType: type });
    };

    var calculateCompensation = function() {
        $scope.compensation = 0;

        var year = new Date().getFullYear();
        var departure = _.findWhere($scope.fields, { name: 'departure' }).value;
        if (departure) { year = departure.getFullYear(); }

        if (droveOwnCar()) {
            var numberMiles = _.findWhere($scope.fields, { name: 'numberMiles' }).value || 0;
            var ownCarRow = getCompensationRow(year, 'Egen bil');
            if (ownCarRow) {
                $scope.compensation += (ownCarRow.amount * numberMiles);
            }
        }

        if (!$scope.isSameDay()) {
            $scope.halfDays.forEach(function(date) {
                var row = getCompensationRow(date.getFullYear(), 'Halv dag');
                if (!row) { return; }
                $scope.compensation += row.amount;
            });

            $scope.fullDays.forEach(function(date) {
                var row = getCompensationRow(date.getFullYear, 'Hel dag');
                if (!row) { return; }
                $scope.compensation += row.amount;
            });


            if (companyOfferedFood()) {
                var halfDayBreakfastRow = getCompensationRow(year, 'Frukost - Halv dag');
                var halfDayBreakfastCount = _.findWhere($scope.fields, { name: 'halfDaysBreakfast' }).value;
                if (halfDayBreakfastCount && halfDayBreakfastRow) {
                    $scope.compensation += (halfDayBreakfastRow.amount * halfDayBreakfastCount);
                }

                var halfDayLunchRow = getCompensationRow(year, 'Lunch - Halv dag');
                var halfDayLunchCount = _.findWhere($scope.fields, { name: 'halfDaysLunchDinner' }).value;
                if (halfDayLunchCount && halfDayLunchRow) {
                    $scope.compensation += (halfDayLunchRow.amount * halfDayLunchCount);
                }

                var fullDayBreakfastRow = getCompensationRow(year, 'Frukost - Hel dag');
                var fullDayBreakfastCount = _.findWhere($scope.fields, { name: 'fullDaysBreakfast' }).value;
                if (fullDayBreakfastCount && fullDayBreakfastRow) {
                    $scope.compensation += (fullDayBreakfastRow.amount * fullDayBreakfastCount);
                }

                var fullDayLunchRow = getCompensationRow(year, 'Lunch - Hel dag');
                var fullDayLunchCount = _.findWhere($scope.fields, { name: 'fullDaysLunchDinner' }).value;
                if (fullDayLunchCount && fullDayLunchRow) {
                    $scope.compensation += (fullDayLunchRow.amount * fullDayLunchCount);
                }
            }
        }

    };

    var updateDays = function() {
        var departure = _.findWhere($scope.fields, { name: 'departure' }).value;
        var journeyHome = _.findWhere($scope.fields, { name: 'journeyHome' }).value;

        $scope.halfDays = [];
        $scope.fullDays = [];
        if (!departure || !journeyHome) { return; }

        var start = departure.clone();
        var end = journeyHome.clone();

        if ((departure.getHours() > 12) || (departure.getHours() == 12 && departure.getMinutes() >= 0)) {
            $scope.halfDays.push(departure);
            start.addDays(1);
        }

        if ((journeyHome.getHours() > 19) || (journeyHome.getHours() == 19 && journeyHome.getMinutes() >= 0)) {
            $scope.halfDays.push(journeyHome);
            end.addDays(-1);
        }

        var formatDate = function(date) {
            return date.getDate() + '/' + (date.getMonth()+1);
        };

        if ($scope.halfDays.length) {
            var halfDays = _.findWhere($scope.fields, { name: 'halfDays' });
            if ($scope.halfDays.length == 1) {
                halfDays.title = util.t('On the half day {0}').format(formatDate($scope.halfDays[0]));
            } else {
                halfDays.title = util.t('On the half days {0}, {1}').format(formatDate($scope.halfDays[0]), formatDate($scope.halfDays[1]));
            }
        }

        if (start <= end) {
            while (start <= end) {
                $scope.fullDays.push(start);
                start = start.clone();
                start.addDays(1);
            }

            var fullDays = _.findWhere($scope.fields, { name: 'fullDays' });
            if ($scope.fullDays.length == 1) {
                fullDays.title = util.t('On the full day {0}').format(formatDate($scope.fullDays[0]));
            } else {
                fullDays.title = util.t('On the full days {0} - {1}').format(formatDate($scope.fullDays[0]), formatDate($scope.fullDays[$scope.fullDays.length-1]));
            }
        }

        calculateCompensation();
    };

    var departureChanged = function() {
        var departure = _.findWhere($scope.fields, { name: 'departure' });
        var journeyHome = _.findWhere($scope.fields, { name: 'journeyHome' });
        if (departure.value && journeyHome.value) {
            if (departure.value > journeyHome.value) {
                journeyHome.value = departure.value;
            }
            if (departure.value.yyyymmdd() == journeyHome.value.yyyymmdd()) {
                _.findWhere($scope.fields, { name: 'droveOwnCar' }).value = true;
            }
        }
        updateDays();
    };

    var journeyHomeChanged = function() {
        var departure = _.findWhere($scope.fields, { name: 'departure' });
        var journeyHome = _.findWhere($scope.fields, { name: 'journeyHome' });
        if (departure.value && journeyHome.value) {
            if (journeyHome.value < departure.value) {
                departure.value = journeyHome.value;
            }
            if (departure.value.yyyymmdd() == journeyHome.value.yyyymmdd()) {
                _.findWhere($scope.fields, { name: 'droveOwnCar' }).value = true;
            }
        }
        updateDays();
    };

    var datesSet = function() {
        var departure = _.findWhere($scope.fields, { name: 'departure' }).value;
        var journeyHome = _.findWhere($scope.fields, { name: 'journeyHome' }).value;
        return departure && journeyHome && !$scope.isSameDay();
    };
    var halfDaysVisible = function() {
        return companyOfferedFood() && $scope.halfDays.length;
    };
    var fullDaysVisible = function() {
        return companyOfferedFood() && $scope.fullDays.length;
    };

    var setDefaultNumber = function(f) {
        return options[f.name] || 0;
    };

    var choosePayoutAccount = function() {
        BankAccount.selectDialog(options.performer || $rootScope.currentStaff).then(function(account) {
            _.findWhere($scope.fields, { name: 'payoutAccount' }).value = account;
        });
    };

    var getDefaultPayoutAccount = function() {
        BankAccount.getFirst(options.performer || $rootScope.currentStaff).then(function(account) {
            _.findWhere($scope.fields, { name: 'payoutAccount' }).value = account;
        });
    };

    var setAccount = function(field, value) {
        if (value) {
            return BankAccount.transform(value);
        }
        getDefaultPayoutAccount();
    };

    $scope.fields = [
        { name: 'payoutAccount', title: 'Payout account', required: true, type: 'customobject', useId: true, getName: function() { return this.value ? this.value.fullname : ''; }, buttonClick: choosePayoutAccount, buttonTitle: 'Choose', setValue: setAccount },
        { name: 'comment', title: 'Comment', type: 'textarea', required: true, helpText: 'Comment describing where the trip was made and why' },
        { name: 'departure', title: 'Departure', type: 'datetime', required: true, change: departureChanged },
        { name: 'journeyHome', title: 'Journey home', type: 'datetime', required: true, change: journeyHomeChanged },
        { name: 'droveOwnCar', title: 'Own car', type: 'checkbox', required: false, change: calculateCompensation },
        { name: 'numberMiles', title: 'Number of miles', type: 'infoNumber', required: false, info: 'miles', visible: droveOwnCar, min: 0, setValue: setDefaultNumber, change: calculateCompensation },
        { name: 'companyOfferedFood', title: 'The company has offered food', type: 'checkbox', required: false, visible: datesSet, change: journeyHomeChanged },
        { name: 'halfDays', title: '', visible: halfDaysVisible },
        { name: 'halfDaysBreakfast', title: 'Breakfast', required: true, type: 'number', visible: halfDaysVisible, min: 0, setValue: setDefaultNumber, change: calculateCompensation },
        { name: 'halfDaysLunchDinner', title: 'Lunch / Dinner', required: true, type: 'number', visible: halfDaysVisible, min: 0, setValue: setDefaultNumber, change: calculateCompensation },
        { name: 'fullDays', title: '', visible: fullDaysVisible },
        { name: 'fullDaysBreakfast', title: 'Breakfast', required: true, type: 'number', visible: fullDaysVisible, min: 0, setValue: setDefaultNumber, change: calculateCompensation },
        { name: 'fullDaysLunchDinner', title: 'Lunch / Dinner', required: true, type: 'number', visible: fullDaysVisible, min: 0, setValue: setDefaultNumber, change: calculateCompensation },
    ];

    util.setValues($scope.fields, options);
    $timeout(updateDays, 500);
}]);

economy.controller('AddTransactionEntryModalCtrl', ['$scope', '$modal', function($scope, $modal) {

    var addIncome = function() {
        $modal.open({
            templateUrl: 'views/economyaddincomemodal.html',
            controller: 'EconomyAddIncomeModalCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                options: function() {
                    return {};
                }
            }
        }).result.then($scope.$close);
    };

    var showAddCostModal = function(options) {
        $modal.open({
            templateUrl: 'views/economyaddcostmodal.html',
            controller: 'AddCostModalCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                options: function() {
                    return options;
                }
            }
        }).result.then($scope.$close);
    };
    var addReceipt = function() {
        showAddCostModal({ type: 'receipt' });
    };
    var addSupplierInvoice = function() {
        showAddCostModal({ type: 'supplierinvoice'});
    };
    var addOutlay = function() {
        showAddCostModal({ type: 'outlay' });
    };

    var addTravelCompensation = function() {
        $modal.open({
            templateUrl: 'views/addtravelcompensationcostmodal.html',
            controller: 'AddTravelCompensationCostModalCtrl',
            resolve: {
                options: function() {
                    return {};
                }
            }
        });
    };

    $scope.types = [
        {
            click: addReceipt,
            module: 'CostHandling',
            permission: 'Add cost basis',
            icon: 'glyphicon glyphicon-list-alt',
            header: 'Receipt',
            text: 'A cost that is paid directly, and deducted / debited from the company\'s account at the time of purchase.'
        }, {
            click: addOutlay,
            module: 'CostHandling',
            permission: 'Add cost basis',
            icon: 'glyphicon glyphicon-user',
            header: 'Outlay',
            text: 'When purchases are made with private money but the company should bear the cost. The money will then be paid to the person who was responsible for the expense.'
        }, {
            click: addTravelCompensation,
            module: 'TravelBill',
            icon: 'glyphicon glyphicon-list-alt',
            header: 'Travel bill',
            text: 'Compensation for increased living costs in conjunction with a business trip. Such as accommodation and use of own car.'
        }, {
            click: addSupplierInvoice,
            module: 'CostHandling',
            permission: 'Add cost basis',
            icon: 'glyphicon glyphicon-envelope',
            header: 'Supplier invoice',
            text: 'Invoice that you often receive after purchasing goods or services, which often have to be paid within a certain period of time, usually 30 days.'
        }, {
            click: addIncome,
            icon: 'glyphicon glyphicon-usd',
            header: 'Income',
            text: 'Compensation you receive after selling a product or service, or receiving a contribution.'
        }
    ];

}]);
